webpackJsonp([171],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConnectionManager_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0344b718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConnectionManager_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0344b718"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConnectionManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0344b718_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConnectionManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40eea423"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Base_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Crud_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e68dd226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Crud_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e68dd226"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Crud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e68dd226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Crud_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CrudBase_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1605c2fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CrudBase_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guide_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed0914d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guide_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ed0914d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed0914d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GooglePlaceInput_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0009dc76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GooglePlaceInput_vue__ = __webpack_require__(506);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GooglePlaceInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0009dc76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GooglePlaceInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateInput_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38aa080e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateInput_vue__ = __webpack_require__(512);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38aa080e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38aa080e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeInput_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b2ccd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeInput_vue__ = __webpack_require__(514);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12b2ccd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12b2ccd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEBUG */
/* unused harmony export APP_NAME */
/* unused harmony export GOOGLE_MAPS_KEY */
/* unused harmony export PRIMARY_COLOR */
/* unused harmony export ACCENT_COLOR */
/* unused harmony export REMOTE_URL */
/* unused harmony export LOCAL_URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_format_currency__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_format_currency___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_format_currency__);



var DEBUG = "production" !== 'production';
var APP_NAME = 'Cube Messenger';
var GOOGLE_MAPS_KEY = 'AIzaSyAH2H2l7eX0osBFtrzJ-WJeVmdf-FG7oUk';
var PRIMARY_COLOR = '#1A75BA';
var ACCENT_COLOR = '#FFC908';
// export const REMOTE_URL = 'http://35.184.187.70'
var REMOTE_URL = 'https://messenger.programminghelpers.com';
var LOCAL_URL = 'http://localhost:3000';

var App = {
  isDebug: DEBUG,
  url: REMOTE_URL,
  googleMapsKey: GOOGLE_MAPS_KEY,
  googleGeocodeUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  googleDirectionsUrl: 'https://maps.googleapis.com/maps/api/directions/json',
  log: function log(logData) {
    if (this.isDebug) {
      console.info(logData);
    }
  },
  imageUrl: function imageUrl(relativePath) {
    // return this.url + '/storage/' + relativePath
    return this.url + '/storage/app/public/' + relativePath;
  },
  fileUrl: function fileUrl(relativePath) {
    // return this.url + '/storage/' + relativePath
    return this.url + '/storage/app/public/' + relativePath;
  },
  dummyImage: function dummyImage() {
    return 'https://unsplash.it/150/300?image=' + (Math.floor(Math.random() * 100) + 1);
  },

  formatMoney: function formatMoney(val) {
    var opts = { format: '%s%v', symbol: 'KES ' };
    return __WEBPACK_IMPORTED_MODULE_1_format_currency___default()(Math.ceil(val), opts);
  },
  timeToMin: function timeToMin(val) {
    return Math.round(val / 60 * 100) / 100 + ' Min';
  },
  distanceToKm: function distanceToKm(val) {
    return Math.round(val / 1000 * 100) / 100 + ' Km';
  },
  capitalizeFirstLetter: function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  generateDocumentName: function generateDocumentName(string) {
    return string.replace(/\s/g, '_').toLowerCase();
  },

  primaryColor: PRIMARY_COLOR,
  accentColor: ACCENT_COLOR
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$app = App;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$appName = APP_NAME;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$actions = {
  addedDelivery: 'addedDelivery',
  addedSubscription: 'addedSubscription',
  collapsedDrawer: 'collapsedDrawer',
  clickedToolbarSideIcon: 'clickedToolbarSideIcon',
  clickedToolbarCartIcon: 'clickedToolbarCartIcon',
  placedOrder: 'placedOrder',
  requestedService: 'requestedService',
  addedAppointment: 'addedAppointment',
  approved: 'approved',
  rejected: 'rejected',
  signedIn: 'rejected'
};
/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
// Vue.axios.defaults.baseURL = App.url + '/api/v1'
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */].url + '/public/api/v1';
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.defaults.headers.common['Accept'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Add a request interceptor
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.info(`REQUEST INTERCEPTOR - CONFIG \n ${JSON.stringify(config)}`)
  return config;
}, function (error) {
  // Do something with request error
  // console.error(`REQUEST INTERCEPTOR - ERROR \n ${JSON.stringify(error)}`)
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Add a response interceptor
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].axios.interceptors.response.use(function (response) {
  // Do something with response data
  // let token = this.axios._getHeaders.call(this, response).Authorization
  // console.info(`RESPONSE INTERCEPTOR - TOKEN \n ${token}`)
  // console.info(`RESPONSE INTERCEPTOR - RESPONSE \n ${JSON.stringify(response.data)}`)
  return response;
}, function (error) {
  // Do something with response error
  // alert(error)
  // console.error(`RESPONSE INTERCEPTOR - ERROR \n`)
  if (error.response) {
    console.info(error.response.status);
    console.info(error.response.data);
    console.info(error.response.headers);
  } else if (error.request) {
    // console.info(`REQUEST: ${JSON.stringify(error.request)}`)
  } else {
      // console.info(`MESSAGE: ${JSON.stringify(error.message)}`)
    }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(relativePath, callback, params) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(relativePath, { params: params }).then(function (response) {
      callback(response.data.data);
    }).catch(function (error) {
      console.info(error);
    });
  }
});

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Toolbar__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Drawer__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Base__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  extends: __WEBPACK_IMPORTED_MODULE_4__components_Base__["a" /* default */],
  components: {
    Drawer: __WEBPACK_IMPORTED_MODULE_3__components_Drawer__["a" /* default */],
    Toolbar: __WEBPACK_IMPORTED_MODULE_1__components_Toolbar__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_0__components_Loader__["a" /* default */]
  },
  data: function data() {
    return {
      darkTheme: false,
      snackbarNotification: false,
      snackbarNotificationMessage: 'No message specified!'
    };
  },
  methods: {
    signOut: function signOut() {
      this.$auth.logout({
        success: function success() {
          this.$app.log('SignOut success');
          this.$vuetify.theme.primary = this.$app.primaryColor;
          this.$vuetify.theme.accent = this.$app.accentColor;
        },
        error: function error() {
          this.$app.log('SignOut failed');
        }
      });
    },
    contact: function contact() {
      this.$app.log(this.$route.name);
      this.$app.log(this.$route.name !== 'signIn');
      this.$app.log(this.$auth.check());
      this.$app.log(this.$auth.user().client);
      this.$app.log(this.$route.name !== 'signIn' && this.$auth.check() && !this.$auth.user().client);
      this.$app.log(this.$auth.user());
    }
  },
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* default */].$on('showSnackbarNotification', function (message, key) {
      that.snackbarNotificationKey = key;
      that.snackbarNotification = true;
      that.snackbarNotificationMessage = message;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* default */].$on('closeSnackbarNotification', function (key) {
      if (that.snackbarNotificationKey === key) {
        that.snackbarNotificationKey = null;
        that.snackbarNotification = false;
        that.snackbarNotificationMessage = null;
      }
    });
    __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* default */].$on('onThemeSwitch', function (val) {
      that.darkTheme = val;
    });
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loader'
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbar',
  extends: __WEBPACK_IMPORTED_MODULE_2__Base_vue__["a" /* default */],
  data: function data() {
    return {
      darkTheme: false,
      balance: 0
    };
  },

  watch: {
    darkTheme: function darkTheme(val) {
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit('onThemeSwitch', val);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    accountButtonColor: function accountButtonColor() {
      if (this.$auth.user().client.accountType === 'PRE_PAID') {
        return this.balance.actual > 200 || this.balance.actual === 0 ? 'primary' : 'error';
      } else {
        return this.balance.actual + this.$auth.user().client.limit > 200 || this.balance.actual === 0 ? 'primary' : 'error';
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    cartProductsCount: 'cartProductsTotal'
  })),
  methods: {
    signOut: function signOut() {
      this.$auth.logout({
        success: function success() {
          this.$notify({
            group: 'all',
            title: 'Signed out',
            text: 'You have signed out successfully!'
          });
        },
        error: function error() {
          console.log('SignOut failed');
        }
      });
    },
    onToolbarSideIconClick: function onToolbarSideIconClick() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit(this.$actions.clickedToolbarCartIcon);
    },
    refreshBalance: function refreshBalance() {
      var _this = this;

      this.$app.log('refreshBalance');
      this.balance = 0;
      if (this.$auth.check() && !this.isAdmin() && !this.isSupplier() && !this.isOperations()) {
        this.axios.get('balance').then(function (response) {
          _this.balance = response.data.data;
        });
      }
    },
    onToolbarCartIconClicked: function onToolbarCartIconClicked() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit(this.$actions.clickedToolbarCartIcon);
    }
  },
  mounted: function mounted() {
    var that = this;
    this.darkTheme = false;
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.addedDelivery, function () {
      that.refreshBalance();
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.placedOrder, function () {
      that.refreshBalance();
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.addedSubscription, function () {
      that.refreshBalance();
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.signedIn, function () {
      that.refreshBalance();
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.approved, function () {
      that.refreshBalance();
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.rejected, function () {
      that.refreshBalance();
    });
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.addedSubscription, function () {
      that.refreshBalance();
    });
    this.refreshBalance();
  }
});

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base',
  data: function data() {
    return {
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        phone: function phone(value) {
          return !!value && ('' + value).length === 10 || 'Phone number must be 10 characters';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      }
    };
  },

  methods: {
    isAdmin: function isAdmin() {
      return this.$auth.user().role.name === 'ADMIN';
    },
    isOperations: function isOperations() {
      return this.$auth.user().role.name === 'OPERATIONS';
    },
    isSupplier: function isSupplier() {
      return this.$auth.user().role.name === 'SUPPLIER';
    },
    isClientAdmin: function isClientAdmin() {
      return this.$auth.user().role.name === 'CLIENT_ADMIN';
    },
    isPurchasingHead: function isPurchasingHead() {
      return this.$auth.user().role.name === 'PURCHASING_HEAD';
    },
    isDepartmentHead: function isDepartmentHead() {
      return this.$auth.user().role.name === 'DEPARTMENT_HEAD';
    },
    isDepartmentUser: function isDepartmentUser() {
      return this.$auth.user().role.name === 'DEPARTMENT_USER';
    }
  },
  mounted: function mounted() {
    var that = this;
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit(that.$actions.collapsedDrawer);
    }, 1000);
  }
});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a106107.png";

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__Base_vue__["a" /* default */],
  name: 'drawer',
  data: function data() {
    return {
      drawerOpen: true,
      mini: false,
      items: [
        /* {icon: 'dashboard', title: 'Dashboard', route: 'dashboard', pendingApprovals: 0},
        {icon: 'schedule', title: 'Subscriptions', route: 'subscriptions', pendingApprovals: 0},
        {icon: 'date_range', title: 'Appointments', route: 'appointments', pendingApprovals: 0},
        {icon: 'folder', title: 'Documents', route: 'documents'},
        {icon: 'shopping_cart', title: 'Shopping', route: 'shopping', pendingApprovals: 0},
        {icon: 'shopping_basket', title: 'Orders', route: 'orders', pendingApprovals: 0},
        {icon: 'computer', title: 'IT Services', route: 'it', pendingApprovals: 0},
        {icon: 'build', title: 'Repair Services', route: 'repairs', pendingApprovals: 0},
        {icon: 'local_shipping', title: 'Courier', route: 'courier', pendingApprovals: 0},
        {icon: 'group', title: 'Users', route: 'users', pendingApprovals: 0},
        {icon: 'group_work', title: 'Departments', route: 'departments', pendingApprovals: 0},
        {icon: 'person', title: 'My Profile', route: 'profile', pendingApprovals: 0} */
      ]
    };
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      this.axios.get('drawerItems').then(function (response) {
        _this.$app.log(response);
        _this.items = [];
        _this.items = _this.items.concat(response.data.data);
      }).catch(function (error) {
        _this.$app.log(error);
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.clickedToolbarSideIcon, function () {
      that.mini = !that.mini;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.placedOrder, function () {
      that.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.addedDelivery, function () {
      that.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.addedAppointment, function () {
      that.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.requestedService, function () {
      that.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.approved, function () {
      that.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.rejected, function () {
      that.refresh();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$on(this.$actions.addedSubscription, function () {
      that.refresh();
    });
    this.refresh();
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeliveryItemQRDialog__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddDeliveryDialog__ = __webpack_require__(492);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  components: {
    AddDeliveryDialog: __WEBPACK_IMPORTED_MODULE_5__AddDeliveryDialog__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__["a" /* default */],
    DeliveryItemQRDialog: __WEBPACK_IMPORTED_MODULE_3__DeliveryItemQRDialog__["a" /* default */]
  },
  name: 'courier',
  data: function data() {
    return {
      addingDelivery: false,
      items: [],
      loading: false,
      trackingItem: null,
      printingItem: null,
      month: null,
      minMonth: null,
      viewDialogHere: false,
      maxMonth: null,
      rowsPerPageItems: [2, 4, 8],
      pagination: {
        rowsPerPage: 4
      },
      filter: null
    };
  },

  watch: {
    '$route': function $route(to, from) {
      // react to route changes...
      if (to.params.filter !== this.filter) {
        this.filter = to.params.filter;
      }
    },
    month: function month(_month) {
      if (_month && this.filter && !this.connecting) {
        this.refresh();
      }
    },
    filter: function filter(val) {
      if (this.month && val && !this.connecting) {
        this.refresh();
      }
    }
  },
  methods: {
    showApprovalActions: function showApprovalActions(item) {
      return this.filter === 'pendingApproval' && (this.isPurchasingHead() && item.status === 'AT_PURCHASING_HEAD' || this.isDepartmentHead() && item.status === 'AT_DEPARTMENT_HEAD');
    },
    showCancelActions: function showCancelActions(item) {
      return (this.filter === 'pendingPickup' || this.filter === 'inProgress') && (this.isPurchasingHead() && item.status === 'PENDING_DELIVERY' || this.isPurchasingHead() && item.status === 'BEING_DELIVERED' || this.isDepartmentHead() && item.status === 'PENDING_DELIVERY' || this.isDepartmentHead() && item.status === 'BEING_DELIVERED');
    },
    confirm: function confirm(delivery) {
      this.items = [];
      var that = this;
      this.$refs.connectionManager.patch('deliveries/' + delivery.id, {
        onSuccess: function onSuccess(response) {
          // that.items = []
          // that.items = that.items.concat(response.data.data)
          that.refresh();
          __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit(that.$actions.approved);
        }
      }, {
        action: 'approve'
      });
    },
    reject: function reject(delivery) {
      this.items = [];
      var that = this;
      this.$refs.connectionManager.patch('deliveries/' + delivery.id, {
        onSuccess: function onSuccess(response) {
          // that.items = []
          // that.items = that.items.concat(response.data.data)
          that.refresh();
          __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit(that.$actions.rejected);
        }
      }, {
        action: 'reject'
      });
    },
    cancelDelivery: function cancelDelivery(delivery) {
      this.items = [];
      var that = this;
      this.$refs.connectionManager.patch('deliveries/' + delivery.id, {
        onSuccess: function onSuccess(response) {
          // that.items = []
          // that.items = that.items.concat(response.data.data)
          that.refresh();
          __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$emit(that.$actions.rejected);
        }
      }, {
        action: 'cancel'
      });
    },
    onCloseAddingDelivery: function onCloseAddingDelivery(refresh) {
      this.addingDelivery = false;
      if (refresh) {
        this.refresh();
      }
    },
    refresh: function refresh() {
      var that = this;
      that.items = [];
      this.$refs.connectionManager.get('/deliveries', {
        onSuccess: function onSuccess(response) {
          that.items = [];
          that.items = that.items.concat(response.data.data);
        }
      }, {
        filter: this.filter,
        month: this.month
      });
    }
  },
  created: function created() {
    this.filter = this.$route.params.filter;
  },
  mounted: function mounted() {
    var dateClientJoined = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.$auth.user().client.createdAt);
    this.minMonth = dateClientJoined.year() + '-' + dateClientJoined.month();
    var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
    this.maxMonth = today.year() + '-' + (today.month() + 2);
    this.month = today.year() + '-' + today.month();
    this.filter = this.$route.params.filter;
    var that = this;
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on('refreshDeliveryHistoryList', function () {
      that.filter = this.$route.params.filter;
    });
  }
});

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_component__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2pdf_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2pdf_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { QRCode: __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_component__["a" /* default */] },
  name: 'delivery-item-q-r-dialog',
  props: {
    item: {
      required: true
    }
  },
  watch: {
    item: function item(_item) {
      if (_item) {
        this.dialog = true;
        this.itemData = {
          id: _item.id
        };
      } else {
        this.dialog = false;
        this.itemData = null;
      }
    }
  },
  data: function data() {
    return {
      dialog: false,
      itemData: null
    };
  },

  methods: {
    onClose: function onClose() {
      this.$emit('onClose');
    },
    printQR: function printQR() {
      // documentTitle
      var courierOptionName = this.item.quantity > 1 ? this.item.courierOption.pluralName : this.item.courierOption.name;
      var element = document.getElementById('qr-code');
      __WEBPACK_IMPORTED_MODULE_1_html2pdf_js___default()(element, {
        margin: 1,
        filename: this.item.quantity + ' ' + courierOptionName + ' to ' + this.item.destinationName + '.pdf',
        image: { type: 'jpeg', quality: 0.99 },
        html2canvas: { dpi: 320, letterRendering: true },
        jsPDF: { unit: 'cm', format: 'letter', orientation: 'portrait' }
      });

      var that = this;
      setTimeout(function () {
        that.onClose();
      }, 1000);

      /* printJS(
        {
          printable: 'qr-code',
          maxWidth: 400,
          showModal: true,
          type: 'html',
          header: this.item.quantity + ' ' + courierOptionName + ' to ' + this.item.destinationName,
          documentTitle: 'Client QR Code (NAME: ' + this.$auth.user().client.name + ', ID: ' + this.$auth.user().client.id + ')',
          onLoadingStart: () => {
            this.onClose()
          }
        }) */
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'connection-manager',
  data: function data() {
    return {
      connecting: false,
      error: false,
      errorText: null,
      dialog: false
    };
  },

  watch: {
    connecting: function connecting(val) {
      this.$app.log(val);
      this.$emit('input', this.connecting);
    }
  },
  methods: {
    reset: function reset() {
      this.connecting = false;
      this.error = false;
      this.errorText = null;
    },
    onFailure: function onFailure(error, callbacks) {
      this.error = true;
      this.connecting = false;
      if (callbacks && callbacks.onFailure) {
        callbacks.onFailure(error);
      }
      this.$app.log(error);
      if (error.response) {
        if (error.response.status === 422) {
          switch (error.response.data.meta.code) {
            case 'VALIDATION':
              this.errorText = error.response.data.data;
              break;
            default:
              this.errorText = error.response.data.meta.message;
          }
        } else if (error.response.data.message) {
          this.errorText = error.response.data.message;
        } else {
          this.errorText = error.response.data;
        }
      }
    },
    onSuccess: function onSuccess(response, callbacks) {
      this.connecting = false;
      this.error = false;
      this.errorText = null;
      this.$app.log(response);
      if (callbacks && callbacks.onSuccess) {
        callbacks.onSuccess(response);
      }
    },
    post: function post(relativePath, callbacks, body) {
      var _this = this;

      this.connecting = true;
      this.error = false;
      this.axios.post(relativePath, body).then(function (response) {
        _this.onSuccess(response, callbacks);
      }).catch(function (error) {
        _this.onFailure(error, callbacks);
      });
    },
    upload: function upload(relativePath, callbacks, formData) {
      var _this2 = this;

      this.connecting = true;
      this.error = false;
      this.axios.post(relativePath, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        _this2.onSuccess(response, callbacks);
      }).catch(function (error) {
        _this2.onFailure(error, callbacks);
      });
    },
    get: function get(relativePath, callbacks, params) {
      var _this3 = this;

      this.$app.log(relativePath);
      this.$app.log(params);
      this.connecting = true;
      this.error = false;
      this.axios.get(relativePath, { params: params }).then(function (response) {
        _this3.onSuccess(response, callbacks);
      }).catch(function (error) {
        _this3.onFailure(error, callbacks);
      });
    },
    patch: function patch(relativePath, callbacks, data) {
      var _this4 = this;

      this.$app.log(relativePath);
      this.$app.log(data);
      this.connecting = true;
      this.error = false;
      this.axios.patch(relativePath, data).then(function (response) {
        _this4.onSuccess(response, callbacks);
      }).catch(function (error) {
        _this4.onFailure(error, callbacks);
      });
    },
    delete: function _delete(relativePath, callbacks) {
      var _this5 = this;

      this.$app.log(relativePath);
      this.connecting = true;
      this.error = false;
      this.axios.delete(relativePath).then(function (response) {
        _this5.onSuccess(response, callbacks);
      }).catch(function (error) {
        _this5.onFailure(error, callbacks);
      });
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePlaceInput__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Guide__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddDeliveryItemDialog__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateInput__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TimeInput__ = __webpack_require__(74);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddDeliveryDialog',
  components: { TimeInput: __WEBPACK_IMPORTED_MODULE_8__TimeInput__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_7__DateInput__["a" /* default */], AddDeliveryItemDialog: __WEBPACK_IMPORTED_MODULE_5__AddDeliveryItemDialog__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__["a" /* default */], Guide: __WEBPACK_IMPORTED_MODULE_3__Guide__["a" /* default */], GooglePlaceInput: __WEBPACK_IMPORTED_MODULE_1__GooglePlaceInput__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      dialog: false,
      addingItem: false,
      connecting: false,
      step: 1,
      originInput: '',
      originName: null,
      originFormattedAddress: null,
      originVicinity: null,
      originPosition: null,
      items: [],
      courierOptions: [],
      costVariables: [],
      addressDetails: null,
      directionsService: new google.maps.DirectionsService(),
      calculatingDirections: false,
      scheduleDate: null,
      allowedDates: {
        dates: function dates(date) {
          // YYYY/MM/DD
          var givenDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date, 'YYYY/MM/DD');
          return __WEBPACK_IMPORTED_MODULE_6_moment___default()().diff(givenDate, 'days') <= 0;
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      },
      scheduleTime: null,
      allowedTimes: {
        hours: function hours(value) {
          return value >= __WEBPACK_IMPORTED_MODULE_6_moment___default()().hour();
        },
        minutes: function minutes(value) {
          return value % 15 === 0;
        }
      },
      urgent: false,
      itemWithLongestDistance: null,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      }
    };
  },

  computed: {
    estimatedCost: function estimatedCost() {
      if (this.items.length > 0) {
        var estimatedMaxDistance = 0;
        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          if (item.distance > estimatedMaxDistance) {
            estimatedMaxDistance = item.distance;
            this.itemWithLongestDistance = item;
          }
        }
        var timeCost = void 0;
        var distanceCost = void 0;
        var baseCost = void 0;
        if (this.urgent) {
          distanceCost = this.costVariables.URGENT_COST_PER_KM * (this.itemWithLongestDistance.distance / 1000);
          timeCost = this.costVariables.URGENT_COST_PER_MIN * (this.itemWithLongestDistance.duration / 60);
          baseCost = this.costVariables.URGENT_BASE_COST;
        } else {
          distanceCost = this.costVariables.NON_URGENT_COST_PER_KM * (this.itemWithLongestDistance.distance / 1000);
          timeCost = this.costVariables.NON_URGENT_COST_PER_MIN * (this.itemWithLongestDistance.duration / 60);
          baseCost = this.costVariables.NON_URGENT_BASE_COST;
        }

        var totalCost = baseCost + timeCost + distanceCost;
        var totalInclusiveProfitMargin = 1.6 * totalCost;
        var valueAddedTax = 0.16 * totalInclusiveProfitMargin;
        this.$app.log('valueAddedTax: ' + valueAddedTax);

        return totalInclusiveProfitMargin + valueAddedTax;
      }

      return 0;
    },

    invalidForm: function invalidForm() {
      return !this.addressDetails;
    }
  },
  watch: {
    show: function show(val) {
      this.dialog = !!val;
    }
  },
  methods: {
    onOriginEntered: function onOriginEntered(addressData, placeResultData) {
      this.originFormattedAddress = placeResultData.formatted_address;
      this.originVicinity = placeResultData.vicinity;
      this.originName = placeResultData.name;
      this.originPosition = {
        lat: placeResultData.geometry.location.lat(),
        lng: placeResultData.geometry.location.lng()
      };
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* default */].$emit('onOriginChanged', this.originPosition);
    },
    onClose: function onClose(successful) {
      this.step = 1;
      this.originPosition = null;
      this.originFormattedAddress = null;
      this.originVicinity = null;
      this.note = null;
      this.urgent = false;
      this.scheduleDate = null;
      this.scheduleTime = null;
      this.items = [];
      this.itemWithLongestDistance = null;
      this.addingItem = false;
      this.$refs.originInput.clear();
      this.$emit('onClose', successful);
    },
    onAddItem: function onAddItem(item) {
      this.addingItem = false;
      this.calculatingDirections = true;
      var that = this;
      this.directionsService.route({
        origin: this.originPosition.lat + ',' + this.originPosition.lng,
        destination: item.destinationPosition.lat + ',' + item.destinationPosition.lng,
        travelMode: 'DRIVING'
      }, function (result, status) {
        that.$app.log(result);
        if (status === 'OK') {
          var leg = result.routes[0].legs[0];
          item.distance = leg.distance.value;
          item.duration = leg.duration.value;
          that.items.push(item);
          that.calculatingDirections = false;
        } else {
          that.$app.log('Directions request failed due to ' + status);
        }
      });
    },
    deleteItem: function deleteItem(item) {
      var newItems = this.items.filter(function (it) {
        return it.destinationPosition.lat !== item.destinationPosition.lat;
      });
      this.items = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(newItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;

          this.items.push(i);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    submit: function submit() {
      this.error = false;
      var deliveryItems = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          deliveryItems.push({
            destinationName: item.destinationName,
            destinationVicinity: item.destinationVicinity,
            destinationFormattedAddress: item.destinationFormattedAddress,
            destinationLatitude: item.destinationPosition.lat,
            destinationLongitude: item.destinationPosition.lng,
            estimatedDistance: item.distance,
            estimatedDuration: item.duration,
            note: item.note,
            recipientContact: item.recipientContact,
            recipientName: item.recipientName,
            quantity: item.quantity,
            courierOptionId: item.courierOption.id
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var that = this;
      this.$refs.connectionManager.post('/deliveries', {
        onSuccess: function onSuccess(response) {
          that.onClose(true);
          __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* default */].$emit(that.$actions.addedDelivery);
          that.$app.log(response);
        }
      }, {
        urgent: this.urgent,
        originName: this.originName,
        originVicinity: this.originVicinity,
        originFormattedAddress: this.originFormattedAddress,
        originLatitude: this.originPosition.lat,
        originLongitude: this.originPosition.lng,
        scheduleDate: this.scheduleDate,
        scheduleTime: this.scheduleTime,
        estimatedCost: Math.ceil(this.estimatedCost),
        estimatedMaxDistance: this.itemWithLongestDistance.distance,
        estimatedMaxDuration: this.itemWithLongestDistance.duration,
        items: deliveryItems
      });
    },
    goStepTwo: function goStepTwo() {
      if (!this.courierOptions.length) {
        var that = this;
        // Load courier options
        this.$refs.connectionManager.get('/courierOptions', {
          onSuccess: function onSuccess(response) {
            that.$app.log(response.data.data);
            that.$app.log(response.data.variables);
            that.costVariables = response.data.costVariables;
            that.courierOptions = that.courierOptions.concat(response.data.data);
            that.step = 2;
          }
        }, { withCostVariables: true });
      } else {
        this.step = 2;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'google-place-input',

  props: {
    appendIcon: {
      type: String,
      default: null
    },
    otherDestination: {
      type: Boolean,
      default: false
    },

    autoGrow: {
      type: Boolean,
      default: false
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    box: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    },

    color: {
      type: String,
      default: 'primary'
    },

    counter: {
      type: [Boolean, Number],
      default: false
    },

    country: {
      type: [String, Array],
      default: null
    },

    classname: {
      type: String,
      default: ''
    },

    dark: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    dontFillMaskBlanks: {
      type: Boolean,
      default: false
    },

    enableGeolocation: {
      type: Boolean,
      default: false
    },

    error: {
      type: Boolean,
      default: false
    },

    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    fullWidth: {
      type: Boolean,
      default: false
    },

    hideDetails: {
      type: Boolean,
      default: true
    },

    hint: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      required: true
    },

    label: {
      type: String,
      default: ''
    },

    light: {
      type: Boolean,
      default: true
    },

    loading: {
      type: [Boolean, String],
      default: false
    },

    mask: {
      type: String,
      default: null
    },

    multiLine: {
      type: Boolean,
      default: false
    },

    persistentHint: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: ''
    },

    prefix: {
      type: String,
      default: ''
    },

    prependIcon: {
      type: String,
      default: null
    },

    readonly: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    courier: {
      type: Boolean,
      default: false
    },

    returnMaskedValue: {
      type: Boolean,
      default: false
    },

    rows: {
      type: Number,
      default: 5
    },

    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    singleLine: {
      type: Boolean,
      default: false
    },

    solo: {
      type: Boolean,
      default: false
    },

    suffix: {
      type: String,
      default: ''
    },

    tabindex: {
      type: Number,
      default: 0
    },

    textarea: {
      type: Boolean,
      default: false
    },

    toggleKeys: {
      type: Array,
      default: function _default() {
        return [13, 32];
      }
    },

    validateOnBlur: {
      type: Boolean,
      default: false
    },

    types: {
      type: String,
      default: 'address'
    }
  },

  data: function data() {
    return {
      /**
       * The Autocomplete object.
       *
       * @type {Autocomplete}
       * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
       */
      autocomplete: null,

      /**
       * Autocomplete input text
       * @type {String}
       */
      autocompleteText: ''
    };
  },

  watch: {
    autocompleteText: function autocompleteText(newVal, oldVal) {
      this.$emit('inputChange', { newVal: newVal, oldVal: oldVal });
    }
  },

  mounted: function mounted() {
    var _this = this;

    var options = {};

    if (this.types) {
      options.types = ['establishment', 'geocode'];
    }

    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }

    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);
    if (this.courier) {}
    // let geoLocation = {
    //   lat: -1.283115,
    //   lng: 36.823288
    // }
    //
    // let circle = new google.maps.Circle({
    //   center: geoLocation,
    //   radius: 50000
    // })
    // this.autocomplete.setBounds(circle.getBounds())
    // this.autocomplete.setOptions({strictBounds: true})


    // Override the default placeholder
    // text set by Google with the
    // placeholder prop value.
    document.getElementById(this.id).setAttribute('placeholder', this.placeholder);

    this.autocomplete.addListener('place_changed', function () {
      var place = _this.autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        _this.$emit('no-results-found', place);
        return;
      }

      var addressComponents = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
      };

      var returnData = {};

      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];

          if (addressComponents[addressType]) {
            var val = place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }

        returnData['latitude'] = place.geometry.location.lat();
        returnData['longitude'] = place.geometry.location.lng();
        _this.$app.log('Place entered ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(returnData));
        // return returnData object and PlaceResult object
        _this.$emit('placechanged', returnData, place, _this.otherDestination, _this.id);

        // update autocompleteText then emit change event
        _this.autocompleteText = place.name;
        _this.$app.log(place);
        _this.onChange();
      }
    });
  },

  methods: {
    /**
     * When the input gets focus
     */
    onFocus: function onFocus() {
      this.geolocate();
      this.$emit('focus');
    },


    /**
     * When the input loses focus
     */
    onBlur: function onBlur() {
      this.$emit('blur');
    },


    /**
     * When the input got changed
     */
    onChange: function onChange() {
      this.$emit('change', this.autocompleteText);
    },


    /**
     * When a key gets pressed
     * @param  {Event} event A keypress event
     */
    onKeyPress: function onKeyPress(event) {
      this.$emit('keypress', event);
    },


    /**
     * Clear the input
     */
    clear: function clear() {
      this.autocompleteText = '';
    },


    /**
     * Focus the input
     */
    focus: function focus() {
      this.$refs.autocomplete.focus();
    },


    /**
     * Blur the input
     */
    blur: function blur() {
      this.$refs.autocomplete.blur();
    },


    /**
     * Update the value of the input
     * @param  {String} value
     */
    update: function update(value) {
      this.autocompleteText = value;
    },


    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate: function geolocate() {
      // if (this.enableGeolocation) {
      //   if (navigator.geolocation) {
      //     navigator.geolocation.getCurrentPosition(position => {
      //       let geolocation = {
      //         lat: position.coords.latitude,
      //         lng: position.coords.longitude
      //       }
      //       let circle = new google.maps.Circle({
      //         center: geolocation,
      //         radius: position.coords.accuracy
      //       })
      //       this.autocomplete.setBounds(circle.getBounds())
      //     })
      //   }
      // }
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Guide',
  props: {
    text: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDeliveryItemDialog_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47069473_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDeliveryItemDialog_vue__ = __webpack_require__(510);
function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47069473"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDeliveryItemDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47069473_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDeliveryItemDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GooglePlaceInput__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Guide__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddDeliveryItemDialog',
  components: {
    Guide: __WEBPACK_IMPORTED_MODULE_4__Guide__["a" /* default */],
    GooglePlaceInput: __WEBPACK_IMPORTED_MODULE_3__GooglePlaceInput__["a" /* default */]
  },
  props: {
    courierOptions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    show: {
      type: Boolean,
      required: true
    },
    isAnEdit: {
      type: Boolean,
      required: false,
      default: false
      // selectedItem: {
      //   type: Object,
      //   default: function () {
      //     return {
      //       recipientContact: '',
      //       recipientName: '',
      //       note: '',
      //       quantity: null,
      //       courierOption: {},
      //       destinationFormattedAddress: '',
      //       destinationVicinity: '',
      //       destinationName: '',
      //       stops: {},
      //       destinationPosition: {
      //         lat: null,
      //         lng: null
      //       }
      //     }
      //   },
      //   required: false
      // }
    } },
  data: function data() {
    return {
      dialog: null,
      note: '',
      recipientContact: '',
      recipientName: '',
      quantity: 1,
      courierOption: null,
      addressData: null,
      placeResultData: null,
      addDestinationDisabled: true,
      max: 250,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        recipientContact: function recipientContact(value) {
          return !!value && ('' + value).length === 10 || 'Recipient contact must be 10 characters';
        },
        quantity: function (value) {
          return !!value && parseInt(value) >= 1 && parseInt(value) <= 100;
        } || 'Quantity cannot be less than 1 and greater than 100'
      },
      otherDestinations: []
    };
  },
  watch: {
    show: function show(val) {
      this.dialog = !!val;
    },
    selectedItem: function selectedItem(newItem, oldItem) {
      if (newItem) {}
    }
  },
  computed: {
    quantityHint: function quantityHint() {
      if (this.courierOption) {
        return 'Number of ' + this.courierOption.pluralName;
      } else {
        return 'Number of items';
      }
    },
    selectedItem: function selectedItem() {
      return this.getSelectedItem();
    },
    invalidForm: function invalidForm() {
      return !this.courierOption || !this.addressData || !this.placeResultData || ('' + this.recipientContact).length !== 10 || !this.recipientName || this.quantity < 1 || this.quantity > 100;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    getSelectedItem: 'getSelectedItem'
  }), {
    addNewDestination: function addNewDestination() {
      this.otherDestinations.push(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].util.extend({}, null));
      this.addDestinationDisabled = true;
    },
    removeOtherDestination: function removeOtherDestination(index) {
      this.otherDestinations.splice(index, 1);
      if (!this.otherDestinations[index]) {
        this.addDestinationDisabled = false;
      }
    },
    onDestinationEntered: function onDestinationEntered(addressData, placeResultData, otherDestination, id) {
      if (otherDestination) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.otherDestinations, id, placeResultData);
        this.addDestinationDisabled = false;
      } else {
        this.addressData = addressData;
        this.placeResultData = placeResultData;
        this.addDestinationDisabled = false;
      }
    },

    onAddItem: function onAddItem() {
      var stops = [];
      stops.push({
        stop_formatted_address: this.placeResultData.formatted_address,
        stop_vicinity: this.placeResultData.vicinity,
        stop_name: this.placeResultData.name,
        stop_latitude: this.placeResultData.geometry.location.lat(),
        stop_longitude: this.placeResultData.geometry.location.lng()
      });
      for (var i = 0; i < this.otherDestinations.length; i++) {
        if (this.otherDestinations[i]) {
          var _item = {
            stop_formatted_address: this.otherDestinations[i].formatted_address,
            stop_vicinity: this.otherDestinations[i].vicinity,
            stop_name: this.otherDestinations[i].name,
            stop_latitude: this.otherDestinations[i].geometry.location.lat(),
            stop_longitude: this.otherDestinations[i].geometry.location.lng()
          };
          stops.push(_item);
        }
      }
      var destination = stops[stops.length - 1];
      stops.splice(stops.length - 1, 1);
      var item = {
        recipientContact: this.recipientContact,
        recipientName: this.recipientName,
        note: this.note,
        quantity: this.quantity,
        courierOption: this.courierOption,
        destinationFormattedAddress: destination.stop_formatted_address,
        destinationVicinity: destination.stop_vicinity,
        destinationName: destination.stop_name,
        stops: stops,
        destinationPosition: {
          lat: destination.stop_latitude,
          lng: destination.stop_longitude
        }
      };
      this.$app.log('The item is: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      this.destinationInput = '';
      this.courierOption = null;
      this.note = null;
      this.recipientContact = null;
      this.recipientName = null;
      this.quantity = 1;
      this.addressData = null;
      this.placeResultData = null;
      this.otherDestinations = [];
      this.$refs.destinationInput.clear();
      this.$emit('onAddItem', item, this.isAnEdit);
    },
    close: function close() {
      this.destinationInput = '';
      this.courierOption = null;
      this.note = null;
      this.recipientContact = null;
      this.recipientName = null;
      this.quantity = 1;
      this.addressData = null;
      this.otherDestinations = [];
      this.placeResultData = null;
      this.$refs.destinationInput.clear();
      this.$emit('onClose');
    }
  }),
  mounted: function mounted() {}
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'date-input',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {},
    placeholder: {
      type: String,
      required: true
    },
    defaultValue: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    allowedDates: {
      type: Object,
      default: function _default() {
        return {
          callback: function callback(date) {
            // YYYY/MM/DD
            var givenDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'YYYY/MM/DD');
            return __WEBPACK_IMPORTED_MODULE_0_moment___default()().diff(givenDate, 'days') <= 0;
            // const [, , day] = date.split('-')
            // return parseInt(day, 10) % 2 === 0
          }
        };
      }
    }
  },
  data: function data() {
    return {
      menu: false,
      date: this.defaultValue
    };
  },

  methods: {
    onChange: function onChange(date) {
      this.$refs.menu.save(date);
      this.$emit('input', date);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-input',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {},
    placeholder: {
      type: String,
      required: true
    },
    defaultValue: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    allowedTimes: {
      type: Object,
      default: function _default() {
        return {
          hours: function hours(value) {
            return true;
          },
          minutes: function minutes(value) {
            return true;
          }
        };
      }
    }
  },
  data: function data() {
    return {
      menu: false,
      time: this.defaultValue
    };
  },

  methods: {
    onChange: function onChange(time) {
      this.$refs.menu.save(time);
      this.$emit('input', time);
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_range__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddAppointmentDialog__ = __webpack_require__(520);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var moment = Object(__WEBPACK_IMPORTED_MODULE_3_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_1_moment___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__Base_vue__["a" /* default */],
  components: {
    AddAppointmentDialog: __WEBPACK_IMPORTED_MODULE_5__AddAppointmentDialog__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__["a" /* default */]
  },
  name: 'appointments',
  data: function data() {
    return {
      date: null,
      addingAppointment: false,
      appointments: [],
      showAppointmentDialog: false,
      selectedAppointment: null,
      config: {
        defaultView: 'month'
      }
    };
  },

  watch: {
    date: function date(val) {
      this.refresh();
    }
  },
  methods: {
    onEventClicked: function onEventClicked(event) {
      this.$app.log(event);
      this.selectedAppointment = event;
      this.showAppointmentDialog = true;
    },
    refresh: function refresh() {
      this.appointments = [];
      var that = this;
      this.$refs.connectionManager.get('appointments/allAppointments', {
        onSuccess: function onSuccess(response) {
          that.appointments = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var appointment = _step.value;

              appointment.start = appointment.startingAt;
              appointment.end = appointment.endingAt;
              // appointment.active = false
              // that.appointmentDates.push(appointment.startingAt)
              that.appointments.push(appointment);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }, {
        date: this.date
      });
    },
    onCloseDialog: function onCloseDialog(addedAppointmentSuccessfully) {
      this.addingAppointment = false;
      this.$app.log('addedAppointmentSuccessfully: ' + addedAppointmentSuccessfully);
      if (addedAppointmentSuccessfully) {
        this.refresh();
      }
    }
  },
  computed: {
    cardHeight: function cardHeight() {
      return this.$vuetify.breakpoint.height * 0.75 + 'px';
    }
  },
  mounted: function mounted() {
    this.date = moment().format('YYYY-MM-DD');
    this.refresh();
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseDialog__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GooglePlaceInput__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DateInput__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimeInput__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_bus__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__BaseDialog__["a" /* default */],
  components: { TimeInput: __WEBPACK_IMPORTED_MODULE_6__TimeInput__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_5__DateInput__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_4__ConnectionManager__["a" /* default */], GooglePlaceInput: __WEBPACK_IMPORTED_MODULE_3__GooglePlaceInput__["a" /* default */], BaseDialog: __WEBPACK_IMPORTED_MODULE_2__BaseDialog__["a" /* default */] },
  name: 'AddAppointmentDialog',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      category: null,
      dialog: false,
      connecting: false,
      step: 0,
      venueType: null,
      venueTypes: [{
        text: 'On site i.e In office, boardroom or a room',
        value: 1
      }, {
        text: 'Off site i.e In a building or hotel',
        value: 2
      }],
      venue: null,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        contact: function contact(value) {
          return !!value && ('' + value).length === 10 || 'Contact contact must be 10 characters';
        }
      },
      addressData: null,
      placeResultData: null,
      title: null,
      internalParticipants: [],
      invalidatingAppointments: [],
      search: null,
      loadingUsers: false,
      users: [],
      externalParticipants: [],
      itemsToDiscuss: [],
      allDay: false,
      startDate: null,
      // Hold an array of startDate Errors
      startDateErrors: [],
      startTime: null,
      endDate: null,
      endTime: null,
      allowedStartDates: {
        dates: function dates(date) {
          // YYYY/MM/DD
          var givenDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(date);
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(givenDate, 'days') <= 0;
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      },
      currentTime: __WEBPACK_IMPORTED_MODULE_7_moment___default()().format('HH:mm'),
      roles: ['ADMIN', 'PURCHASING_HEAD', 'DEPARTMENT_HEAD', 'DEPARTMENT_USER']
    };
  },

  watch: {
    show: function show(val) {
      this.dialog = !!val;
    },
    step: function step(val) {
      if (val === 2) {
        this.queryUsers('');
      }
    },
    category: function category(val) {
      this.$app.log(val);
      val && this.queryUsers(val);
    },
    venueType: function venueType(val) {
      this.venue = null;
    },
    search: function search(val) {
      val && this.queryUsers(val);
    },
    startDate: function startDate(val) {
      this.$refs.endDate.onChange(null);
    },
    startTime: function startTime(val) {
      this.$refs.endTime.onChange(null);
    },
    invalidatingAppointments: function invalidatingAppointments(val) {
      this.$app.log(val);
    }
  },
  computed: {
    allowedStartTimes: function allowedStartTimes() {
      return {
        hours: function hours(value) {
          // return value >= moment().hour()
          return true;
        },
        minutes: function minutes(value) {
          // return value >= moment().minute()
          return true;
        }
      };
    },
    allowedEndDates: function allowedEndDates() {
      var that = this;
      return {
        dates: function dates(date) {
          // YYYY/MM/DD
          return __WEBPACK_IMPORTED_MODULE_7_moment___default()(__WEBPACK_IMPORTED_MODULE_7_moment___default()(date)).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_7_moment___default()(that.startDate, 'YYYY-MM-DD'));
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      };
    },
    allowedEndTimes: function allowedEndTimes() {
      return {
        hours: function hours(value) {
          return true;
          // return true
        },
        minutes: function minutes(value) {
          // return value > moment(that.startTime, 'HH:mm:ss').minute()
          return true;
        }
      };
    },
    filteredUsers: function filteredUsers() {
      var _this = this;

      if (this.search) {
        return this.users.filter(function (participant) {
          return _this.name.includes(_this.search);
        });
      } else {
        return this.users;
      }
    },
    invalidSchedule: function invalidSchedule() {
      if (!this.startDate || !this.endDate) {
        return true;
      } else {
        return false;
      }
    },
    invalidDate: function invalidDate() {
      if (this.startDate && this.endDate) {
        var beginningDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.startDate, 'YYYY-MM-DD');
        var endDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.endDate, 'YYYY-MM-DD');
        return endDate.isBefore(beginningDate);
      } else {
        return false;
      }
    },
    invalidTime: function invalidTime() {
      if (this.startTime && this.endTime && !this.allDay) {
        var beginningTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.startTime, 'HH:mm');
        var endTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.endTime, 'HH:mm');
        return endTime.isBefore(beginningTime);
      } else {
        return false;
      }
    },
    invalidInternalParticipants: function invalidInternalParticipants() {
      if (this.startDate && (this.startTime || this.allDay) && this.endDate && (this.endTime || this.allDay)) {
        // Find invalid selected internal participants based on dates
        var that = this;
        this.invalidatingAppointments = [];
        return this.internalParticipants.filter(function (participant) {
          // Check if participant has a meeting in the selected duration
          // Find all appointments with a startingAt and endingAt within the selection
          var appointments = participant.appointments.filter(function (appointment) {
            that.$app.log(appointment);

            var startDateIsInThisAppointment = __WEBPACK_IMPORTED_MODULE_7_moment___default()(that.startDate, 'YYYY-MM-DD').isBetween(__WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.startingAt, 'YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.endingAt, 'YYYY-MM-DD'), null, '[]');

            var endDateIsInThisAppointment = __WEBPACK_IMPORTED_MODULE_7_moment___default()(that.endDate, 'YYYY-MM-DD').isBetween(__WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.startingAt, 'YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.endingAt, 'YYYY-MM-DD'), null, '[]');

            if (that.allDay) {
              // Check selected startDate and endDate are within
              return startDateIsInThisAppointment || endDateIsInThisAppointment;
            } else if (startDateIsInThisAppointment || endDateIsInThisAppointment) {
              // If selected startDate or endDate are within this appointment
              // Check if selected times are within

              var appointmentStartingAtHour = __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.startingAt).hour();
              that.$app.log('appointmentStartingAtHour = ' + appointmentStartingAtHour);
              var appointmentStartingAtMin = __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.startingAt).minute();
              that.$app.log('appointmentStartingAtMin = ' + appointmentStartingAtMin);

              var appointmentEndingAtHour = __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.endingAt).hour();
              that.$app.log('appointmentEndingAtHour = ' + appointmentEndingAtHour);
              var appointmentEndingAtMin = __WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.endingAt).minute();
              that.$app.log('appointmentEndingAtMin = ' + appointmentEndingAtMin);

              var selectedStartingAtHour = __WEBPACK_IMPORTED_MODULE_7_moment___default()(that.startTime, 'HH:mm:ss').hour();
              that.$app.log('selectedStartingAtHour = ' + selectedStartingAtHour);
              var selectedStartingAtMin = __WEBPACK_IMPORTED_MODULE_7_moment___default()(that.startTime, 'HH:mm:ss').minute();
              that.$app.log('selectedStartingAtMin = ' + selectedStartingAtMin);

              var selectedEndingAtHour = __WEBPACK_IMPORTED_MODULE_7_moment___default()(that.endTime, 'HH:mm:ss').hour();
              that.$app.log('selectedEndingAtHour = ' + selectedEndingAtHour);
              var selectedEndingAtMin = __WEBPACK_IMPORTED_MODULE_7_moment___default()(that.endTime, 'HH:mm:ss').minute();
              that.$app.log('selectedEndingAtMin = ' + selectedEndingAtMin);

              var startTimeIsInThisAppointment = __WEBPACK_IMPORTED_MODULE_7_moment___default()().hour(selectedStartingAtHour).minute(selectedStartingAtMin).isBetween(__WEBPACK_IMPORTED_MODULE_7_moment___default()().hour(appointmentStartingAtHour).minute(appointmentStartingAtMin), __WEBPACK_IMPORTED_MODULE_7_moment___default()().hour(appointmentEndingAtHour).minute(appointmentEndingAtMin), null, '[]');
              var endTimeIsInThisAppointment = __WEBPACK_IMPORTED_MODULE_7_moment___default()().hour(selectedEndingAtHour).minute(selectedEndingAtMin).isBetween(__WEBPACK_IMPORTED_MODULE_7_moment___default()().hour(appointmentStartingAtHour).minute(appointmentStartingAtMin), __WEBPACK_IMPORTED_MODULE_7_moment___default()().hour(appointmentEndingAtHour).minute(appointmentEndingAtMin), null, '[]');
              return startTimeIsInThisAppointment || endTimeIsInThisAppointment;
            } else {
              return false;
            }
          });

          that.invalidatingAppointments = that.invalidatingAppointments.concat({
            participant: participant,
            appointments: appointments
          });
          // The participant is invalid if has an appointment on the selected startDate
          return appointments.length > 0;
        });
      } else {
        return [];
      }
    },
    maxWidth: function maxWidth() {
      return this.$vuetify.breakpoint.width * 0.60 + 'px';
    },
    externalParticipantsValidate: function externalParticipantsValidate() {
      var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      var validParticipants = 0;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.externalParticipants), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var participant = _step.value;

          if (participant.name) {
            participant.errors.name = [];
          } else {
            participant.errors.name = ['Enter a valid name'];
          }

          if (participant.email && pattern.test(participant.email)) {
            participant.errors.email = [];
          } else {
            participant.errors.email = ['Enter a valid email address'];
          }

          if (participant.phone && ('' + participant.phone).length === 10) {
            participant.errors.phone = [];
          } else {
            participant.errors.phone = ['Enter a valid phone number'];
          }

          if (participant.email && pattern.test(participant.email) && ('' + participant.phone).length === 10) {
            validParticipants++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return validParticipants === this.externalParticipants.length;
    },
    itemsToDiscussValidate: function itemsToDiscussValidate() {
      var validItems = 0;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.itemsToDiscuss), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var itemToDiscuss = _step2.value;

          if (!itemToDiscuss.text) {
            itemToDiscuss.error = ['This field can not be empty'];
          } else {
            itemToDiscuss.error = [];
            validItems++;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return validItems === this.itemsToDiscuss.length;
    }
  },
  methods: {
    queryUsers: function queryUsers(val) {
      var _this2 = this;

      this.loadingUsers = true;
      this.axios.get('appointments/allUserSuggestions', {
        params: {
          search: val
        }
      }).then(function (response) {
        console.log('Response returned' + response.data.data.role);
        _this2.users = [];
        _this2.users = _this2.users.concat(response.data.data);
        _this2.loadingUsers = false;
      }).catch(function (error) {
        _this2.loadingUsers = false;
        _this2.$app.log(error);
      });
    },
    onCancel: function onCancel(successful) {
      // this.step = 2
      // this.title = null
      // this.startDate = null
      // this.startTime = null
      // this.endDate = null
      // this.endTime = null
      // this.allDay = false
      // this.internalParticipants = []
      // this.externalParticipants = []
      // this.itemsToDiscuss = []
      // this.addressData = null
      // this.placeResultData = null
      // // this.category = null
      // // this.venue = null
      // this.placeResultData = null
      // this.invalidatingAppointments = []
      // this.search = null
      // this.loadingUsers = false
      // // Hold an array of startDate Errors
      // this.startDateErrors = []
      // this.venueType = null
      // this.dialog = false
      this.$emit('onClose', successful);
    },
    onLocationEntered: function onLocationEntered(addressData, placeResultData) {
      this.addressData = addressData;
      this.placeResultData = placeResultData;
      this.venue = placeResultData.formatted_address;
    },
    removeExternalParticipant: function removeExternalParticipant(participant) {
      this.externalParticipants.splice(this.externalParticipants.indexOf(participant), 1);
      this.externalParticipants = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.externalParticipants));
    },
    addExternalParticipant: function addExternalParticipant() {
      this.externalParticipants.push({
        email: null,
        phone: null,
        name: null,
        errors: {
          email: [],
          phone: [],
          name: []
        }
      });
    },
    removeItemToDiscuss: function removeItemToDiscuss(itemToDiscuss) {
      this.itemsToDiscuss.splice(this.itemsToDiscuss.indexOf(itemToDiscuss), 1);
      this.itemsToDiscuss = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemsToDiscuss));
    },
    addItemToDiscuss: function addItemToDiscuss() {
      this.itemsToDiscuss.push({
        error: [],
        text: null
      });
    },
    submit: function submit() {
      var appointment = {
        venue: this.venue,
        title: this.title,
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        allDay: this.allDay,
        internalParticipants: [],
        externalParticipants: [],
        itemsToDiscuss: []
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.itemsToDiscuss), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var itemToDiscuss = _step3.value;

          appointment.itemsToDiscuss.push(itemToDiscuss.text);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.internalParticipants), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var participant = _step4.value;

          appointment.internalParticipants.push(participant.id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.externalParticipants), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _participant = _step5.value;

          appointment.externalParticipants.push({
            email: _participant.email,
            phone: _participant.phone,
            name: _participant.name
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.$app.log(appointment);
      var that = this;
      this.$refs.connectionManager.post('appointments', {
        onSuccess: function onSuccess(response) {
          that.onCancel(true);
          __WEBPACK_IMPORTED_MODULE_8__event_bus__["a" /* default */].$emit(that.$actions.addedAppointment);
        }
      }, appointment);
    }
  },
  mounted: function mounted() {
    // var offset = new Date().getTimezoneOffset()
    var appointmentStartingAt = __WEBPACK_IMPORTED_MODULE_7_moment___default()('2018-04-20 14:00:00');
    var selectedStartingAt = __WEBPACK_IMPORTED_MODULE_7_moment___default()('14:00', 'HH:mm');
    this.$app.log('appointmentStartingAt Hour ' + appointmentStartingAt.hour());
    this.$app.log('selectedStartingAt Hour ' + selectedStartingAt.hour());
  }
});

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__Base__["a" /* default */],
  components: { Base: __WEBPACK_IMPORTED_MODULE_0__Base__["a" /* default */] },
  name: 'BaseDialog',
  computed: {}
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddSubscriptionDialog__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__Base_vue__["a" /* default */],
  components: {
    AddSubscriptionDialog: __WEBPACK_IMPORTED_MODULE_3__AddSubscriptionDialog__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */]
  },
  name: 'subscriptions',
  data: function data() {
    return {
      showAddSubscriptionDialog: false,
      connecting: false,
      filter: null,
      items: [],
      headers: [{ text: 'Item', sortable: false, value: 'optionItem.name' }, { text: 'Weekdays', sortable: false, value: 'weekdays' }, { text: 'Quantity', sortable: false, value: 'quantity' }, { text: 'Item Cost', sortable: false, value: 'item_cost' }, { text: 'Delivery Cost', sortable: false, value: 'deliveryCost' }, { text: 'Total Cost', sortable: false, value: 'amount' }, { text: 'Duration', sortable: false, value: '' }, { text: 'Action', sortable: false, value: '' }]

    };
  },

  watch: {
    '$route': function $route(to, from) {
      // react to route changes...
      if (to.params.filter !== this.filter) {
        this.filter = to.params.filter;
      }
    },
    filter: function filter(val) {
      if (val) {
        this.refresh();
      }
    }
  },
  methods: {
    showApprovalActions: function showApprovalActions(item) {
      return this.filter === 'pendingApproval' && (this.isPurchasingHead() && item.status === 'AT_PURCHASING_HEAD' || this.isDepartmentHead() && item.status === 'AT_DEPARTMENT_HEAD');
    },
    confirm: function confirm(item) {
      this.items = [];
      var that = this;
      this.$refs.connectionManager.patch('subscriptions/' + item.id, {
        onSuccess: function onSuccess(response) {
          that.items = [];
          that.items = that.items.concat(response.data.data);
          __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* default */].$emit(that.$actions.approved);
        }
      }, {
        action: 'approve'
      });
    },
    reject: function reject(item) {
      this.items = [];
      var that = this;
      this.$refs.connectionManager.patch('subscriptions/' + item.id, {
        onSuccess: function onSuccess(response) {
          that.items = [];
          that.items = that.items.concat(response.data.data);
          __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* default */].$emit(that.$actions.approved);
        }
      }, {
        action: 'reject'
      });
    },
    transformWeekdays: function transformWeekdays(weekdays) {
      var weekdayNumbers = weekdays.split('#');
      var weekdayNames = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(weekdayNumbers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var weekdayNumber = _step.value;

          weekdayNames.push(__WEBPACK_IMPORTED_MODULE_4_moment___default()().weekday(weekdayNumber).format('dddd'));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return weekdayNames.join(',');
    },
    onCloseAddSubscriptionDialog: function onCloseAddSubscriptionDialog(val) {
      this.showAddSubscriptionDialog = false;
      if (val) {
        if (this.filter !== 'pendingApproval') {
          this.filter = 'pendingApproval';
        } else {
          this.refresh();
        }
      }
    },
    refresh: function refresh() {
      var that = this;
      that.items = [];
      this.$refs.connectionManager.get('subscriptions', {
        onSuccess: function onSuccess(response) {
          that.items = [];
          that.items = that.items.concat(response.data.data);
        }
      }, { filter: this.filter });
    }
  },
  created: function created() {
    this.filter = this.$route.params.filter;
  }
  // mounted () {
  // this.filter = 'active'
  // }

});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSubscriptionDialog_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd591de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSubscriptionDialog_vue__ = __webpack_require__(533);
function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cd591de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSubscriptionDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd591de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSubscriptionDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddSubscriptionDialog',
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      showSubscriptionPeriodGuide: false,
      connecting: false,
      showSelectTerminationDateDialog: false,
      dialog: false,
      step: 1,
      options: [],
      option: null,
      optionId: null,
      selectedOptionItem: null,
      weekdays: [],
      quantity: null,
      terminationDate: null,
      renewEveryMonth: true,
      oneTimeSubscription: false,
      daysToDeliver: 0,
      renewal: 'renew_every_month',
      allowedTimes: {
        hours: function hours(value) {
          return value >= __WEBPACK_IMPORTED_MODULE_2_moment___default()().hour();
        },
        minutes: function minutes(value) {
          return value % 15 === 0;
        },
        dates: function dates(date) {
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()().hour() >= 16) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
          }
          // YYYY/MM/DD
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      }
    };
  },

  watch: {
    show: function show(val) {
      this.dialog = !!val;
      if (val && this.options.length === 0) {
        var that = this;
        setTimeout(function () {
          that.loadSubscriptionOptions();
        }, 300);
      }
    },
    optionId: function optionId(val) {
      if (val) {
        this.option = this.options.find(function (element) {
          return element.id === val;
        });
        this.selectedOptionItem = null;
      }
    },
    renewal: function renewal(val) {
      if (val === 'renew_every_month') {
        this.renewEveryMonth = true;
        this.showSubscriptionPeriodGuide = true;
        this.showSubscriptionPeriodGuide = false;
        this.updateDays();
      } else {}
    },
    showSubscriptionPeriodGuide: function showSubscriptionPeriodGuide(val) {
      if (val) {
        var that = this;
        setTimeout(function () {
          that.showSubscriptionPeriodGuide = false;
        }, 5000);
      }
    },
    step: function step(val) {
      if (val === 4) {
        this.updateDays();
        this.showSubscriptionPeriodGuide = true;
      }
      if (val === 3) {}
    },
    renewEveryMonth: function renewEveryMonth(val) {
      this.showSubscriptionPeriodGuide = true;
      this.updateDays();
    },
    terminationDate: function terminationDate(val) {
      if (val) {
        this.showSelectTerminationDateDialog = false;
        this.renewEveryMonth = false;
        this.showSubscriptionPeriodGuide = true;
        this.updateDays();
      }
    }
  },
  computed: {
    renewEveryMonthHint: function renewEveryMonthHint() {
      return this.renewEveryMonth ? 'Un check "Renew every month" to specify a date to terminate this subscription' : 'Check "Renew every month" to renew this subscription every month';
    },
    allowedSubscriptionDates: function allowedSubscriptionDates() {
      return {
        dates: function dates(date) {
          // YYYY/MM/DD
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      };
    },
    costsDescription: function costsDescription() {
      return 'Above are costs ' + (this.renewEveryMonth ? ' for this month' : ' between now and ' + this.terminationDate) + ' (' + this.daysToDeliver + ' days)';
    },
    selectedWeekdays: function selectedWeekdays() {
      var selected = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.weekdays), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var schedule = _step.value;

          if (schedule.selected) {
            selected++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return selected;
    },
    costs: function costs() {
      if (this.step === 4) {
        this.daysToDeliver = 0;

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.weekdays), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var weekday = _step2.value;

            if (weekday.selected) {
              this.daysToDeliver += weekday.days;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.$app.log(this.daysToDeliver);
        if (this.renewEveryMonth) {
          return {
            item: this.selectedOptionItem.price * this.quantity * this.daysToDeliver,
            // delivery: this.option.deliveryCost * this.quantity * this.daysToDeliver
            delivery: this.option.deliveryCost * 0
          };
        } else {
          return {
            item: this.selectedOptionItem.price * this.quantity,
            // delivery: this.option.deliveryCost * this.quantity * this.daysToDeliver
            delivery: this.option.deliveryCost * 0
          };
        }
      } else {
        return {
          item: 0,
          delivery: 0
        };
      }
    }
  },
  methods: {
    onClose: function onClose(val) {
      this.step = 1;
      this.optionId = null;
      this.option = null;
      this.selectedOptionItem = null;
      this.terminationDate = null;
      this.renewEveryMonth = true;
      this.quantity = null;
      this.options = [];
      for (var i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].selected = false;
      }
      this.$emit('onClose', val);
    },
    allowedDates: function allowedDates(date) {
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()().hour() >= 16) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days'));
      } else {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
      }
    },
    resetDays: function resetDays() {
      // Initialize days of weekdays in the subscribed period
      for (var i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].days = 0;
      }
    },
    updateDays: function updateDays() {
      this.resetDays();

      if (this.renewEveryMonth) {
        // Date today
        var currentDayOfThisMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.systemVariables.date).date();
        this.$app.log('currentDayOfThisMonth = ' + currentDayOfThisMonth);

        // Date of the last day of this month
        var lastDayOfThisMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.systemVariables.date).endOf('month').date();
        this.$app.log('lastDayOfThisMonth = ' + lastDayOfThisMonth);

        // Add one to #currentDayOfThisMonth so as not to include today
        for (var i = currentDayOfThisMonth + 1; i <= lastDayOfThisMonth; i++) {
          // Weekday number of the date
          var weekdayNumber = __WEBPACK_IMPORTED_MODULE_2_moment___default()().date(i).weekday();
          // Updates number of days of the weekday number in the current month
          this.updateWeekdayDays(weekdayNumber);
        }
      } else if (this.terminationDate) {
        // Calculate days to deliver until the termination date

        var terminationDayOfYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.terminationDate).dayOfYear();
        // Weekday number of the day of year
        var _weekdayNumber = __WEBPACK_IMPORTED_MODULE_2_moment___default()().dayOfYear(terminationDayOfYear).weekday();
        // select the weekday and set the days count to one
        for (var _i = 0; _i < this.weekdays.length; _i++) {
          var weekday = this.weekdays[_i];
          if (weekday.number === _weekdayNumber) {
            this.weekdays[_i].selected = true;
            this.weekdays[_i].days = 1;
            break;
          }
        }

        // Add one to #currentDayOfYear so as not to include today
        // for (let i = (currentDayOfYear + 1); i <= terminationDayOfYear; i++) {
        // Weekday number of the day of year
        // let weekdayNumber = moment().dayOfYear(i).weekday()
        // Updates number of days of the weekday number in the current month
        // this.updateWeekdayDays(weekdayNumber)
        // }
      }
    },
    updateWeekdayDays: function updateWeekdayDays(weekdayNumber) {
      // Check if weekday number is selected, if selected update days of that weekday in the subscription period
      for (var i = 0; i < this.weekdays.length; i++) {
        var weekday = this.weekdays[i];
        if (weekday.number === weekdayNumber && weekday.selected) {
          this.weekdays[i].days++;
          break;
        }
      }
    },
    submit: function submit() {
      var selectedWeekdayNumbers = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.weekdays), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var weekday = _step3.value;

          if (weekday.selected) {
            selectedWeekdayNumbers.push(weekday.number);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var subscription = {
        renewEveryMonth: this.renewEveryMonth,
        terminationDate: this.terminationDate,
        weekdays: selectedWeekdayNumbers.join('#'),
        quantity: this.quantity,
        deliveryCost: this.costs.delivery,
        itemCost: this.costs.item,
        optionItemId: this.selectedOptionItem.id,
        optionId: this.optionId
      };
      var that = this;

      this.$refs.connectionManager.post('subscriptions', {
        onSuccess: function onSuccess(response) {
          __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* default */].$emit(that.$actions.addedSubscription);
          that.onClose(true);
        }
      }, subscription);
    },
    loadSubscriptionOptions: function loadSubscriptionOptions() {
      var that = this;
      this.$refs.connectionManager.get('subscriptionOptions', {
        onSuccess: function onSuccess(response) {
          that.options = [];
          that.options = that.options.concat(response.data.data);
          that.systemVariables = response.data.systemVariables;
          that.weekdays = [];
          that.weekdays.push({ name: 'Monday', number: 1, days: 0 });
          that.weekdays.push({ name: 'Tuesday', number: 2, days: 0 });
          that.weekdays.push({ name: 'Wednesday', number: 3, days: 0 });
          that.weekdays.push({ name: 'Thursday', number: 4, days: 0 });
          that.weekdays.push({ name: 'Friday', number: 5, days: 0 });
          that.weekdays.push({ name: 'Saturday', number: 6, days: 0 });
          that.weekdays.push({ name: 'Sunday', number: 0, days: 0 });
        }
      }, { withSystemVariables: true });
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddSubscription',
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      showSubscriptionPeriodGuide: false,
      connecting: false,
      showSelectTerminationDateDialog: false,
      step: 1,
      options: [],
      option: null,
      optionId: null,
      selectedOptionItem: null,
      weekdays: [],
      quantity: null,
      terminationDate: null,
      renewEveryMonth: true,
      oneTimeSubscription: false,
      daysToDeliver: 0,
      renewal: 'renew_every_month',
      allowedTimes: {
        hours: function hours(value) {
          return value >= __WEBPACK_IMPORTED_MODULE_2_moment___default()().hour();
        },
        minutes: function minutes(value) {
          return value % 15 === 0;
        },
        dates: function dates(date) {
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()().hour() >= 16) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
          }
          // YYYY/MM/DD
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      }
    };
  },

  watch: {
    optionId: function optionId(val) {
      if (val) {
        this.option = this.options.find(function (element) {
          return element.id === val;
        });
        this.selectedOptionItem = null;
      }
    },
    renewal: function renewal(val) {
      if (val === 'renew_every_month') {
        this.renewEveryMonth = true;
        this.showSubscriptionPeriodGuide = true;
        this.showSubscriptionPeriodGuide = false;
        this.updateDays();
      } else {
        this.renewEveryMonth = false;
        this.showSubscriptionPeriodGuide = false;
        this.showSubscriptionPeriodGuide = false;
        this.updateDays();
      }
    },
    showSubscriptionPeriodGuide: function showSubscriptionPeriodGuide(val) {
      if (val) {
        var that = this;
        setTimeout(function () {
          that.showSubscriptionPeriodGuide = false;
        }, 5000);
      }
    },
    step: function step(val) {
      if (val === 4) {
        this.updateDays();
        this.showSubscriptionPeriodGuide = true;
      }
      if (val === 3) {}
    },
    renewEveryMonth: function renewEveryMonth(val) {
      this.showSubscriptionPeriodGuide = true;
      this.updateDays();
    },
    terminationDate: function terminationDate(val) {
      if (val) {
        this.showSelectTerminationDateDialog = false;
        this.renewEveryMonth = false;
        this.showSubscriptionPeriodGuide = true;
        this.updateDays();
      }
    }
  },
  computed: {
    renewEveryMonthHint: function renewEveryMonthHint() {
      return this.renewEveryMonth ? 'Un check "Renew every month" to specify a date to terminate this subscription' : 'Check "Renew every month" to renew this subscription every month';
    },
    allowedSubscriptionDates: function allowedSubscriptionDates() {
      return {
        dates: function dates(date) {
          // YYYY/MM/DD
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
          // const [, , day] = date.split('-')
          // return parseInt(day, 10) % 2 === 0
        }
      };
    },
    costsDescription: function costsDescription() {
      return 'Above are costs ' + (this.renewEveryMonth ? ' for this month' : ' between now and ' + this.terminationDate) + ' (' + this.daysToDeliver + ' days)';
    },
    selectedWeekdays: function selectedWeekdays() {
      var selected = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.weekdays), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var schedule = _step.value;

          if (schedule.selected) {
            selected++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return selected;
    },
    costs: function costs() {
      if (this.step === 4) {
        this.daysToDeliver = 0;

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.weekdays), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var weekday = _step2.value;

            if (weekday.selected) {
              this.daysToDeliver += weekday.days;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.$app.log(this.daysToDeliver);
        if (this.renewEveryMonth) {
          return {
            item: this.selectedOptionItem.price * this.quantity * this.daysToDeliver,
            // delivery: this.option.deliveryCost * this.quantity * this.daysToDeliver
            delivery: this.option.deliveryCost * 0
          };
        } else {
          return {
            item: this.selectedOptionItem.price * this.quantity,
            // delivery: this.option.deliveryCost * this.quantity * this.daysToDeliver
            delivery: this.option.deliveryCost * 0
          };
        }
      } else {
        return {
          item: 0,
          delivery: 0
        };
      }
    }
  },
  methods: {
    onClose: function onClose(val) {
      this.step = 1;
      this.optionId = null;
      this.option = null;
      this.selectedOptionItem = null;
      this.terminationDate = null;
      this.renewEveryMonth = true;
      this.quantity = null;
      this.options = [];
      for (var i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].selected = false;
      }
      this.$emit('onClose', val);
    },
    allowedDates: function allowedDates(date) {
      if (__WEBPACK_IMPORTED_MODULE_2_moment___default()().hour() >= 16) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days'));
      } else {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date)).isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()());
      }
    },
    resetDays: function resetDays() {
      // Initialize days of weekdays in the subscribed period
      for (var i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].days = 0;
      }
    },
    updateDays: function updateDays() {
      this.resetDays();

      if (this.renewEveryMonth) {
        // Date today
        var currentDayOfThisMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.systemVariables.date).date();
        this.$app.log('currentDayOfThisMonth = ' + currentDayOfThisMonth);

        // Date of the last day of this month
        var lastDayOfThisMonth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.systemVariables.date).endOf('month').date();
        this.$app.log('lastDayOfThisMonth = ' + lastDayOfThisMonth);

        // Add one to #currentDayOfThisMonth so as not to include today
        for (var i = currentDayOfThisMonth + 1; i <= lastDayOfThisMonth; i++) {
          // Weekday number of the date
          var weekdayNumber = __WEBPACK_IMPORTED_MODULE_2_moment___default()().date(i).weekday();
          // Updates number of days of the weekday number in the current month
          this.updateWeekdayDays(weekdayNumber);
        }
      } else if (this.terminationDate) {
        // Calculate days to deliver until the termination date

        var terminationDayOfYear = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.terminationDate).dayOfYear();
        // Weekday number of the day of year
        var _weekdayNumber = __WEBPACK_IMPORTED_MODULE_2_moment___default()().dayOfYear(terminationDayOfYear).weekday();
        // select the weekday and set the days count to one
        for (var _i = 0; _i < this.weekdays.length; _i++) {
          var weekday = this.weekdays[_i];
          if (weekday.number === _weekdayNumber) {
            this.weekdays[_i].selected = true;
            this.weekdays[_i].days = 1;
            break;
          }
        }

        // Add one to #currentDayOfYear so as not to include today
        // for (let i = (currentDayOfYear + 1); i <= terminationDayOfYear; i++) {
        // Weekday number of the day of year
        // let weekdayNumber = moment().dayOfYear(i).weekday()
        // Updates number of days of the weekday number in the current month
        // this.updateWeekdayDays(weekdayNumber)
        // }
      }
    },
    updateWeekdayDays: function updateWeekdayDays(weekdayNumber) {
      // Check if weekday number is selected, if selected update days of that weekday in the subscription period
      for (var i = 0; i < this.weekdays.length; i++) {
        var weekday = this.weekdays[i];
        if (weekday.number === weekdayNumber && weekday.selected) {
          this.weekdays[i].days++;
          break;
        }
      }
    },
    submit: function submit() {
      var selectedWeekdayNumbers = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.weekdays), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var weekday = _step3.value;

          if (weekday.selected) {
            selectedWeekdayNumbers.push(weekday.number);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var subscription = {
        renewEveryMonth: this.renewEveryMonth,
        terminationDate: this.terminationDate,
        weekdays: selectedWeekdayNumbers.join('#'),
        quantity: this.quantity,
        deliveryCost: this.costs.delivery,
        itemCost: this.costs.item,
        optionItemId: this.selectedOptionItem.id,
        optionId: this.optionId
      };
      console.log('The subscription being submitted is ' + subscription);
      var that = this;

      this.$refs.connectionManager.post('subscriptions', {
        onSuccess: function onSuccess(response) {
          var filter = 'pendingApproval';
          that.$router.push({ name: 'subscriptions', params: { filter: filter } });
          __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* default */].$emit(that.$actions.addedSubscription);
          that.onClose(true);
        }
      }, subscription);
    },
    loadSubscriptionOptions: function loadSubscriptionOptions() {
      var that = this;
      this.$refs.connectionManager.get('subscriptionOptions', {
        onSuccess: function onSuccess(response) {
          that.options = [];
          that.options = that.options.concat(response.data.data);
          that.systemVariables = response.data.systemVariables;
          that.weekdays = [];
          that.weekdays.push({ name: 'Monday', number: 1, days: 0 });
          that.weekdays.push({ name: 'Tuesday', number: 2, days: 0 });
          that.weekdays.push({ name: 'Wednesday', number: 3, days: 0 });
          that.weekdays.push({ name: 'Thursday', number: 4, days: 0 });
          that.weekdays.push({ name: 'Friday', number: 5, days: 0 });
          that.weekdays.push({ name: 'Saturday', number: 6, days: 0 });
          that.weekdays.push({ name: 'Sunday', number: 0, days: 0 });
        }
      }, { withSystemVariables: true });
    }
  },
  created: function created() {
    if (this.options.length === 0) {
      var that = this;
      setTimeout(function () {
        that.loadSubscriptionOptions();
      }, 300);
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddSubscriptionDialog__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var jsPDF = __webpack_require__(68);
__webpack_require__(540);

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_3__Base_vue__["a" /* default */],
  components: {
    AddSubscriptionDialog: __WEBPACK_IMPORTED_MODULE_4__AddSubscriptionDialog__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_2__ConnectionManager__["a" /* default */]
  },
  name: 'admin-subscriptions',
  data: function data() {
    return {
      showAddSubscriptionDialog: false,
      connecting: false,
      viewItemDialog: false,
      filter: null,
      itemToView: null,
      dayFilter: 'all',
      search: null,
      items: [],
      optionItemsIds: [],
      headers: [{ text: 'Item', sortable: false, value: 'optionItem.name' }, { text: 'Weekdays', sortable: false, value: 'weekdays' }, { text: 'Quantity', sortable: false, value: 'quantity' }, { text: 'Item Cost', sortable: false, value: 'item_cost' }, { text: 'Delivery Cost', sortable: false, value: 'deliveryCost' }, { text: 'Total Cost', sortable: false, value: 'amount' }, { text: 'Duration', sortable: false, value: '' }, { text: 'Action', sortable: false, value: '' }],
      viewItemHeaders: [{ text: 'Name', value: 'name' }, { text: 'Email', value: 'email' }, { text: 'Phone', value: 'phone' }]
    };
  },

  watch: {
    '$route': function $route(to, from) {
      // react to route changes...
      if (to.params.filter !== this.filter) {
        this.filter = to.params.filter;
      }
    },
    filter: function filter(val) {
      if (val) {
        this.refresh();
      }
    },
    dayFilter: function dayFilter(val) {
      if (val) {
        this.refresh();
      }
    }
  },
  computed: {},
  methods: {
    printForSupplier: function printForSupplier() {
      var groupedItems = this.groupItemsByOptionItems(this.items.slice());
      this.$app.log(groupedItems);
      var documentTitle = 'Supplier Report for ';
      if (this.dayFilter === 'all') {
        documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions';
      } else if (this.dayFilter === 'today') {
        documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().toDate().toDateString() + ')';
      } else {
        documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days').toDate().toDateString() + ')';
      }
      var rows = [];
      for (var i = 0; i < this.optionItemsIds.length; i++) {
        rows.push([groupedItems[this.optionItemsIds[i]].optionItem.name, groupedItems[this.optionItemsIds[i]].quantity]);
      }
      var columns = ['Item', 'Quantity'];
      this.printDocument(documentTitle, rows, columns);
    },
    printForRider: function printForRider() {
      var documentTitle = 'Rider Report for ';
      if (this.dayFilter === 'all') {
        documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions';
      } else if (this.dayFilter === 'today') {
        documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().toDate().toDateString() + ')';
      } else {
        documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1, 'days').toDate().toDateString() + ')';
      }
      var rows = [];
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        rows.push([item.optionItem.name, item.quantity, item.user.client.name, item.user.client.phone, item.user.client.formattedAddress]);
      }
      var columns = ['Item', 'Quantity', 'Client Name', 'Phone', 'Address'];
      this.printDocument(documentTitle, rows, columns);
    },
    printDocument: function printDocument(documentTitle, rows, columns) {
      var doc = jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        hotfixes: [] // an array of hotfix strings to enable
      });
      var header = function header(data) {
        doc.setFontSize(18);
        doc.setTextColor(26, 117, 186);
        doc.setFontStyle('helvetica');
        doc.setFontType('bold');
        // doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
        doc.text(documentTitle, data.settings.margin.left, 10);
      };
      var options = {
        addPageContent: header,
        margin: {
          top: 30
        },
        startY: 20
      };
      doc.autoTable(columns, rows, options);
      doc.save(this.$app.generateDocumentName(documentTitle) + '.pdf');
    },
    groupItemsByOptionItems: function groupItemsByOptionItems(array) {
      var result = {};
      this.optionItemsIds = [];
      var that = this;
      array.forEach(function (item) {
        if (!result[item.optionItem.id]) {
          that.optionItemsIds.push(item.optionItem.id);
          result[item.optionItem.id] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
        } else {
          result[item.optionItem.id].quantity = result[item.optionItem.id].quantity + item.quantity;
        }
      });
      return result;
    },
    viewItem: function viewItem(item) {
      this.viewItemDialog = true;
      this.itemToView = item.user.client;
    },
    transformWeekdays: function transformWeekdays(weekdays) {
      var weekdayNumbers = weekdays.split('#');
      var weekdayNames = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(weekdayNumbers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var weekdayNumber = _step.value;

          weekdayNames.push(__WEBPACK_IMPORTED_MODULE_5_moment___default()().weekday(weekdayNumber).format('dddd'));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return weekdayNames.join(',');
    },
    onCloseAddSubscriptionDialog: function onCloseAddSubscriptionDialog(val) {
      this.showAddSubscriptionDialog = false;
      if (val) {
        if (this.filter !== 'pendingApproval') {
          this.filter = 'pendingApproval';
        } else {
          this.refresh();
        }
      }
    },
    refresh: function refresh() {
      var that = this;
      that.items = [];
      this.$refs.connectionManager.get('subscriptions', {
        onSuccess: function onSuccess(response) {
          that.items = [];
          that.items = that.items.concat(response.data.data);
        }
      }, { filter: this.filter, dayFilter: this.dayFilter });
    }
  },
  created: function created() {
    this.filter = this.$route.params.filter;
  },
  mounted: function mounted() {
    this.filter = this.$route.params.filter;
    this.dayFilter = 'all';
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Blank',
  data: function data() {
    return {
      passwordVisibilityOff: true,
      error: null,
      errorText: '',
      email: '',
      emailRules: [function (v) {
        return !!v || 'Username is required';
      }],
      password: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }],
      connecting: false
    };
  },

  computed: {
    valid: function valid() {
      return this.email && this.password;
    }
  },
  methods: {
    submit: function submit() {
      // Native form submission is not yet supported
      this.error = false;
      this.connecting = true;
      this.$auth.login({
        data: {
          signInId: this.email,
          password: this.password,
          withVariables: true
        },
        rememberMe: true,
        success: function success(response) {
          // this.$app.log(response.data.data)
          this.connecting = false;
          __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].$emit(this.$actions.signedIn);
          this.$notify({
            group: 'all',
            title: 'Sign',
            text: 'You have signed successfully!'
          });
        },
        error: function error(_error) {
          this.error = true;
          this.connecting = false;
          if (_error.response) {
            if (_error.response.status === 422) {
              switch (_error.response.data.meta.code) {
                case 'VALIDATION':
                  this.errorText = _error.response.data.data;
                  break;
                default:
                  this.errorText = _error.response.data.meta.message;
              }
            } else {
              this.errorText = _error.response.data;
            }
          } else {
            this.errorText = 'An error occurred ' + _error.message;
          }
        }
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientDashboard__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SupplierDashboard__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdminDashboard__ = __webpack_require__(610);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    AdminDashboard: __WEBPACK_IMPORTED_MODULE_3__AdminDashboard__["a" /* default */],
    SupplierDashboard: __WEBPACK_IMPORTED_MODULE_2__SupplierDashboard__["a" /* default */],
    ClientDashboard: __WEBPACK_IMPORTED_MODULE_1__ClientDashboard__["a" /* default */]
  },
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */]

});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatsCard__ = __webpack_require__(312);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { StatsCard: __WEBPACK_IMPORTED_MODULE_1__StatsCard__["a" /* default */] },
  name: 'ClientDashboard',
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be413c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__(602);
function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4be413c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be413c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatsPieChart__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatsBarChart__ = __webpack_require__(600);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { StatsBarChart: __WEBPACK_IMPORTED_MODULE_3__StatsBarChart__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */], StatsPieChart: __WEBPACK_IMPORTED_MODULE_0__StatsPieChart__["a" /* default */] },
  name: 'stats-card',
  props: {
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    chartType: {
      type: String,
      default: 'pie'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    chartData: function chartData() {
      return this.$store.getters['charts/getDataByFilter'](this.url);
    }
  },
  methods: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('charts', ['refreshData']),
  created: function created() {
    this.$store.dispatch('charts/loadData', this.url);
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(315);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Pie */],
  name: 'stats-pie-chart',
  mixins: [reactiveProp],
  mounted: function mounted() {
    // Overwriting base render method with actual data.
    var options = {
      responsive: true,
      maintainAspectRatio: false,
      // rotation: -Math.PI,
      // cutoutPercentage: 30,
      // circumference: Math.PI,
      legend: {
        position: 'top'
      },
      animation: {
        animateRotate: false,
        animateScale: true
      },
      title: {
        display: false,
        text: 'Title here',
        fontSize: 24
      }
    };
    this.renderChart(this.chartData, options);
  }
});

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(315);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  name: 'stats-bar-chart',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp],
  props: ['chartData'],
  data: function data() {
    return {
      options: {
        scales: {
          yAxes: [{
            barPercentage: 0.5,
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              barPercentage: 0.5,
              zeroLineColor: 'black',
              zeroLineWidth: 2
            },
            ticks: {
              min: 1,
              max: 12,
              stepSize: 1
            },
            scaleLabel: {
              display: true
              // labelString: "Density in kg/m3"
            }
          }]
        },
        elements: {
          rectangle: {
            borderSkipped: 'left'
          }
        }
      }
    };
  },
  mounted: function mounted() {
    // Overwriting base render method with actual data.
    /* this.chartData = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          label: 'Population (millions)',
          backgroundColor: [
            '#3e95cd', '#8e5ea2', '#3cba9f', '#e8c3b9', '#c45850'],
          data: [2478, 5267, 734, 784, 433]
        }
      ]
    } */
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComingSoon__ = __webpack_require__(606);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SupplierDashboard',
  components: { ComingSoon: __WEBPACK_IMPORTED_MODULE_0__ComingSoon__["a" /* default */] }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  name: 'coming-soon'
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatsCard__ = __webpack_require__(312);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminDashboard',
  components: { StatsCard: __WEBPACK_IMPORTED_MODULE_0__StatsCard__["a" /* default */] }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddToCartDialog__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CartDialog__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_3__Base_vue__["a" /* default */],
  components: {
    CartDialog: __WEBPACK_IMPORTED_MODULE_4__CartDialog__["a" /* default */],
    AddToCartDialog: __WEBPACK_IMPORTED_MODULE_2__AddToCartDialog__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */]
  },
  name: 'Shopping',
  data: function data() {
    return {
      selectedProduct: null,
      currentTab: null,
      rowsPerPageItems: [12],
      pagination: {
        rowsPerPage: 12
      },
      search: null
    };
  },

  watch: {
    categories: function categories(val) {
      if (val && val.length) {
        this.currentTab = val[0].id + '';
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    products: function products() {
      var _this = this;

      // console.info(this.currentTab)
      console.info('Computing products');
      var category = this.categories.find(function (category) {
        return category.id === parseInt(_this.currentTab);
      });
      if (this.search) {
        return category ? category.products.filter(function (product) {
          return product.name.toLowerCase().includes(_this.search.toLowerCase());
        }) : [];
      }
      return category ? category.products : [];
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    categories: 'allCategories'
  })),
  created: function created() {
    this.$store.dispatch('getAllCategories');
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__Base__["a" /* default */],
  name: 'add-to-cart-dialog',
  props: {
    product: {
      required: true
    }
  },
  watch: {
    product: function product(val) {
      if (val) {
        this.quantity = !this.product.quantityInCart ? 1 : this.product.quantityInCart;
      } else {
        this.quantity = 1;
      }
      this.dialog = !!val;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onCancel: function onCancel() {
      this.$emit('onCancel');
      this.quantity = 1;
    },
    onConfirm: function onConfirm() {
      this.$store.dispatch('addProductToCart', { product: this.product, quantity: parseInt(this.quantity) });
      this.quantity = 1;
      this.$emit('onCancel');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addProductToCart'])),
  data: function data() {
    return {
      dialog: false,
      quantity: 1
    };
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CartDialog',
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__["a" /* default */] },
  data: function data() {
    return {
      show: false,
      connecting: false,
      headers: [
      // text: 'Item Id', sortable: true, value: 'product.id'},
      { text: 'Item', sortable: true, value: 'product.name', isMoney: true }, { text: 'Price/Item', sortable: true, value: 'product.price' }, { text: 'Quantity', sortable: true, value: 'quantity' }, { text: 'Total Cost', sortable: true, value: 'total' }, { text: 'Actions', sortable: false, value: 'actions' }]
    };
  },
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* default */].$on(this.$actions.clickedToolbarCartIcon, function () {
      that.show = true;
    });
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    cartProducts: 'cartProducts',
    cartTotal: 'cartTotal'
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    close: function close() {
      this.$refs.connectionManager.reset();
      this.$store.dispatch('removeAllProductsFromCart');
      this.show = false;
    },
    submit: function submit() {
      var that = this;
      var orders = [];
      this.cartProducts.forEach(function (cartProduct) {
        orders.push({
          productId: cartProduct.product.id,
          quantity: cartProduct.quantity
        });
      });
      this.$refs.connectionManager.post('rawOrderItems', {
        onSuccess: function onSuccess(response) {
          that.close();
        }
      }, orders);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['removeProductFromCart', 'removeAllProductsFromCart']))
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceRequests__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_vue__ = __webpack_require__(5);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__Base_vue__["a" /* default */],
  components: { ServiceRequests: __WEBPACK_IMPORTED_MODULE_0__ServiceRequests__["a" /* default */] },
  name: 'it-services'
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceRequests_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d09fd38_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceRequests_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d09fd38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d09fd38_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceRequestDialog__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__Base_vue__["a" /* default */],
  components: {
    Base: __WEBPACK_IMPORTED_MODULE_2__Base_vue__["a" /* default */],
    ServiceRequestDialog: __WEBPACK_IMPORTED_MODULE_1__ServiceRequestDialog__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__["a" /* default */]
  },
  name: 'service-requests',
  props: {
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return value === 'it' || value === 'repair';
      }
    }
  },
  data: function data() {
    return {
      currentTab: null,
      loading: false,
      addingServiceRequest: false,
      headers: [
      /* {text: 'ID', value: 'id'}, */
      { text: 'Details', value: 'details' }, { text: 'Note', value: 'note' }, { text: 'Scheduled Date', value: 'scheduleDate' }, { text: 'Scheduled Time', value: 'scheduleTime' }],
      serviceRequests: []
    };
  },

  watch: {
    currentTab: function currentTab(val) {
      if (val) {
        this.refresh();
      }
    }
  },
  methods: {
    showApprovalActions: function showApprovalActions(order) {
      return this.currentTab === 'pendingApproval' && (this.isPurchasingHead() && order.status === 'AT_PURCHASING_HEAD' || this.isDepartmentHead() && order.status === 'AT_DEPARTMENT_HEAD');
    },
    confirm: function confirm(order) {
      this.serviceRequests = [];
      var that = this;
      this.$refs.connectionManager.patch('serviceRequests/' + order.id, {
        onSuccess: function onSuccess(response) {
          that.serviceRequests = [];
          that.serviceRequests = that.serviceRequests.concat(response.data.data);
          __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* default */].$emit(that.$actions.approved);
        }
      }, {
        action: 'approve',
        type: this.type
      });
    },
    reject: function reject(order) {
      this.serviceRequests = [];
      var that = this;
      this.$refs.connectionManager.patch('serviceRequests/' + order.id, {
        onSuccess: function onSuccess(response) {
          that.serviceRequests = [];
          that.serviceRequests = that.serviceRequests.concat(response.data.data);
          __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* default */].$emit(that.$actions.approved);
        }
      }, {
        action: 'reject',
        type: this.type
      });
    },
    refresh: function refresh() {
      var that = this;
      this.serviceRequests = [];
      this.$refs.connectionManager.get('serviceRequests', {
        onSuccess: function onSuccess(response) {
          that.serviceRequests = [];
          that.serviceRequests = that.serviceRequests.concat(response.data.data);
        }
      }, {
        filter: this.currentTab,
        type: this.type
      });
    },
    onCloseAddingServiceRequest: function onCloseAddingServiceRequest(successful) {
      this.addingServiceRequest = false;
      this.currentTab = 'pendingApproval';
      this.$app.log(successful);
      if (successful) {
        this.refresh();
      }
    }
  },
  mounted: function mounted() {
    this.currentTab = 'pendingApproval';
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DateInput__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeInput__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeInput: __WEBPACK_IMPORTED_MODULE_3__TimeInput__["a" /* default */],
    DateInput: __WEBPACK_IMPORTED_MODULE_2__DateInput__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */]
  },
  name: 'service-request-dialog',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return value === 'it' || value === 'repair';
      }
    }
  },
  computed: {
    formIsValid: function formIsValid() {
      return this.select.length > 0;
    },
    detailsHint: function detailsHint() {
      return this.type === 'it' ? 'Hit \'Enter\' to write multiple issues or select from the suggestions, e.g Computer is slow' : 'Hit \'Enter\' to write multiple issues or select from the suggestions, e.g A broken chair or wall painting';
    },
    detailsLabel: function detailsLabel() {
      return this.type === 'it' ? 'What issues you have noticed' : 'What repairs do you need';
    }
  },
  watch: {
    show: function show(val) {
      this.dialog = val;
    },
    search: function search(val) {
      val && this.querySelections(val);
    }
  },
  data: function data() {
    return {
      dialog: false,
      connecting: false,
      serviceOptions: [],
      note: null,
      select: [],
      loading: false,
      items: [],
      search: null,
      scheduleDate: null,
      scheduleTime: null
    };
  },

  methods: {
    submit: function submit() {
      var serviceRequest = {
        scheduleDate: this.scheduleDate,
        scheduleTime: this.scheduleTime,
        note: this.note,
        type: this.type,
        details: this.select
      };

      this.$app.log(serviceRequest);
      var that = this;
      this.$refs.connectionManager.post('serviceRequests', {
        onSuccess: function onSuccess(response) {
          __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* default */].$emit(that.$actions.requestedService);
          that.$emit('onClose', true);
        }
      }, serviceRequest);
    },
    querySelections: function querySelections(val) {
      var _this = this;

      this.loading = true;
      this.axios.get('serviceRequestOptions', {
        params: {
          search: val,
          type: this.type
        }
      }).then(function (response) {
        _this.items = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _this.items.push(item.description);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        _this.$app.log(error);
      });
    }
  },
  mounted: function mounted() {
    // this.$refs.connectionManager.connecting = true
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceRequests__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_vue__ = __webpack_require__(5);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__Base_vue__["a" /* default */],
  components: { ServiceRequests: __WEBPACK_IMPORTED_MODULE_0__ServiceRequests__["a" /* default */] },
  name: 'repair-services'
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Guide__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase__["a" /* default */],
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__["a" /* default */], Guide: __WEBPACK_IMPORTED_MODULE_2__Guide__["a" /* default */], Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  name: 'Orders',
  data: function data() {
    return {
      confirmingReceived: false,
      confirmingReceivedItem: null,
      item: null,
      confirmationToken: null,
      viewDialogHere: false,
      connecting: false,
      dispatchingItem: null,
      dispatching: false,
      viewableHeaders: [],
      viewItemHeaders: [],
      adminAndOperationsFilters: [{ value: 'PENDING_DISPATCH', name: 'Pending Dispatch' }, { value: 'DISPATCHED', name: 'Dispatched' }, { value: 'DELIVERED', name: 'Delivered'
        // {value: 'AT_DEPARTMENT_HEAD', name: 'At Department Head'},
        // {value: 'AT_PURCHASING_HEAD', name: 'At Purchasing Head'},
        // {value: 'APPROVED', name: 'Approved'},
        // {value: 'REJECTED', name: 'Rejected'}
      }],
      clientFilters: [
      // {value: 'AT_DEPARTMENT_HEAD', name: 'At Department Head'},
      // {value: 'AT_PURCHASING_HEAD', name: 'At Purchasing Head'},
      // {value: 'APPROVED', name: 'Approved'},
      // {value: 'DELIVERED', name: 'Delivered'},
      // {value: 'REJECTED', name: 'Rejected'},
      // {value: 'DISPATCHED', name: 'Dispatched'},
      // {value: 'PENDING_DISPATCH', name: 'Pending Dispatch'}
      { value: 'PENDING_DISPATCH', name: 'Pending Dispatch' }, { value: 'DISPATCHED', name: 'Dispatched' }, { value: 'DELIVERED', name: 'Delivered' }],
      productHeaders: [{ text: 'Name', value: 'product.name' }, { text: 'Price', value: 'product.price' }, { text: 'Quantity', value: 'quantity' }, { text: 'Total', value: 'total' }],
      extraTopActions: [{
        name: 'Approve All',
        key: 'approveAll'
      }, {
        name: 'Reject All',
        key: 'rejectAll',
        color: 'accent'
      }],
      extraInlineActions: [{
        name: 'Confirm Received',
        key: 'confirmReceived',
        color: 'accent'
      }, {
        name: 'Dispatch',
        key: 'dispatch',
        color: 'accent'
      }, {
        name: 'View',
        key: 'view',
        color: 'primary'
      }]
    };
  },

  methods: {
    closeDispatchingDialog: function closeDispatchingDialog() {
      this.dispatchingItem = null;
      this.dispatching = false;
      this.connecting = false;
    },
    closeConfirmingDispatch: function closeConfirmingDispatch() {
      this.confirmingReceivedItem = null;
      this.confirmingReceived = false;
      this.connecting = false;
    },
    dispatch: function dispatch() {
      var that = this;
      this.$refs.dispatchConnectionManager.post('orders/dispatch/' + this.dispatchingItem.id, {
        onSuccess: function onSuccess(response) {
          that.$refs.crud.setItems(response.data.data);
          that.closeDispatchingDialog();
        }
      });
    },
    confirmReceived: function confirmReceived() {
      var that = this;
      this.$refs.confirmingReceivedConnectionManager.post('orders/confirmReceived/' + this.confirmingReceivedItem.id, {
        onSuccess: function onSuccess(response) {
          that.$refs.crud.removeItem(response.data.data);
          that.closeConfirmingDispatch();
        }
      }, { code: this.confirmationToken });
    },
    resendConfirmationCode: function resendConfirmationCode() {
      var that = this;
      this.$refs.confirmingReceivedConnectionManager.get('orders/confirmationToken/' + this.confirmingReceivedItem.id, {
        onSuccess: function onSuccess(response) {
          that.$notify({
            group: 'all',
            title: 'Confirmation Token Sent',
            text: 'Confirmation token resent successfully!'
          });
        }
      });
    },
    close: function close() {
      this.item = null;
      this.viewDialogHere = false;
    },
    initialize: function initialize() {
      var _this = this;

      var that = this;
      this.manager.editable = function (item) {
        return false;
      };
      this.manager.deletable = function (item) {
        return false;
      };
      this.manager.creatable = function () {
        return false;
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'createdBy') {
          return item.user ? item.user.name : that.defaultValue;
        } else if (header.value === 'rejectedBy') {
          return item.rejectedBy ? item.rejectedBy.name + ' - (' + item.rejectedBy.role.name + ')' : that.defaultValue;
        } else if (header.value === 'dispatchedBy') {
          return item.dispatchedBy ? item.dispatchedBy.name : that.defaultValue;
        } else if (header.value === 'receivedConfirmedBy') {
          return item.receivedConfirmedBy ? item.receivedConfirmedBy.name : that.defaultValue;
        } else if (header.value === 'dispatchRider') {
          return item.dispatchRider ? item.dispatchRider.name : that.defaultValue;
        } else if (header.value === 'client') {
          // return item.user.client.name
        } else if (header.value === 'deliveryCost') {
          return that.$app.formatMoney(item.deliveryCost);
        } else if (header.value === 'totalCost') {
          return that.$app.formatMoney(parseFloat(item.deliveryCost) + item.amount);
        } else if (header.value === 'amount') {
          return that.$app.formatMoney(item.amount);
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
      this.manager.nameOnDelete = function (item) {
        return 'this order.';
      };
      this.manager.hasCustomView = function (item, viewableHeaders, viewItemHeaders) {
        that.item = item;
        that.viewDialogHere = true;
        that.viewableHeaders = viewableHeaders;
        that.viewItemHeaders = viewItemHeaders;
        return true;
      };
      this.manager.showInlineAction = function (action, item, filter) {
        if (action.key === 'dispatch' && filter) {
          return filter.value === 'PENDING_DISPATCH' && (_this.isAdmin() || _this.isOperations());
        }
        if (action.key === 'confirmReceived' && filter) {
          return filter.value === 'DISPATCHED' && _this.isDepartmentUser();
        } else {
          return true;
        }
      };
      this.manager.showTopAction = function (action, items, filter) {
        if ((action.key === 'approveAll' || action.key === 'rejectAll') && filter) {
          return (filter.value === 'AT_DEPARTMENT_HEAD' && _this.isDepartmentHead() || filter.value === 'AT_PURCHASING_HEAD' && _this.isPurchasingHead()) && items.length;
        } else {
          return true;
        }
      };
      this.manager.onTopAction = function (action, items, filter) {
        if (action.key === 'approveAll' || action.key === 'rejectAll') {
          _this.$refs.connectionManager.patch('orders/' + action, {
            onSuccess: function onSuccess(response) {
              that.$refs.crud.clearItems();
            }
          });
        }
      };
      this.manager.onInlineActionClicked = function (action, item, filter) {
        if (action.key === 'view') {
          that.$refs.crud.viewItem(item);
        } else if (action.key === 'dispatch') {
          that.viewableHeaders = that.$refs.crud.viewableHeaders;
          that.viewItemHeaders = that.$refs.crud.viewItemHeaders;
          that.dispatchingItem = item;
          that.dispatching = true;
        } else if (action.key === 'confirmReceived') {
          that.viewableHeaders = that.$refs.crud.viewableHeaders;
          that.viewItemHeaders = that.$refs.crud.viewItemHeaders;
          that.confirmingReceivedItem = item;
          that.confirmingReceived = true;
        }
      };
      this.manager.hideHeader = function (header, filter) {
        if (header.value === 'rejectedBy') {
          return filter.value === 'REJECTED';
        } else if (header.value === 'dispatchedAt') {
          return filter.value !== 'DISPATCHED' || that.isSupplier();
        } else if (header.value === 'dispatchedBy') {
          return filter.value !== 'DISPATCHED' || !that.isSupplier();
        } else if (header.value === 'receivedConfirmedAt') {
          return filter.value !== 'DELIVERED';
        } else if (header.value === 'receivedConfirmedBy') {
          return filter.value !== 'DELIVERED';
        } else if (header.value === 'dispatchRider') {
          return filter.value !== 'DISPATCHED';
        } else if (header.value === 'itemsReceivedFromSupplierCount') {
          return !that.isAdmin() && !that.isOperations();
        } else if (header.value === 'itemsNotReceivedFromSupplierCount') {
          return !that.isAdmin() && !that.isOperations();
        } else if (header.value === 'client') {
          return !that.isAdmin() && !that.isOperations();
        } else {
          return false;
        }
      };
    },
    approveOrReject: function approveOrReject(action) {
      var that = this;
      this.$refs.connectionManager.patch('orders/' + this.item.id, {
        onSuccess: function onSuccess(response) {
          that.item = null;
          that.connecting = false;
          that.selected = [];
          that.viewDialogHere = false;
          var item = response.data.data;
          that.$refs.crud.removeItem(item);
        }
      }, { action: action });
    },
    showRejectButton: function showRejectButton(item) {
      return this.isPurchasingHead() && item.status === 'AT_PURCHASING_HEAD' || this.isDepartmentHead() && item.status === 'AT_DEPARTMENT_HEAD';
    },
    showApproveButton: function showApproveButton(item) {
      // Item is rejected
      // The user who rejected is the authenticated user
      return item.status === 'REJECTED' && item.rejectedBy && item.rejectedBy.id === this.$auth.user().id || this.isPurchasingHead() && item.status === 'AT_PURCHASING_HEAD' || this.isDepartmentHead() && item.status === 'AT_DEPARTMENT_HEAD';
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrudRemoteSelect__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GooglePlaceInput__ = __webpack_require__(54);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Crud',
  components: { CrudRemoteSelect: __WEBPACK_IMPORTED_MODULE_2__CrudRemoteSelect__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */], GooglePlaceInput: __WEBPACK_IMPORTED_MODULE_3__GooglePlaceInput__["a" /* default */] },
  props: { // Specify the endpoint to connect to
    resource: {
      type: String,
      required: true
    },
    // Actions to be shown at the top, next to the search bar
    extraTopActions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },

    // Actions to be shown inline, below the row when the item is clicked
    extraInlineActions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },

    // Actions to be shown when the overflow icon is clicked
    extraOverflowActions: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },

    // An array of filters to show, filters are show at the right of the search
    filters: {
      type: Array,
      required: false
    },

    // If should show a custom view dialog
    customViewDialog: {
      type: Boolean,
      required: false
    },

    // If the add button should be shown
    creatable: {
      type: Boolean,
      required: false,
      default: true
    },

    // A manager
    manager: {
      type: Object,
      required: true
    },

    // Headers that should not be shown
    hiddenHeaders: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      editDialog: false,
      viewDialog: false,
      deleteDialog: false,
      valid: false,
      connecting: false,
      deleting: false,
      headers: [],
      browsableHeaders: [],
      viewableHeaders: [],
      viewItemHeaders: [{
        text: 'Name',
        value: 'name',
        align: 'left'
      }, {
        text: 'Value',
        value: 'value',
        align: 'left'
      }],
      rowsPerPageItems: [10],
      pagination: {
        rowsPerPage: 10
      },
      items: [],
      rules: {
        required: function required(value) {
          return !!value || 'This field is required.';
        }
      },
      itemToEditIndex: -1,
      itemToEdit: {},
      itemToDeleteIndex: -1,
      itemToDelete: null,
      itemToView: null,
      currentFilter: null,
      search: null,
      placeResultData: null,
      location: null,
      addressData: null
    };
  },
  computed: {
    formTitle: function formTitle() {
      return this.itemToEditIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },
  watch: {
    editDialog: function editDialog(val) {
      val || this.close();
    },
    itemToView: function itemToView(val) {
      this.viewDialog = !!val;
    },
    itemToDelete: function itemToDelete(val) {
      this.deleteDialog = !!val;
    },
    currentFilter: function currentFilter(val) {
      if (val) {
        this.initialize();
      }
    }
  },
  methods: {
    isRequired: function isRequired(header) {
      if (this.itemToEditIndex > -1) {
        return header.editRequired;
      } else {
        return header.createRequired;
      }
    },
    onLocationEntered: function onLocationEntered(addressData, placeResultData) {
      this.addressData = addressData;
      this.placeResultData = placeResultData;
      this.location = placeResultData.name;
    },
    isEditable: function isEditable(header) {
      if (this.itemToEditIndex > -1) {
        return header.editable;
      } else {
        return header.creatable;
      }
    },


    // Remove all the items
    clearItems: function clearItems() {
      this.items = [];
    },


    // Set the items
    setItems: function setItems(items) {
      this.items = items;
    },


    // Generate placeholder based on the value of a header
    toPlaceholder: function toPlaceholder(value) {
      return 'Enter ' + value.toLowerCase();
    },


    // Generate an array where options for select header are comma separated
    toOptions: function toOptions(options) {
      return options.split(',');
    },
    isHiddenHeader: function isHiddenHeader() {
      return this.hiddenHeaders.find();
    },
    initialize: function initialize() {
      this.items = [];
      var that = this;
      this.$refs.connectionManager.get(this.resource, {
        onSuccess: function onSuccess(response) {
          that.$app.log(response.data);
          that.$app.log(response.data.meta);
          that.items = [];
          that.items = that.items.concat(response.data.data);
          that.headers = [];
          that.headers = that.headers.concat(response.data.meta.headers);
          that.browsableHeaders = that.headers.filter(function (header) {
            // Find if the header is in the hidden headers
            return header.browsable && !that.hiddenHeaders.find(function (h) {
              return h.text === header.text;
            }) && !that.manager.hideHeader(header, that.currentFilter);
          });
          that.viewableHeaders = that.headers.filter(function (header) {
            return header.viewable && !that.hiddenHeaders.find(function (h) {
              return h.text === header.text;
            }) && !that.manager.hideHeader(header, that.currentFilter);
          });
          that.browsableHeaders.push({
            text: 'Actions',
            value: 'actions',
            align: 'center',
            sortable: false
          });
        }
      }, { filter: this.currentFilter ? this.currentFilter.value : '' });
    },
    viewItem: function viewItem(item) {
      if (!this.manager.hasCustomView(item, this.viewableHeaders)) {
        this.$app.log(item);
        this.itemToView = item;
      }
    },
    editItem: function editItem(item) {
      this.itemToEditIndex = this.items.indexOf(item);
      this.itemToEdit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.editDialog = true;
    },
    deleteItem: function deleteItem(item) {
      this.itemToDeleteIndex = this.items.indexOf(item);
      this.itemToDelete = item;
      this.$app.log(item);
      // confirm('Are you sure you want to delete this item?') && this.items.splice(deleteIndex, 1)
    },
    doDelete: function doDelete() {
      var that = this;
      this.$refs.deleteConnectionManager.delete(this.resource + '/' + this.itemToDelete.id, {
        onSuccess: function onSuccess(response) {
          that.$app.log(response);
          that.items.splice(that.itemToDeleteIndex, 1);
          that.itemToDelete = null;
          that.itemToDeleteIndex = -1;
          that.deleting = false;
          that.$refs.deleteConnectionManager.reset();
        }
      });
    },


    // Updates the given item
    updateItem: function updateItem(updatedItem) {
      this.$app.log('updateItem');
      var itemToUpdate = this.items.find(function (item) {
        return item.id === updatedItem.id;
      });
      var indexOfItemToUpdate = this.items.indexOf(itemToUpdate);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.items[indexOfItemToUpdate], updatedItem);
    },
    removeItem: function removeItem(updatedItem) {
      this.$app.log('removeItem');
      this.items = this.items.filter(function (item) {
        return item.id !== updatedItem.id;
      });
    },
    close: function close() {
      var _this = this;

      this.editDialog = false;
      setTimeout(function () {
        _this.itemToEdit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {});
        _this.itemToEditIndex = -1;
        _this.$refs.form.reset();
        _this.$refs.editConnectionManager.reset();
      }, 300);
    },
    save: function save() {
      // location has been added manually.. to be checked later
      this.itemToEdit['locationName'] = this.location;
      this.itemToEdit['formattedAddress'] = this.placeResultData ? this.placeResultData.formatted_address : '';
      this.itemToEdit['vicinity'] = this.placeResultData ? this.placeResultData.vicinity : '';
      this.itemToEdit['latitude'] = this.placeResultData ? this.placeResultData.geometry.location.lat() : '';
      this.itemToEdit['longitude'] = this.placeResultData ? this.placeResultData.geometry.location.lng() : '';
      this.$app.log(this.itemToEdit);
      var that = this;
      if (this.itemToEditIndex > -1 && this.$refs.form.validate()) {
        this.$refs.editConnectionManager.patch(this.resource + '/' + this.itemToEdit.id, {
          onSuccess: function onSuccess(response) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(that.items[that.itemToEditIndex], response.data.data);
            that.close();
          }
        }, this.itemToEdit);
      } else if (this.$refs.form.validate()) {
        this.$refs.editConnectionManager.post(this.resource, {
          onSuccess: function onSuccess(response) {
            that.items.push(response.data.data);
            that.close();
          }
        }, this.itemToEdit);
      }
    }
  },
  mounted: function mounted() {
    if (this.filters) {
      this.currentFilter = this.filters[0];
    } else {
      this.initialize();
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CrudRemoteSelect',
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: true
    },
    header: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      itemId: null,
      query: null,
      searching: false,
      items: []
    };
  },

  watch: {
    query: function query(val) {
      if (val) {
        // this.search(val)
      }
    },
    itemId: function itemId(val) {
      this.$app.log(val);
      this.$emit('input', val);
    }
  },
  methods: {
    search: function search(val) {
      var _this = this;

      this.searching = true;
      this.axios.get(this.header.options, {
        params: {
          search: val
        }
      }).then(function (response) {
        _this.$app.log('Select option items ' + response.data.data[0]['id']);
        _this.searching = false;
        _this.items = [];
        _this.items = _this.items.concat(response.data.data);
      }).catch(function (error) {
        _this.searching = false;
        _this.$app.log(error);
      });
    }
  },
  created: function created() {
    this.search('test');
  },
  mounted: function mounted() {}
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CrudBase',
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  data: function data() {
    return {
      headers: [], // Headers for the table
      manager: {},
      defaultValue: '_____', // Displayed when a value is null
      extraInlineActions: [
        /*
        Actions should be name,color,key objects e.g
        {
          name: 'Approve',
          color: 'accent',
          key:'approve'
        }, {
          name: 'Reject',
          color: 'primary',
          key:'reject'
        } */
      ],
      extraOverflowActions: [
        /*
        Actions should be name,key objects e.g
        {
          name: 'Approve',
          key:'approve'
        }, {
          name: 'Reject',
          key:'reject'
        } */

      ],
      extraTopActions: [
        /*
        Actions should be name,color, key objects e.g
        {
          name: 'Approve',
          color: 'accent',
          key: 'ddd'
        }, {
          name: 'Reject',
          color: 'primary',
          key: 'ddd'
        } */
      ]
    };
  },
  created: function created() {
    this.setDefaultManager(); // Sets a default manager
    this.initialize(); //
  },

  methods: {
    initialize: function initialize() {},
    setDefaultManager: function setDefaultManager() {
      var that = this;
      this.manager = {

        // Whether the item is deletable
        deletable: function deletable(item) {
          return true;
        },

        // Whether the item is editable
        editable: function editable(item) {
          return true;
        },

        // If should show a custom dialog or any view when view item is clicked
        hasCustomView: function hasCustomView(item, viewableHeaders, viewItemHeaders) {
          return false;
        },


        // Get value for a header
        // header: the header
        // item: current item
        toValue: function toValue(header, item) {
          return item[header.value] ? item[header.value] : that.defaultValue;
        },

        // Name shown in the delete prompt dialog
        nameOnDelete: function nameOnDelete(item) {
          return item.name;
        },


        // Called when any specified top action is clicked
        // action: clicked action
        // items: all items
        // filter: current filter
        onTopAction: function onTopAction(action, items, filter) {},


        // Whether a top action should be shown
        showTopAction: function showTopAction(action, items, filter) {
          return true;
        },


        // Called when any specified inline action is clicked
        // action: clicked action
        // item: item in that row
        // filter: current filter
        onInlineActionClicked: function onInlineActionClicked(action, item, filter) {},


        // Whether an inline action should be shown
        showInlineAction: function showInlineAction(action, item, filter) {
          return true;
        },


        // Determine if a header should be hidden
        hideHeader: function hideHeader(header, filter) {
          return false;
        },

        // Determine if a extra overflow item show be shown
        showExtraOverflowActions: function showExtraOverflowActions(action, filter) {
          return false;
        },
        fireAction: function fireAction(action, item) {}
      };
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminUsers__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientUsers__ = __webpack_require__(648);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Users',
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  components: { ClientUsers: __WEBPACK_IMPORTED_MODULE_2__ClientUsers__["a" /* default */], AdminUsers: __WEBPACK_IMPORTED_MODULE_1__AdminUsers__["a" /* default */] },
  methods: {}
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUsers',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud_vue__["a" /* default */] },
  methods: {
    initialize: function initialize() {
      var that = this;
      this.manager.deletable = function (item) {
        return item.role.name !== 'ADMIN' && item.role.name !== 'OPERATIONS' && !item.email.startsWith('test');
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'roleId') {
          return item.role ? item.role.name : that.defaultValue;
        } else if (header.value === 'clientId') {
          return item.client ? item.client.name : that.defaultValue;
        } else if (header.value === 'departmentId') {
          return item.department ? item.department.name : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Base__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddUserDialog__ = __webpack_require__(650);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__Base__["a" /* default */],
  components: { AddUserDialog: __WEBPACK_IMPORTED_MODULE_3__AddUserDialog__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_1__ConnectionManager__["a" /* default */], Base: __WEBPACK_IMPORTED_MODULE_2__Base__["a" /* default */] },
  name: 'ClientUsers',
  data: function data() {
    return {
      editingUser: false,
      deletingUser: false,
      deleteDialog: false,
      editDialog: false,
      formValid: false,
      users: [],
      userToEditIndex: -1,
      userToEdit: {},
      userToDeleteIndex: -1,
      userToDelete: null,
      roleName: null,
      roles: ['ADMIN', 'PURCHASING_HEAD', 'DEPARTMENT_HEAD', 'DEPARTMENT_USER'],
      departments: []
    };
  },

  watch: {
    userToDelete: function userToDelete(val) {
      this.deleteDialog = !!val;
    }
  },
  methods: {
    editItem: function editItem(item) {
      this.userToEditIndex = this.users.indexOf(item);
      this.userToEdit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.roleName = this.userToEdit.role.name;
      this.editDialog = true;
    },
    deleteItem: function deleteItem(item) {
      this.$app.log(item);
      this.userToDelete = item;
      this.userToDeleteIndex = this.users.indexOf(item);
      // confirm('Are you sure you want to delete this item?') && this.users.splice(this.userToDeleteIndex, 1)
    },
    doDelete: function doDelete() {
      var that = this;
      this.$refs.deleteConnectionManager.delete('/users/' + that.userToDelete.id, {
        onSuccess: function onSuccess(response) {
          that.users.splice(that.userToDeleteIndex, 1);
          that.userToDelete = null;
          that.userToDeleteIndex = -1;
          that.deletingUser = false;
          that.$refs.deleteConnectionManager.reset();
        }
      });
    },
    close: function close() {
      var _this = this;

      this.editDialog = false;
      setTimeout(function () {
        _this.userToEdit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {});
        _this.userToEditIndex = -1;
        _this.$refs.form.reset();
        _this.$refs.editConnectionManager.reset();
      }, 300);
    },
    save: function save() {
      this.$app.log('Saving item...');
      this.$app.log(this.userToEdit);
      this.userToEdit['role'] = this.roleName;
      var that = this;
      if (this.userToEditIndex > -1 && this.$refs.form.validate()) {
        this.$refs.editConnectionManager.patch('/users/' + this.userToEdit.id, {
          onSuccess: function onSuccess(response) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(that.users[that.userToEditIndex], response.data.data);
            that.close();
          }
        }, this.userToEdit);
      } else if (this.$refs.form.validate()) {
        this.$refs.editConnectionManager.post('users', {
          onSuccess: function onSuccess(response) {
            that.users.push(response.data.data);
            that.close();
          }
        }, this.userToEdit);
      }
    },
    initialize: function initialize() {
      this.departments = [];
      var that = this;
      this.$refs.connectionManager.get('/departments', {
        onSuccess: function onSuccess(response) {
          that.$app.log(response.data);
          that.$app.log(response.data.meta);
          that.departments = [];
          that.departments = that.departments.concat(response.data.data);
          that.$app.log('Client departments');
          that.$app.log(that.departments);
        }
      });
    }
  },
  mounted: function mounted() {
    // this.loadUsers()
    this.users = this.$auth.user().client.users;
    this.initialize();
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__ = __webpack_require__(4);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddUserDialog',
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__["a" /* default */] },
  props: {
    userToEdit: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      roles: ['ADMIN', 'PURCHASING_HEAD', 'DEPARTMENT_HEAD', 'DEPARTMENT_USER'],
      role: null,
      password: null,
      dialog: false,
      connecting: false,
      name: null,
      email: null,
      phone: null,
      departmentId: null,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        phone: function phone(value) {
          return !!value && ('' + value).length === 10 || 'Phone number must be 10 characters';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      }
    };
  },

  watch: {
    userToEdit: function userToEdit(val) {
      this.dialog = !!val;
      if (!val) {
        this.onClose(null);
      }
    }
  },
  computed: {
    formIsValid: function formIsValid() {
      var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.name && this.email && pattern.test(this.email) && (this.departmentId || this.role === 'ADMIN' || this.role === 'PURCHASING_HEAD') && ('' + this.phone).length === 10 && this.role;
    }
  },
  methods: {
    onClose: function onClose() {
      this.name = null;
      this.email = null;
      this.phone = null;
      this.role = null;
      this.password = null;
      this.departmentId = null;
    },
    submit: function submit() {
      var that = this;
      this.$refs.connectionManager.post('users', {
        onSuccess: function onSuccess(response) {
          that.$emit('onClose', response);
        }
      }, {
        name: this.name,
        role: this.role === 'ADMIN' ? 'CLIENT_ADMIN' : this.role,
        password: this.password,
        email: this.email,
        phone: this.phone,
        departmentId: this.departmentId
      });
    }
  },
  mounted: function mounted() {
    this.departments = this.$auth.user().client.departments;
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChangePasswordDialog__ = __webpack_require__(657);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  components: { ChangePasswordDialog: __WEBPACK_IMPORTED_MODULE_1__ChangePasswordDialog__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__["a" /* default */] },
  data: function data() {
    return {
      appointments: [],
      changingPassword: false
    };
  },
  mounted: function mounted() {
    var that = this;
    this.$refs.connectionManager.get('users/appointments', {
      onSuccess: function onSuccess(response) {
        that.appointments = response.data.data;
      }
    });
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Guide__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChangePasswordDialog',
  components: { Guide: __WEBPACK_IMPORTED_MODULE_1__Guide__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_0__ConnectionManager__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      connecting: false,
      dialog: false,
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      }
    };
  },

  computed: {
    validates: function validates() {
      return this.currentPassword && this.newPassword && this.confirmPassword && this.newPassword === this.confirmPassword;
    }
  },
  watch: {
    show: function show(val) {
      this.dialog = !!val;
    }
  },
  methods: {
    submit: function submit() {
      var that = this;
      this.$refs.connectionManager.post('users/changePassword', {
        onSuccess: function onSuccess(response) {
          that.signOut();
        }
      }, {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword
      });
    },
    signOut: function signOut() {
      this.$auth.logout({
        success: function success() {
          this.$notify({
            group: 'all',
            title: 'Sign out',
            text: 'You have signed out successfully!'
          });
        },
        error: function error() {
          this.$app.log('SignOut failed');
        }
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Departments',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  methods: {
    initialize: function initialize() {
      // let that = this
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Clients',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  methods: {
    clientCreated: function clientCreated() {},
    initialize: function initialize() {
      var that = this;
      this.manager.deletable = function (item) {
        return item.email !== 'testclient@cube-messenger.com';
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'balance') {
          return item.balance ? that.$app.formatMoney(item.balance) : that.defaultValue;
        } else if (header.value === 'limit') {
          return item.limit ? that.$app.formatMoney(item.limit) : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Clients',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  methods: {
    initialize: function initialize() {
      // let that = this
      this.manager.deletable = function (item) {
        return false;
      };
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TopUps',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud_vue__["a" /* default */] },
  methods: {
    initialize: function initialize() {
      var that = this;
      this.manager.deletable = function (item) {
        return false;
      };
      this.manager.editable = function (item) {
        return false;
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'clientId') {
          return item.client ? item.client.name : that.defaultValue;
        } else if (header.value === 'amount') {
          return item.amount ? that.$app.formatMoney(item.amount) : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Categories',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  methods: {
    initialize: function initialize() {
      // let that = this
    }
  }

});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Products',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  methods: {
    initialize: function initialize() {
      var that = this;
      this.manager.toValue = function (header, item) {
        if (header.value === 'price') {
          return item.price ? that.$app.formatMoney(item.price) : that.$app.formatMoney(0);
        } else if (header.value === 'supplierPrice') {
          return item.price ? that.$app.formatMoney(item.supplierPrice) : that.$app.formatMoney(0);
        } else if (header.value === 'supplierId') {
          return item.supplier ? item.supplier.name : that.defaultValue;
        } else if (header.value === 'categoryId') {
          return item.category ? item.category.name : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
    }
  }

});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConnectionManager__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Deliveries',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_2__ConnectionManager__["a" /* default */], Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  data: function data() {
    return {
      item: null,
      currentItem: null,
      connecting: false,
      proceedWithCancel: false,
      viewDialogHere: false,
      changeUrgency: false,
      cancellationReason: '',
      viewableHeaders: [],
      viewItemHeaders: [],
      itemHeaders: [{ text: 'Name', value: 'product.name' }, { text: 'Destination', value: 'item.destinationName' }, { text: 'Recipient Name', value: 'item.recipientName' }, { text: 'Recipient Contact', value: 'item.recipientContact' }, { text: 'Quantity', value: 'item.quantity' }, { text: 'Status', value: 'item.status' }, { text: 'Received Time', value: 'item.receivedTime' }],
      extraOverflowActions: [{
        name: 'Cancel',
        key: 'cancel'
      }, {
        name: 'Change Urgency',
        key: 'change_urgency'
      }],
      filters: [{ value: 'AT_DEPARTMENT_HEAD', name: 'At Department Head' }, { value: 'AT_PURCHASING_HEAD', name: 'At purchasing Head' }, { value: 'REJECTED', name: 'Rejected' }, { value: 'PENDING_DELIVERY', name: 'Pending Pickup' }, { value: 'BEING_DELIVERED', name: 'In Progress' }, { value: 'DELIVERED', name: 'Delivered' }]
    };
  },

  methods: {
    close: function close() {
      this.item = null;
      this.viewDialogHere = false;
    },
    cancelDelivery: function cancelDelivery() {
      this.proceedWithCancel = false;
      var that = this;
      this.$refs.crud.$refs.connectionManager.patch('deliveries/' + this.item.id, {
        onSuccess: function onSuccess(response) {
          // that.items = []
          // that.items = that.items.concat(response.data.data)
          // that.$refs.crud.initialize()
          that.$refs.crud.updateItem(that.item);
        }
      }, {
        action: 'cancel',
        reason: that.cancellationReason
      });
    },
    changeDeliveryUrgency: function changeDeliveryUrgency() {
      this.changeUrgency = false;
      var that = this;
      this.$refs.crud.$refs.connectionManager.patch('deliveries/' + this.item.id, {
        onSuccess: function onSuccess(response) {
          // that.items = []
          // that.items = that.items.concat(response.data.data)
          that.$refs.crud.updateItem(response.data.data);
        }
      }, {
        action: 'change_urgency'
      });
    },
    initialize: function initialize() {
      var _this = this;

      var that = this;
      this.manager.editable = function (item) {
        return _this.isAdmin();
      };
      this.manager.deletable = function (item) {
        return false;
      };
      this.manager.creatable = function () {
        return false;
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'from') {
          return item.originFormattedAddress ? item.originFormattedAddress : that.defaultValue;
        }
        if (header.value === 'client') {
          return item.user && item.user.client ? item.user.client.name : that.defaultValue;
        }
        if (header.value === 'riderId') {
          return item.rider ? item.rider.name : that.defaultValue;
        }
        if (header.value === 'date') {
          return item.scheduleDate ? item.scheduleDate : that.defaultValue;
        }
        if (header.value === 'time') {
          return item.scheduleTime ? item.scheduleTime : that.defaultValue;
        }
        if (header.value === 'riderName') {
          return item.rider ? item.rider.name : that.defaultValue;
        }
        if (header.value === 'placedBy') {
          return item.user ? item.user.name + ' - ' + item.user.phone : that.defaultValue;
        }
        if (header.value === 'estimatedCost') {
          return item.estimatedCost ? that.$app.formatMoney(item.estimatedCost) : that.defaultValue;
        }
        if (header.value === 'urgent') {
          return item.urgent ? 'Urgent' : 'Not Urgent';
        }
        if (header.value === 'riderPhone') {
          return item.rider ? item.rider.phone : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
      this.manager.nameOnDelete = function (item) {
        return 'this order.';
      };
      this.manager.hasCustomView = function (item, viewableHeaders, viewItemHeaders) {
        that.item = item;
        that.viewDialogHere = false;
        that.viewDialogHere = true;
        that.viewableHeaders = viewableHeaders;
        that.viewItemHeaders = viewItemHeaders;
        return true;
      };
      this.manager.showInlineAction = function (action, item, filter) {
        if (action.key === 'dispatch' && filter) {
          return filter.value === 'PENDING_DISPATCH' && (_this.isAdmin() || _this.isOperations());
        }
        if (action.key === 'confirmReceived' && filter) {
          return filter.value === 'DISPATCHED' && _this.isDepartmentUser();
        } else {
          return true;
        }
      };
      this.manager.showTopAction = function (action, items, filter) {
        if ((action.key === 'approveAll' || action.key === 'rejectAll') && filter) {
          return (filter.value === 'AT_DEPARTMENT_HEAD' && _this.isDepartmentHead() || filter.value === 'AT_PURCHASING_HEAD' && _this.isPurchasingHead()) && items.length;
        } else {
          return true;
        }
      };
      this.manager.onTopAction = function (action, items, filter) {
        if (action.key === 'approveAll' || action.key === 'rejectAll') {
          _this.$refs.connectionManager.patch('orders/' + action, {
            onSuccess: function onSuccess(response) {
              that.$refs.crud.clearItems();
            }
          });
        }
      };
      this.manager.onInlineActionClicked = function (action, item, filter) {
        if (action.key === 'view') {
          that.$refs.crud.viewItem(item);
        } else if (action.key === 'dispatch') {
          that.viewableHeaders = that.$refs.crud.viewableHeaders;
          that.viewItemHeaders = that.$refs.crud.viewItemHeaders;
          that.dispatchingItem = item;
          that.dispatching = true;
        } else if (action.key === 'confirmReceived') {
          that.viewableHeaders = that.$refs.crud.viewableHeaders;
          that.viewItemHeaders = that.$refs.crud.viewItemHeaders;
          that.confirmingReceivedItem = item;
          that.confirmingReceived = true;
        }
      };
      this.manager.showExtraOverflowActions = function (action, filter) {
        if (action.key === 'cancel') {
          return filter.value === 'PENDING_DELIVERY' || filter.value === 'BEING_DELIVERED';
        } else {
          return true;
        }
      };
      this.manager.hideHeader = function (header, filter) {
        if (header.value === 'rejectedBy') {
          return filter.value === 'REJECTED';
        } else if (header.value === 'dispatchedAt') {
          return filter.value !== 'DISPATCHED' || that.isSupplier();
        } else if (header.value === 'dispatchedBy') {
          return filter.value !== 'DISPATCHED' || !that.isSupplier();
        } else if (header.value === 'receivedConfirmedAt') {
          return filter.value !== 'DELIVERED';
        } else if (header.value === 'receivedConfirmedBy') {
          return filter.value !== 'DELIVERED';
        } else if (header.value === 'dispatchRider') {
          return filter.value !== 'DISPATCHED';
        } else if (header.value === 'itemsReceivedFromSupplierCount') {
          return !that.isAdmin() && !that.isOperations();
        } else if (header.value === 'itemsNotReceivedFromSupplierCount') {
          return !that.isAdmin() && !that.isOperations();
        } else if (header.value === 'client') {
          return !that.isAdmin() && !that.isOperations();
        } else {
          return false;
        }
      };
      this.manager.fireAction = function (action, item) {
        that.item = item;
        if (action.key === 'change_urgency') {
          that.changeUrgency = true;
        } else if (action.key === 'cancel') {
          that.proceedWithCancel = true;
        }
      };
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrudBase_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Guide__ = __webpack_require__(33);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderedItems',
  extends: __WEBPACK_IMPORTED_MODULE_2__CrudBase_vue__["a" /* default */],
  components: {
    Guide: __WEBPACK_IMPORTED_MODULE_4__Guide__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__["a" /* default */],
    Crud: __WEBPACK_IMPORTED_MODULE_1__Crud__["a" /* default */]
  },
  data: function data() {
    return {
      rules: {
        required: function required(value) {
          return !!value || 'Required';
        },
        quantity: function quantity(value) {
          return !!value && parseInt(value) >= 1 && parseInt(value) <= 100 || 'Quantity should be 1 - 100';
        }
      },
      valid: true,
      connecting: false,
      selectingItems: false,
      selectedItems: [],
      adminAndOperationsFilters: [{ value: 'PENDING_LPO', name: 'Pending LPO' }, { value: 'ACCEPTED_BY_SUPPLIER', name: 'Accepted By Supplier' }, { value: 'REJECTED_BY_SUPPLIER', name: 'Rejected By Supplier' }, { value: 'RECEIVED_FROM_SUPPLIER', name: 'Received From Supplier' }],
      supplierFilters: [{ value: 'PENDING_LPO', name: 'Pending LPO' }, { value: 'ACCEPTED_BY_SUPPLIER', name: 'Accepted' }, { value: 'REJECTED_BY_SUPPLIER', name: 'Rejected' }, { value: 'RECEIVED_FROM_SUPPLIER', name: 'Delivered' }],
      clientFilters: [{ value: 'AT_DEPARTMENT_HEAD', name: 'At Department Head' }, { value: 'AT_PURCHASING_HEAD', name: 'At Purchasing Head' }, { value: 'APPROVED', name: 'Approved' }, { value: 'REJECTED', name: 'Rejected' }],
      extraTopActions: [{
        name: 'Select Items To Supply',
        key: 'generateLPO'
      }, {
        name: 'Select Items Approve',
        key: 'approveItems'
      }],
      items: [],
      headers: [{ text: 'Name', value: 'name' }, { text: 'Price', value: 'price' }, { text: 'Quantity', value: 'quantity' }, { text: 'Total', value: 'total' }],
      departmentHeadHeaders: [{ text: 'Product', value: 'name' }, { text: 'Quantity', value: 'quantity' }, { text: '', value: 'action', sortable: false }, { text: 'Price at Purchase', value: 'price' }, { text: 'Amount', value: 'amount' }],
      supplierHiddenHeaders: [{ text: 'Supplier' }]
    };
  },

  methods: {
    closeGeneratingLPODialog: function closeGeneratingLPODialog() {
      this.$refs.connectionManager.reset();
      this.selectingItems = false;
      this.selectedItems = [];
      this.item = null;
    },
    selectedItemsValid: function selectedItemsValid() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var orderItem = _step.value;

          if (!orderItem.quantity || orderItem.quantity < 0) {
            return false;
          }
          return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    approveItems: function approveItems() {
      var that = this;
      var orderItemIds = [];
      var quantities = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var orderItem = _step2.value;

          orderItemIds.push(orderItem.id);
          quantities.push(orderItem.quantity);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.$refs.connectionManager.post('rawOrderItems/approve', {
        onSuccess: function onSuccess(response) {
          that.$refs.crud.setItems(response.data.data);
          that.closeGeneratingLPODialog();
        }
      }, {
        items: orderItemIds.join(','), quantities: quantities.join(','), deliveryCost: that.deliveryCost
      });
    },
    generateLPO: function generateLPO() {
      var that = this;
      var orderItemIds = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var orderItem = _step3.value;

          orderItemIds.push(orderItem.id);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.$refs.connectionManager.post('orderItems/generateLPO', {
        onSuccess: function onSuccess(response) {
          that.$refs.crud.setItems(response.data.data);
          that.closeGeneratingLPODialog();
        }
      }, {
        items: orderItemIds.join(',')
      });
    },
    initialize: function initialize() {
      var _this = this;

      var that = this;
      this.manager.deletable = function (item) {
        return false;
      };
      this.manager.editable = function (item) {
        return false;
      };
      this.manager.toValue = function (header, item) {
        var that = _this;
        if (header.value === 'priceAtPurchase') {
          return item.priceAtPurchase ? that.$app.formatMoney(item.priceAtPurchase) : that.$app.formatMoney(0);
        } else if (header.value === 'supplierPriceAtPurchase') {
          return item.supplierPriceAtPurchase ? that.$app.formatMoney(item.supplierPriceAtPurchase) : that.$app.formatMoney(0);
        } else if (header.value === 'product') {
          return item.product ? item.product.name : that.defaultValue;
        } else if (header.value === 'amount') {
          if (that.isSupplier()) {
            return that.$app.formatMoney(item.supplierPriceAtPurchase * item.quantity);
          } else {
            return that.$app.formatMoney(item.priceAtPurchase * item.quantity);
          }
        } else if (header.value === 'supplier') {
          return item.product && item.product.supplier ? item.product.supplier.name : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
      this.manager.showTopAction = function (action, items, filter) {
        if (action.key === 'generateLPO' && filter) {
          return filter.value === 'PENDING_LPO' && items.length && _this.isSupplier();
        } else if (action.key === 'approveItems' && filter) {
          if (filter.value === 'AT_DEPARTMENT_HEAD') {
            return items.length && _this.isDepartmentHead();
          }
          if (filter.value === 'AT_PURCHASING_HEAD') {
            return items.length && _this.isPurchasingHead();
          }
        } else {
          return true;
        }
      };
      this.manager.onTopAction = function (action, items, filter) {
        that.items = items;
        // that.selectingItems = action.key === 'generateLPO'
        that.selectingItems = true;
      };

      this.manager.hideHeader = function (header, filter) {
        if (header.value === 'priceAtPurchase') {
          return that.isSupplier();
        }
        if (header.value === 'supplier' || header.value === 'supplierPriceAtPurchase' || header.value === 'status') {
          return that.isDepartmentUser() || that.isDepartmentHead() || that.isPurchasingHead();
        } else if (header.value === 'supplierPriceAtPurchase') {
          return that.isSupplier();
        } else {
          return false;
        }
      };
    }
  },
  computed: {
    totalCost: function totalCost() {
      var totalCostValue = 0.0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var orderItem = _step4.value;

          totalCostValue += orderItem.priceAtPurchase * orderItem.quantity;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return totalCostValue;
    },
    amountPayable: function amountPayable() {
      return this.deliveryCost + this.totalCost;
    },
    deliveryCost: function deliveryCost() {
      var deliveryCost = 0.0;
      if (this.totalCost > 0) {
        deliveryCost = 250;
      }
      return deliveryCost;
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrudBase_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadButton__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Guide__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FilePicker__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_pdf__ = __webpack_require__(692);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LPOs',
  extends: __WEBPACK_IMPORTED_MODULE_2__CrudBase_vue__["a" /* default */],
  components: {
    FilePicker: __WEBPACK_IMPORTED_MODULE_6__FilePicker__["a" /* default */],
    ConnectionManager: __WEBPACK_IMPORTED_MODULE_5__ConnectionManager__["a" /* default */],
    Guide: __WEBPACK_IMPORTED_MODULE_4__Guide__["a" /* default */],
    UploadButton: __WEBPACK_IMPORTED_MODULE_3__UploadButton__["a" /* default */],
    Crud: __WEBPACK_IMPORTED_MODULE_1__Crud__["a" /* default */],
    pdf: __WEBPACK_IMPORTED_MODULE_7_vue_pdf__["a" /* default */]
  },
  data: function data() {
    return {
      viewDocumentError: null,
      viewDocumentItem: null,
      viewDocument: false,
      documentLoadedProgress: 0,
      currentPage: 0,
      pageCount: 0,
      uploadingDeliveryNote: false,
      connecting: false,
      selectedItems: [],
      items: [],
      item: null,
      adminAndOperationsFilters: [{ value: 'pending', name: 'Pending' }, { value: 'received', name: 'Received' }],
      supplierFilters: [{ value: 'pending', name: 'New' }, { value: 'received', name: 'Delivered' }],
      headers: [{ text: 'Name', value: 'name' }, { text: 'Price', value: 'price' }, { text: 'Quantity', value: 'quantity' }, { text: 'Total', value: 'total' }],
      extraInlineActions: [{
        name: 'Upload Delivery Note & Invoice',
        color: 'accent',
        key: 'uploadDocuments'
      }, {
        name: 'View LPO',
        key: 'viewLPO',
        color: 'info'
      }, {
        name: 'View Delivery Note',
        key: 'viewDeliveryNote',
        color: 'success'
      }, {
        name: 'View Invoice',
        key: 'viewInvoice',
        color: 'error'
      }, {
        name: 'View',
        color: 'primary',
        key: 'view'
      }],
      supplierHiddenHeaders: [{ text: 'Supplier' }],
      deliveryNoteFile: null,
      invoiceFile: null
    };
  },

  methods: {
    onCloseViewDocument: function onCloseViewDocument() {
      this.viewDocument = false;
      this.viewDocumentItem = null;
      this.viewDocumentError = null;
      this.documentLoadedProgress = 0;
    },
    closeUploadingDeliveryNoteDialog: function closeUploadingDeliveryNoteDialog() {
      this.$refs.connectionManager.reset();
      this.uploadingDeliveryNote = false;
      this.selectedItems = [];
      this.item = null;
    },
    uploadDeliveryNote: function uploadDeliveryNote() {
      var itemIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          itemIds.push(item.id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var formData = new FormData();
      formData.append('deliveryNoteFile', this.deliveryNoteFile);
      formData.append('invoiceFile', this.invoiceFile);
      formData.append('items', itemIds.join(','));
      this.$app.log(formData);
      var that = this;
      this.$refs.connectionManager.upload('lpos/' + this.item.id + '/deliveryDocuments', {
        onSuccess: function onSuccess(response) {
          that.$refs.crud.removeItem(response.data.data);
          that.closeUploadingDeliveryNoteDialog();
          // alert(JSON.stringify(response))
        }
      }, formData);
    },
    onDeliveryNotePicked: function onDeliveryNotePicked(file) {
      this.deliveryNoteFile = file;
      this.$app.log(file);
    },
    onInvoicePicked: function onInvoicePicked(file) {
      this.invoiceFile = file;
      this.$app.log(file);
    },
    initialize: function initialize() {
      var that = this;
      this.manager.deletable = function (item) {
        return false;
      };
      this.manager.editable = function (item) {
        return false;
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'supplier') {
          return item.supplier ? item.supplier.name : that.defaultValue;
        } else if (header.value === 'deliveryNoteReceivedBy') {
          return item.deliveryNoteReceivedBy ? item.deliveryNoteReceivedBy.name : that.defaultValue;
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
      this.manager.hideHeader = function (header, filter) {
        return (header.value === 'deliveryNoteReceivedBy' || header.value === 'deliveryNoteReceivedAt') && filter.value === 'pending';
      };
      this.manager.onInlineActionClicked = function (action, item, filter) {
        // that.$app.log(item)
        if (action.key === 'view') {
          that.$refs.crud.viewItem(item);
        } else if (action.key === 'uploadDocuments') {
          that.items = item.items;
          that.item = item;
          that.uploadingDeliveryNote = true;
        } else {
          if (action.key === 'viewLPO') {
            that.viewDocumentSrc = that.$app.fileUrl(item.lpoPdfPath);
          } else if (action.key === 'viewInvoice') {
            that.viewDocumentSrc = that.$app.fileUrl(item.invoicePdfPath);
          } else {
            that.viewDocumentSrc = that.$app.fileUrl(item.deliveryNotePath);
          }
          // alert(that.viewDocumentSrc)
          // that.viewDocumentSrc = 'https://cdn.mozilla.net/pdfjs/tracemonkey.pdf'
          // this.$app.log(that.viewDocumentSrc)
          // that.viewDocument = true
          // that.viewDocumentItem = item
          window.open(that.viewDocumentSrc, '_blank');
        }
      };
      this.manager.showInlineAction = function (action, item, filter) {
        if (action.key === 'uploadDocuments') {
          return !item.deliveryNotePath && (that.isOperations() || that.isAdmin());
        } else {
          return filter.value === 'received';
        }
      };
    }
  },
  watch: {
    viewDocumentError: function viewDocumentError(val) {
      this.$app.log(val);
    }
  }

});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UploadButton',
  props: {
    selectedCallback: Function,
    title: String
  },
  methods: {
    fileSelected: function fileSelected(e) {
      if (this.selectedCallback) {
        if (e.target.files[0]) {
          this.selectedCallback(e.target.files[0]);
        } else {
          this.selectedCallback(null);
        }
      }
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilePicker',
  props: {
    label: {
      type: String,
      'default': 'Select input file...'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: '.pdf'
    },
    moreData: {
      default: ''
    },
    name: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      filename: this.label,
      file: null,
      dialog: false,
      message: ''
    };
  },

  methods: {
    reset: function reset() {
      this.file = null;
      this.dialog = false;
      this.filename = this.label;
    }
  },

  created: function created() {
    this.$upload.on(this.name, {
      startOnSelect: false,
      maxSizePerFile: 1024 * 1024 * 2,
      extensions: ['pdf'],
      body: {
        // report: this.report,
        data: this.moreData
      },
      onSuccess: function onSuccess(res) {},
      onError: function onError(error) {
        console.error(error);
      },
      onSelect: function onSelect(files) {
        this.file = files[0];
        this.filename = files[0].name;
        this.$emit('onFilePicked', files[0]);
        /* files[0].preview((file) => {
          // this.brandImage = file.raw
          console.info('File Content ' + file.raw)
        }) */
      }
    });
  },
  mounted: function mounted() {
    this.reset();
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentFactory_js__ = __webpack_require__(694);
//




if (Object({"NODE_ENV":"production"}).VUE_ENV === 'server') {

	var component = Object(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])({});
} else {

	var pdfjsWrapper = __webpack_require__(697).default;
	var PDFJS = __webpack_require__(805);
	var component = Object(__WEBPACK_IMPORTED_MODULE_0__componentFactory_js__["a" /* default */])(pdfjsWrapper(PDFJS));
}

/* harmony default export */ __webpack_exports__["a"] = (component);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateInput__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_3__ConnectionManager__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_1__DateInput__["a" /* default */] },
  name: 'Billing',
  extends: __WEBPACK_IMPORTED_MODULE_0__Base_vue__["a" /* default */],
  data: function data() {
    return {
      adminHeaders: [{ text: 'Id', sortable: false, value: 'id' }, { text: 'Client', sortable: false, value: 'client' }, { text: 'Amount', sortable: false, value: 'amount' }, { text: 'Status', sortable: false, value: 'status' }, { text: 'Description', sortable: false, value: 'description' }, { text: 'Date/Time', sortable: false, value: 'createdAt' }],
      clientHeaders: [{ text: 'Id', sortable: false, value: 'id' }, { text: 'Amount', sortable: false, value: 'amount' }, { text: 'Status', sortable: false, value: 'status' }, { text: 'Description', sortable: false, value: 'description' }, { text: 'Date/Time', sortable: false, value: 'createdAt' }],
      search: '',
      filter: 'courier',
      connecting: false,
      month: null,
      minMonth: null,
      maxMonth: null,
      rowsPerPageItems: [6, 10, 20],
      pagination: {
        rowsPerPage: 6
      },
      items: []
    };
  },

  methods: {
    refresh: function refresh() {
      // this.$refs.dataTable.pageStart = 0
      this.items = [];
      var that = this;
      this.$app.log('This month is: ' + this.month);
      this.$refs.connectionManager.get('bills', {
        onSuccess: function onSuccess(response) {
          that.items = that.items.concat(response.data.data);
        }
      }, { filter: this.filter, month: this.month });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // react to route changes...
      if (to.params.filter !== this.filter) {
        this.filter = to.params.filter;
      }
    },
    month: function month(_month) {
      if (_month && this.filter && !this.connecting) {
        this.refresh();
      }
    },
    filter: function filter(val) {
      if (this.month && val && !this.connecting) {
        this.refresh();
      }
    }
  },
  mounted: function mounted() {
    var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
    var todayMonth = today.month() + 1;
    if (todayMonth < 10) {
      todayMonth = '0' + todayMonth;
    }

    if (this.isAdmin() || this.isOperations()) {
      this.month = today.year() + '-' + todayMonth;
    } else {
      var dateClientJoined = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.$auth.user().client.createdAt);
      this.minMonth = dateClientJoined.year() + '-' + dateClientJoined.month();
      this.maxMonth = today.year() + '-' + (today.month() + 2);
      this.month = today.year() + '-' + todayMonth;
    }
  },
  created: function created() {
    this.filter = this.$route.params.filter;
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GooglePlaceInput__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Guide__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConnectionManager__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddDeliveryItemDialog__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateInput__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TimeInput__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(27);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-undef */











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddDelivery',
  components: { TimeInput: __WEBPACK_IMPORTED_MODULE_11__TimeInput__["a" /* default */], DateInput: __WEBPACK_IMPORTED_MODULE_10__DateInput__["a" /* default */], AddDeliveryItemDialog: __WEBPACK_IMPORTED_MODULE_8__AddDeliveryItemDialog__["a" /* default */], ConnectionManager: __WEBPACK_IMPORTED_MODULE_7__ConnectionManager__["a" /* default */], Guide: __WEBPACK_IMPORTED_MODULE_6__Guide__["a" /* default */], GooglePlaceInput: __WEBPACK_IMPORTED_MODULE_4__GooglePlaceInput__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      dialog: false,
      addingItem: false,
      connecting: false,
      step: 1,
      originInput: '',
      originName: null,
      originFormattedAddress: null,
      originVicinity: null,
      originPosition: null,
      isAnEdit: false,
      items: [],
      addressDetails: null,
      courierOptions: [],
      costVariables: [],
      selectedItem: null,
      selectedItemIndex: -1,
      directionsService: new google.maps.DirectionsService(),
      calculatingDirections: false,
      scheduleDate: null,
      // currentDate: moment().format('YYYY-MM-DD'),
      // currentTime: moment().add(1, 'hours').format('HH:mm'),
      allowedDates: {
        dates: function dates(date) {
          var givenDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, 'YYYY/MM/DD');
          if (givenDate.day() === 0) {
            return false;
          }
          if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() > 15 && __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() < 24) {
            return givenDate.diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(), 'days', true) > 0;
          }
          if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().isSame(givenDate, 'day')) {
            return true;
          }
          return givenDate.diff(__WEBPACK_IMPORTED_MODULE_9_moment___default()(), 'days', true) >= 0;
        }
      },
      scheduleTime: null,
      urgent: false,
      itemWithLongestDistance: null,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      },
      invalidTimeErrorMessage: 'Pickup time should be between 8a.m and 4p.m and can\'t be lower than the current time'
    };
  },

  computed: {
    invalidTime: function invalidTime() {
      if (this.scheduleTime) {
        var selectedTime = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.scheduleTime, 'HH:mm');
        var onePM = __WEBPACK_IMPORTED_MODULE_9_moment___default()('13:01', 'HH:mm');
        var fourPM = __WEBPACK_IMPORTED_MODULE_9_moment___default()('16:01', 'HH:mm');
        var hour = selectedTime.hour();
        if (this.scheduleDate) {
          if (__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.scheduleDate, 'YYYY/MM/DD').day() === 6) {
            if (!(hour >= 8 && selectedTime.isBefore(onePM, 'minutes'))) {
              this.invalidTimeErrorMessage = 'Pickup time should be between 8a.m and 1p.m and can\'t be lower than the current time';
              return true;
            } else {
              return false;
            }
          }
          if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().isSame(__WEBPACK_IMPORTED_MODULE_9_moment___default()(this.scheduleDate, 'YYYY/MM/DD'), 'day')) {
            if (!(hour >= 8 && selectedTime.isBefore(fourPM, 'minutes') && hour >= __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() + 1)) {
              this.invalidTimeErrorMessage = 'Pickup time should be between 8a.m and 4p.m and can\'t be lower than the current time';
              return true;
            } else {
              return false;
            }
          }
        }
        this.invalidTimeErrorMessage = 'Pickup time should be between 8a.m and 4p.m and can\'t be lower than the current time';
        return !(hour >= 8 && hour <= 16);
      } else {
        return false;
      }
    },
    invalidDate: function invalidDate() {
      if (this.scheduleDate) {
        var selectedDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.scheduleDate, 'YYYY/MM/DD');
        return selectedDate.day() === 0;
      } else {
        return false;
      }
    },
    currentDate: function currentDate() {
      if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() > 15 && __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() < 24) {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()().add(1, 'days').format('YYYY-MM-DD');
      }
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD');
    },
    currentTime: function currentTime() {
      if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() === 7) {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()().add(1, 'hours').format('HH:mm');
      } else if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() > 15 && __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() < 24) {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()('08:00', ['HH:mm'], true).format('HH:mm');
      } else if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() >= 24 && __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() < 7) {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()('08:00', ['HH:mm'], true).format('HH:mm');
        // return moment().add(1, 'hours').format('HH:mm')
      }
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()().add(1, 'hours').format('HH:mm');
    },
    estimatedCost: function estimatedCost() {
      if (this.items.length > 0) {
        var timeCost = 0;
        var distanceCost = 0;
        var baseCost = 0;
        var totalCost = 0;
        // calculate the longest distance of the trip
        var estimatedMaxDistance = 0;
        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          if (item.distance > estimatedMaxDistance) {
            estimatedMaxDistance = item.distance;
            this.itemWithLongestDistance = item;
          }
          // the code below can be improved
          var distance = item.distance / 1000;
          var duration = item.duration / 60;
          if (this.urgent) {
            if (item.courierOption.id === 3) {
              distanceCost = this.costVariables.ERRAND_COST_PER_KM * distance;
              timeCost = this.costVariables.ERRAND_COST_PER_MIN * duration;
              baseCost = this.costVariables.ERRAND_BASE_COST;
            } else {
              distanceCost = this.costVariables.URGENT_COST_PER_KM * distance;
              timeCost = this.costVariables.URGENT_COST_PER_MIN * duration;
              baseCost = this.costVariables.URGENT_BASE_COST;
            }
          } else {
            if (item.courierOption.id === 3) {
              distanceCost = this.costVariables.ERRAND_COST_PER_KM * distance;
              timeCost = this.costVariables.ERRAND_COST_PER_MIN * duration;
              baseCost = this.costVariables.ERRAND_BASE_COST;
            } else {
              distanceCost = this.costVariables.NON_URGENT_COST_PER_KM * distance;
              timeCost = this.costVariables.NON_URGENT_COST_PER_MIN * duration;
              baseCost = this.costVariables.NON_URGENT_BASE_COST;
            }
          }
          this.$app.log('distance: ' + distance);
          this.$app.log('duration: ' + duration);
          this.$app.log('distanceCost: ' + distanceCost);
          this.$app.log('timeCost: ' + timeCost);
          this.$app.log('baseCost: ' + baseCost);
          var itemTotalCost = baseCost + timeCost + distanceCost;
          itemTotalCost += item.stops.length * 30;
          var totalInclusiveProfitMargin = 1.6 * itemTotalCost;
          var valueAddedTax = 0.16 * totalInclusiveProfitMargin;
          itemTotalCost = totalInclusiveProfitMargin + valueAddedTax;
          if (this.urgent) {
            if (itemTotalCost < this.costVariables.URGENT_MIN_COST) {
              itemTotalCost = this.costVariables.URGENT_MIN_COST;
            }
          } else {
            if (itemTotalCost < this.costVariables.NON_URGENT_MIN_COST) {
              itemTotalCost = this.costVariables.NON_URGENT_MIN_COST;
            }
          }
          this.items[i].itemTotalDeliveryCost = itemTotalCost;
          totalCost += itemTotalCost;
        }
        return totalCost;
      }
      return 0;
    },

    invalidForm: function invalidForm() {
      return !this.addressDetails;
    },
    allowedTimes: function allowedTimes() {
      return {
        hours: function hours(value) {
          if (this.scheduleDate) {
            if (this.scheduleDate.day() === 6) {
              return value >= 8 && value <= 13 && value >= __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() + 1;
            }
            if (__WEBPACK_IMPORTED_MODULE_9_moment___default()().isSame(this.scheduleDate, 'day')) {
              return value >= 8 && value <= 16 && value >= __WEBPACK_IMPORTED_MODULE_9_moment___default()().hour() + 1;
            }
          }
          return value >= 8 && value <= 16;
          // return value >= moment().hour()
        },
        minutes: function minutes(value) {
          return value % 15 === 0;
        }
      };
    }
  },
  watch: {
    show: function show(val) {
      this.dialog = !!val;
    },
    originPosition: function originPosition(val) {
      if (this.items.length > 0) {
        var itemsCopy = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.items));
        this.items = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(itemsCopy), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            this.onAddItem(item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.$app.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(val));
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["d" /* mapMutations */])({
    setSelectedItem: 'setSelectedItem'
  }), {
    onOriginEntered: function onOriginEntered(addressData, placeResultData) {
      this.originFormattedAddress = placeResultData.formatted_address;
      this.originVicinity = placeResultData.vicinity;
      this.originName = placeResultData.name;
      this.originPosition = {
        lat: placeResultData.geometry.location.lat(),
        lng: placeResultData.geometry.location.lng()
      };
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* default */].$emit('onOriginChanged', this.originPosition);
    },
    onClose: function onClose(successful) {
      this.step = 1;
      this.originPosition = null;
      this.originFormattedAddress = null;
      this.originVicinity = null;
      this.note = null;
      this.urgent = false;
      this.scheduleDate = null;
      this.scheduleTime = null;
      this.items = [];
      this.itemWithLongestDistance = null;
      this.addingItem = false;
      this.isAnEdit = false;
      this.$refs.originInput.clear();
      this.$emit('onClose', successful);
    },
    onAddItem: function onAddItem(item, isAnEdit) {
      this.addingItem = false;
      this.isAnEdit = false;
      this.calculatingDirections = true;
      var that = this;
      var waypts = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(item.stops), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var stop = _step2.value;

          waypts.push({
            location: stop.stop_formatted_address,
            stopover: true
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.directionsService.route({
        origin: this.originPosition.lat + ',' + this.originPosition.lng,
        destination: item.destinationPosition.lat + ',' + item.destinationPosition.lng,
        waypoints: waypts,
        optimizeWaypoints: false,
        travelMode: 'DRIVING'
      }, function (result, status) {
        that.$app.log(result);
        if (status === 'OK') {
          item.distance = 0;
          item.duration = 0;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(result.routes[0].legs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var leg = _step3.value;

              item.distance = item.distance + leg.distance.value;
              item.duration = item.duration + leg.duration.value;
            }
            // if (that.originPosition.lat === item.destinationPosition.lat && that.originPosition.lng === item.destinationPosition.lng) {
            //   item.distance = item.distance * 2
            // }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          that.items.push(item);
          that.calculatingDirections = false;
          that.$app.log('The total distance is: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item));
        } else {
          that.$app.log('Directions request failed due to ' + status);
        }
      });
    },
    editItem: function editItem(item, index) {
      this.setSelectedItem(item);
      this.selectedItem = item;
      this.selectedItemIndex = index;
      this.addingItem = true;
      this.isAnEdit = true;
    },
    deleteItem: function deleteItem(item, index) {
      this.items.splice(index, 1);
    },
    submit: function submit() {
      this.error = false;
      var deliveryItems = [];
      var estimatedCost = Math.ceil(this.estimatedCost);
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          deliveryItems.push({
            destinationName: item.destinationName,
            destinationVicinity: item.destinationVicinity,
            destinationFormattedAddress: item.destinationFormattedAddress,
            destinationLatitude: item.destinationPosition.lat,
            destinationLongitude: item.destinationPosition.lng,
            estimatedDistance: item.distance,
            estimatedDuration: item.duration,
            stops: item.stops,
            note: item.note,
            itemTotalDeliveryCost: item.itemTotalDeliveryCost,
            recipientContact: item.recipientContact,
            recipientName: item.recipientName,
            quantity: item.quantity,
            courierOptionId: item.courierOption.id
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.$app.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(deliveryItems));
      var that = this;
      this.$refs.connectionManager.post('/deliveries', {
        onSuccess: function onSuccess(response) {
          that.onClose(true);
          __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* default */].$emit(that.$actions.addedDelivery);
          that.$app.log(response);
          var filter = 'pendingApproval';
          that.$router.push({ name: 'courier', params: { filter: filter } });
        }
      }, {
        urgent: this.urgent,
        originName: this.originName,
        addressDetails: this.addressDetails,
        originVicinity: this.originVicinity,
        originFormattedAddress: this.originFormattedAddress,
        originLatitude: this.originPosition.lat,
        originLongitude: this.originPosition.lng,
        scheduleDate: this.scheduleDate,
        scheduleTime: this.scheduleTime,
        estimatedCost: estimatedCost,
        estimatedMaxDistance: this.itemWithLongestDistance.distance,
        estimatedMaxDuration: this.itemWithLongestDistance.duration,
        items: deliveryItems,
        maintenance: 'maintenance'
      });
    },
    goStepTwo: function goStepTwo() {
      if (!this.courierOptions.length) {
        var that = this;
        // Load courier options
        this.$refs.connectionManager.get('/courierOptions', {
          onSuccess: function onSuccess(response) {
            that.$app.log(response.data.data);
            that.$app.log(response.data.variables);
            that.costVariables = response.data.costVariables;
            that.courierOptions = that.courierOptions.concat(response.data.data);
            that.step = 2;
          }
        }, { withCostVariables: true });
      } else {
        this.step = 2;
      }
    }
  }),
  mounted: function mounted() {
    this.scheduleTime = this.currentTime;
    this.scheduleDate = this.currentDate;
    __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* default */].$on('onOriginChanged', function (payload) {});
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Crud__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConnectionManager__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeliveryItems',
  extends: __WEBPACK_IMPORTED_MODULE_1__CrudBase_vue__["a" /* default */],
  components: { ConnectionManager: __WEBPACK_IMPORTED_MODULE_2__ConnectionManager__["a" /* default */], Crud: __WEBPACK_IMPORTED_MODULE_0__Crud__["a" /* default */] },
  data: function data() {
    return {
      item: null,
      viewDialogHere: false,
      connecting: false,
      viewableHeaders: [],
      viewItemHeaders: [],
      itemHeaders: [{ text: 'Type', value: 'item.type' }, { text: 'Name', value: 'item.stopName' }, { text: 'Vicinity', value: 'item.stopVicinity' }, { text: 'Address', value: 'item.stopFormattedAddress' }, { text: 'Stop Latitude', value: 'item.stopLatitude' }, { text: 'Stop Longitude', value: 'item.stopLongitude' }],
      filters: [{ value: 'PENDING_PICKUP', name: 'Pending Pickup' }, { value: 'EN_ROUTE_TO_DESTINATION', name: 'On Progress' }, { value: 'AT_DESTINATION', name: 'At Destination' }]
    };
  },

  methods: {
    close: function close() {
      this.item = null;
      this.viewDialogHere = false;
    },
    initialize: function initialize() {
      var _this = this;

      var that = this;
      this.manager.editable = function (item) {
        return false;
      };
      this.manager.deletable = function (item) {
        return false;
      };
      this.manager.creatable = function () {
        return false;
      };
      this.manager.toValue = function (header, item) {
        if (header.value === 'courierOptionName') {
          return item.courierOption ? item.courierOption.name : that.defaultValue;
        }if (header.value === 'deliveryRider') {
          if (item.delivery) {
            return item.delivery.rider ? item.delivery.rider.name + ' - ' + item.delivery.rider.phone : that.defaultValue;
          } else {
            return '';
          }
        }if (header.value === 'addressDetails') {
          return item.delivery ? item.delivery.addressDetails : that.defaultValue;
        }if (header.value === 'pickupLocation') {
          return item.delivery ? item.delivery.originName : that.defaultValue;
        }if (header.value === 'deliveryClient') {
          return item.delivery ? item.delivery.user.client.name : that.defaultValue;
        }if (header.value === 'scheduled') {
          return item.delivery ? item.delivery.scheduleDate + '-' + item.delivery.scheduleTime : that.defaultValue;
        }if (header.value === 'bookedBy') {
          return item.delivery ? item.delivery.user.name + '-' + item.delivery.user.phone : that.defaultValue;
        }if (header.value === 'urgency') {
          if (item.delivery) {
            if (item.delivery.urgent === 1) {
              return 'Urgent';
            } else {
              return 'Non-Urgent';
            }
          }
        }if (header.value === 'pickupAddress') {
          return item.delivery ? item.delivery.originFormattedAddress : that.defaultValue;
        }if (header.value === 'estimatedDeliveryCost') {
          return that.$app.formatMoney(item.estimatedDeliveryCost);
        }if (header.value === 'deliveryCost') {
          return that.$app.formatMoney(item.deliveryCost);
        }if (header.value === 'stopTime') {
          return that.$app.timeToMin(item.stopTime);
        }if (header.value === 'timeTaken') {
          return that.$app.timeToMin(item.timeTaken);
        }if (header.value === 'totalDistance') {
          return that.$app.distanceToKm(item.totalDistance);
        } else {
          return item[header.value] ? item[header.value] : that.defaultValue;
        }
      };
      this.manager.nameOnDelete = function (item) {
        return 'this order.';
      };
      this.manager.hasCustomView = function (item, viewableHeaders, viewItemHeaders) {
        that.item = item;
        _this.$app.log('The items are ' + item.stops);
        that.viewDialogHere = true;
        that.viewableHeaders = viewableHeaders;
        that.viewItemHeaders = viewItemHeaders;
        return true;
      };
      this.manager.showInlineAction = function (action, item, filter) {
        if (action.key === 'dispatch' && filter) {
          return filter.value === 'PENDING_DISPATCH' && (_this.isAdmin() || _this.isOperations());
        }
        if (action.key === 'confirmReceived' && filter) {
          return filter.value === 'DISPATCHED' && _this.isDepartmentUser();
        } else {
          return true;
        }
      };
      this.manager.showTopAction = function (action, items, filter) {
        if ((action.key === 'approveAll' || action.key === 'rejectAll') && filter) {
          return (filter.value === 'AT_DEPARTMENT_HEAD' && _this.isDepartmentHead() || filter.value === 'AT_PURCHASING_HEAD' && _this.isPurchasingHead()) && items.length;
        } else {
          return true;
        }
      };
      this.manager.onTopAction = function (action, items, filter) {
        if (action.key === 'approveAll' || action.key === 'rejectAll') {
          _this.$refs.connectionManager.patch('orders/' + action, {
            onSuccess: function onSuccess(response) {
              that.$refs.crud.clearItems();
            }
          });
        }
      };
      this.manager.onInlineActionClicked = function (action, item, filter) {
        if (action.key === 'view') {
          that.$refs.crud.viewItem(item);
        } else if (action.key === 'dispatch') {
          that.viewableHeaders = that.$refs.crud.viewableHeaders;
          that.viewItemHeaders = that.$refs.crud.viewItemHeaders;
          that.dispatchingItem = item;
          that.dispatching = true;
        } else if (action.key === 'confirmReceived') {
          that.viewableHeaders = that.$refs.crud.viewableHeaders;
          that.viewItemHeaders = that.$refs.crud.viewItemHeaders;
          that.confirmingReceivedItem = item;
          that.confirmingReceived = true;
        }
      };
      this.manager.hideHeader = function (header, filter) {
        // if (header.value === 'destinationName' || header.value === 'destinationFormattedAddress') {
        //   return filter.value === 'PENDING_PICKUP'
        // } else {
        //   return false
        // }
      };

      this.manager.fireAction = function (action, item) {
        that.$app.log(action.key);
      };
    }
  }
});

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios_progress_bar__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios_progress_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notification__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios_progress_bar_dist_nprogress_css__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios_progress_bar_dist_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios_progress_bar_dist_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_timeago__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jspdf__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__websanova_vue_upload__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__websanova_vue_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__websanova_vue_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_full_calendar__ = __webpack_require__(858);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__websanova_vue_upload___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_notification___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_jspdf___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */];
// Vue.store = store

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(863), {
  auth: __webpack_require__(867),
  http: __webpack_require__(868),
  router: __webpack_require__(869),
  fetchData: { url: 'auth', method: 'GET', enabled: true },
  registerData: { url: 'auth/signUp', method: 'POST', redirect: { name: 'dashboard' } },
  loginData: { url: 'auth/signIn', method: 'POST', redirect: { name: 'dashboard' }, fetchUser: true },
  logoutData: { url: 'auth/signOut', method: 'POST', redirect: { name: 'signIn' }, makeRequest: true },
  refreshData: { url: 'auth/refresh', method: 'GET', enabled: false, interval: 0 },
  authRedirect: { path: 'auth/signIn' }
});
__webpack_require__(870);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a, {
  theme: {
    primary: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */].primaryColor,
    secondary: '#424242',
    accent: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */].accentColor,
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_full_calendar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_timeago__["a" /* default */], {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    // 'en-US': require('vue-timeago/locales/en-US.json')
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  // provide the router using the "router" option.
  // this will inject the router instance to all child components.
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  http: {
    emulateJSON: true,
    emulateHTTP: true
  },
  template: '<Application></Application>',
  components: { Application: __WEBPACK_IMPORTED_MODULE_5__App_vue__["a" /* default */] },
  data: function data() {
    return {
      test: 'This is a test in the app'
    };
  },
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_2_axios_progress_bar__["loadProgressBar"])();
  }
});

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */,
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ba58b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(444);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35ba58b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7db994fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(426);
function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7db994fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7db994fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__(139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3471a3c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__(440);
function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3471a3c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3471a3c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"fixed":"","dense":"","color":_vm.darkTheme ? 'black' : 'white',"app":"","clipped-left":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.onToolbarSideIconClick($event)}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(146),"height":"32px","width":"200px"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$route.name === 'newOrder')?_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onToolbarCartIconClicked($event)}}},[_c('v-badge',{attrs:{"overlap":"","small":"","color":"accent"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.cartProductsCount))]),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("shopping_cart")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(!_vm.$auth.check())?_c('v-btn',{attrs:{"to":"signIn","flat":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("person")]),_vm._v("\n            Sign In\n        ")],1):_vm._e(),_vm._v(" "),(_vm.$auth.check())?_c('v-btn',{attrs:{"small":"","flat":""}},[_c('v-icon',{attrs:{"color":"primary","left":""}},[_vm._v("check_circle\n            ")]),_vm._v("\n            Home / "+_vm._s(_vm.$route.name)+"\n        ")],1):_vm._e(),_vm._v(" "),(_vm.$auth.check() && _vm.$auth.user().client)?_c('v-menu',{attrs:{"offset-y":"","bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","color":_vm.accountButtonColor},slot:"activator"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("account_balance_wallet")]),_vm._v("\n                Account\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(_vm.$auth.user().client.logo),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$auth.user().client.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$auth.user().client.email))])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-2"}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_vm._v("Balance "+_vm._s(_vm.$app.formatMoney(_vm.balance.actual))+"\n                        ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption text--accent"},[_vm._v("\n                            Actual amount in your account incl. blocked\n                        ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_vm._v("Limit "+_vm._s(_vm.$app.formatMoney(_vm.balance.limit))+"\n                        ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption text--accent"},[_vm._v("\n                            Maximum amount you can spend with a zero balance\n                        ")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-2"}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_vm._v("Spent "+_vm._s(_vm.$app.formatMoney(_vm.balance.spent))+"\n                        ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption text--accent-1"},[_vm._v("\n                            Actual amount spent\n                        ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_vm._v("Blocked "+_vm._s(_vm.$app.formatMoney(_vm.balance.blocked))+"\n                        ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption text--accent"},[_vm._v("\n                            Amount charged pending service completion\n                        ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-chip',{attrs:{"label":"","small":"","color":"accent","text-color":"white"}},[_vm._v("\n                            You are on "+_vm._s(_vm.$auth.user().client.accountType)+" account\n                        ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){return _vm.refreshBalance($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("refresh")]),_vm._v("\n                            Refresh\n                        ")],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),(_vm.$auth.check())?_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":_vm.signOut}},[_vm._v("\n                Sign Out\n            ")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af21d6ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af21d6ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af21d6ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"clipped":"","fixed":"","permanent":"","disable-route-watcher":true,"stateless":"","width":250,"mini-variant":_vm.mini,"app":""},on:{"update:miniVariant":function($event){_vm.mini=$event}},model:{value:(_vm.drawerOpen),callback:function ($$v) {_vm.drawerOpen=$$v},expression:"drawerOpen"}},[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":"","tag":"div"}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(_vm.$auth.user().avatar)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_c('b',[_vm._v(_vm._s(_vm.$auth.user().name))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$auth.user().email))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item,index){return [(item.group)?_c('v-list-group',{key:index,attrs:{"append-icon":item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_right',"prepend-icon":item.icon},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.title)+"\n            ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":{name: child.route, params: child.params}}},[(child.icon)?_c('v-list-tile-action'):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(child.title)+"\n            ")])],1)],1)})],2):(item.children)?_c('v-list-group',{key:index,attrs:{"append-icon":item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_right',"prepend-icon":item.icon},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.title)+"\n            ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":{name: item.route, params: child.params}}},[(child.icon)?_c('v-list-tile-action'):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(child.title)+"\n            ")])],1)],1)})],2):_c('v-list-tile',{key:index,attrs:{"to":{name: item.route}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n            "+_vm._s(item.title)+"\n          ")])],1)],1)]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.ready())?_c('div',[_c('v-app',{attrs:{"dark":_vm.darkTheme}},[(_vm.$auth.check())?_c('drawer'):_vm._e(),_vm._v(" "),_c('toolbar'),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"grid-list-xs":"","fluid":"","fill-height":""}},[(_vm.$route.name !== 'signIn' && _vm.$auth.check() && !_vm.$auth.user().client && !_vm.isAdmin() && !_vm.isOperations() && !_vm.isSupplier())?_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","flat":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Authorization Required")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{staticClass:"headline",attrs:{"outline":"","color":"error","icon":"warning","value":true}},[_vm._v("\n                    Sorry! Your are not yet authorized to access "),_c('b',[_vm._v(_vm._s(_vm.$appName))])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.contact($event)}}},[_vm._v("Contact "+_vm._s(_vm.$appName)+"\n                  ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","flat":""},nativeOn:{"click":function($event){return _vm.signOut($event)}}},[_vm._v("Sign Out\n                  ")])],1)],1)],1)],1):_c('router-view'),_vm._v(" "),_c('notifications',{attrs:{"group":"all"}})],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":"","color":"primary","dark":"","fixed":false}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","py-3":"","text-xs-center":"","white--text":""}},[_vm._v("\n            ©2019 — "),_c('strong',[_vm._v("www.cube-messenger.com")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","py-3":"","white--text":""}},[_vm._v("\n            Powered By — "),_c('strong',[_c('a',{staticClass:"accent-4",staticStyle:{"color":"#FFFFFF"},attrs:{"target":"_blank","href":"http://thinksynergy.co.ke/"}},[_vm._v("Think Synergy Limited")])])])],1)],1)],1)],1):_c('div',[_c('loader')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Courier_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Appointments_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Subscriptions_vue__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddSubscription_vue__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AdminSubscriptions_vue__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SignIn_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Shopping_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ItServices__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RepairServices__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Orders__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Users__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Profile__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Departments__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Clients__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Roles__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_TopUps__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Categories__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Products__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Deliveries__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_OrderedItems__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_LPOs__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Billing__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_AddDelivery__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_DeliveryItems__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_router__ = __webpack_require__(821);




























__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_26_vue_router__["a" /* default */]({
  hashbang: true,
  linkActiveClass: 'active',
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/dashboard'
  }, {
    meta: { auth: false },
    path: '/auth/signIn',
    name: 'signIn',
    component: __WEBPACK_IMPORTED_MODULE_5__components_SignIn_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/clients',
    name: 'clients',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Clients__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/deliveries',
    name: 'deliveries',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Deliveries__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/deliveryItems',
    name: 'deliveryItems',
    component: __WEBPACK_IMPORTED_MODULE_24__components_DeliveryItems__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/newDelivery',
    name: 'newDelivery',
    component: __WEBPACK_IMPORTED_MODULE_23__components_AddDelivery__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/roles',
    name: 'roles',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Roles__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/lpos',
    name: 'lpos',
    component: __WEBPACK_IMPORTED_MODULE_21__components_LPOs__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/topUps',
    name: 'topUps',
    component: __WEBPACK_IMPORTED_MODULE_16__components_TopUps__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/billing/:filter',
    name: 'billing',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Billing__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/courier/:filter',
    name: 'courier',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Courier_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/newOrder',
    name: 'newOrder',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Shopping_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/orderedItems',
    name: 'orderedItems',
    component: __WEBPACK_IMPORTED_MODULE_20__components_OrderedItems__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/orders',
    name: 'orders',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Orders__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/appointments',
    name: 'appointments',
    component: __WEBPACK_IMPORTED_MODULE_1__components_Appointments_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/subscriptions/:filter',
    name: 'subscriptions',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Subscriptions_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/newSubscription',
    name: 'newSubscription',
    component: __WEBPACK_IMPORTED_MODULE_3__components_AddSubscription_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/adminSubscriptions/:filter',
    name: 'adminSubscriptions',
    component: __WEBPACK_IMPORTED_MODULE_4__components_AdminSubscriptions_vue__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/users',
    name: 'users',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Users__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/products',
    name: 'products',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Products__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/categories',
    name: 'categories',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Categories__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/orderItems',
    name: 'orderItems',
    component: __WEBPACK_IMPORTED_MODULE_20__components_OrderedItems__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/departments',
    name: 'departments',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Departments__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/profile',
    name: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Profile__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/repairs',
    name: 'repairs',
    component: __WEBPACK_IMPORTED_MODULE_9__components_RepairServices__["a" /* default */]
  }, {
    meta: { auth: true },
    path: '/it',
    name: 'it',
    component: __WEBPACK_IMPORTED_MODULE_8__components_ItServices__["a" /* default */]
  }]
}));

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Courier_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae05ef9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Courier_vue__ = __webpack_require__(516);
function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Courier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae05ef9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Courier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 149,
	"./af.js": 149,
	"./ar": 150,
	"./ar-dz": 151,
	"./ar-dz.js": 151,
	"./ar-kw": 152,
	"./ar-kw.js": 152,
	"./ar-ly": 153,
	"./ar-ly.js": 153,
	"./ar-ma": 154,
	"./ar-ma.js": 154,
	"./ar-sa": 155,
	"./ar-sa.js": 155,
	"./ar-tn": 156,
	"./ar-tn.js": 156,
	"./ar.js": 150,
	"./az": 157,
	"./az.js": 157,
	"./be": 158,
	"./be.js": 158,
	"./bg": 159,
	"./bg.js": 159,
	"./bm": 160,
	"./bm.js": 160,
	"./bn": 161,
	"./bn.js": 161,
	"./bo": 162,
	"./bo.js": 162,
	"./br": 163,
	"./br.js": 163,
	"./bs": 164,
	"./bs.js": 164,
	"./ca": 165,
	"./ca.js": 165,
	"./cs": 166,
	"./cs.js": 166,
	"./cv": 167,
	"./cv.js": 167,
	"./cy": 168,
	"./cy.js": 168,
	"./da": 169,
	"./da.js": 169,
	"./de": 170,
	"./de-at": 171,
	"./de-at.js": 171,
	"./de-ch": 172,
	"./de-ch.js": 172,
	"./de.js": 170,
	"./dv": 173,
	"./dv.js": 173,
	"./el": 174,
	"./el.js": 174,
	"./en-au": 175,
	"./en-au.js": 175,
	"./en-ca": 176,
	"./en-ca.js": 176,
	"./en-gb": 177,
	"./en-gb.js": 177,
	"./en-ie": 178,
	"./en-ie.js": 178,
	"./en-il": 179,
	"./en-il.js": 179,
	"./en-nz": 180,
	"./en-nz.js": 180,
	"./eo": 181,
	"./eo.js": 181,
	"./es": 182,
	"./es-do": 183,
	"./es-do.js": 183,
	"./es-us": 184,
	"./es-us.js": 184,
	"./es.js": 182,
	"./et": 185,
	"./et.js": 185,
	"./eu": 186,
	"./eu.js": 186,
	"./fa": 187,
	"./fa.js": 187,
	"./fi": 188,
	"./fi.js": 188,
	"./fo": 189,
	"./fo.js": 189,
	"./fr": 190,
	"./fr-ca": 191,
	"./fr-ca.js": 191,
	"./fr-ch": 192,
	"./fr-ch.js": 192,
	"./fr.js": 190,
	"./fy": 193,
	"./fy.js": 193,
	"./gd": 194,
	"./gd.js": 194,
	"./gl": 195,
	"./gl.js": 195,
	"./gom-latn": 196,
	"./gom-latn.js": 196,
	"./gu": 197,
	"./gu.js": 197,
	"./he": 198,
	"./he.js": 198,
	"./hi": 199,
	"./hi.js": 199,
	"./hr": 200,
	"./hr.js": 200,
	"./hu": 201,
	"./hu.js": 201,
	"./hy-am": 202,
	"./hy-am.js": 202,
	"./id": 203,
	"./id.js": 203,
	"./is": 204,
	"./is.js": 204,
	"./it": 205,
	"./it.js": 205,
	"./ja": 206,
	"./ja.js": 206,
	"./jv": 207,
	"./jv.js": 207,
	"./ka": 208,
	"./ka.js": 208,
	"./kk": 209,
	"./kk.js": 209,
	"./km": 210,
	"./km.js": 210,
	"./kn": 211,
	"./kn.js": 211,
	"./ko": 212,
	"./ko.js": 212,
	"./ky": 213,
	"./ky.js": 213,
	"./lb": 214,
	"./lb.js": 214,
	"./lo": 215,
	"./lo.js": 215,
	"./lt": 216,
	"./lt.js": 216,
	"./lv": 217,
	"./lv.js": 217,
	"./me": 218,
	"./me.js": 218,
	"./mi": 219,
	"./mi.js": 219,
	"./mk": 220,
	"./mk.js": 220,
	"./ml": 221,
	"./ml.js": 221,
	"./mn": 222,
	"./mn.js": 222,
	"./mr": 223,
	"./mr.js": 223,
	"./ms": 224,
	"./ms-my": 225,
	"./ms-my.js": 225,
	"./ms.js": 224,
	"./mt": 226,
	"./mt.js": 226,
	"./my": 227,
	"./my.js": 227,
	"./nb": 228,
	"./nb.js": 228,
	"./ne": 229,
	"./ne.js": 229,
	"./nl": 230,
	"./nl-be": 231,
	"./nl-be.js": 231,
	"./nl.js": 230,
	"./nn": 232,
	"./nn.js": 232,
	"./pa-in": 233,
	"./pa-in.js": 233,
	"./pl": 234,
	"./pl.js": 234,
	"./pt": 235,
	"./pt-br": 236,
	"./pt-br.js": 236,
	"./pt.js": 235,
	"./ro": 237,
	"./ro.js": 237,
	"./ru": 238,
	"./ru.js": 238,
	"./sd": 239,
	"./sd.js": 239,
	"./se": 240,
	"./se.js": 240,
	"./si": 241,
	"./si.js": 241,
	"./sk": 242,
	"./sk.js": 242,
	"./sl": 243,
	"./sl.js": 243,
	"./sq": 244,
	"./sq.js": 244,
	"./sr": 245,
	"./sr-cyrl": 246,
	"./sr-cyrl.js": 246,
	"./sr.js": 245,
	"./ss": 247,
	"./ss.js": 247,
	"./sv": 248,
	"./sv.js": 248,
	"./sw": 249,
	"./sw.js": 249,
	"./ta": 250,
	"./ta.js": 250,
	"./te": 251,
	"./te.js": 251,
	"./tet": 252,
	"./tet.js": 252,
	"./tg": 253,
	"./tg.js": 253,
	"./th": 254,
	"./th.js": 254,
	"./tl-ph": 255,
	"./tl-ph.js": 255,
	"./tlh": 256,
	"./tlh.js": 256,
	"./tr": 257,
	"./tr.js": 257,
	"./tzl": 258,
	"./tzl.js": 258,
	"./tzm": 259,
	"./tzm-latn": 260,
	"./tzm-latn.js": 260,
	"./tzm.js": 259,
	"./ug-cn": 261,
	"./ug-cn.js": 261,
	"./uk": 262,
	"./uk.js": 262,
	"./ur": 263,
	"./ur.js": 263,
	"./uz": 264,
	"./uz-latn": 265,
	"./uz-latn.js": 265,
	"./uz.js": 264,
	"./vi": 266,
	"./vi.js": 266,
	"./x-pseudo": 267,
	"./x-pseudo.js": 267,
	"./yo": 268,
	"./yo.js": 268,
	"./zh-cn": 269,
	"./zh-cn.js": 269,
	"./zh-hk": 270,
	"./zh-hk.js": 270,
	"./zh-tw": 271,
	"./zh-tw.js": 271
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448;

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryItemQRDialog_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1d68ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryItemQRDialog_vue__ = __webpack_require__(489);
function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f1d68ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryItemQRDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1d68ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryItemQRDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_QRCode_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ab69aad4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_QRCode_vue__ = __webpack_require__(453);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_QRCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ab69aad4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_QRCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */,
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"lazy":"","persistent":"","width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.dialog)?_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dense":"","dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.onClose($event)}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Item QR Code")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.printQR($event)}}},[_vm._v("Print")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.onClose($event)}}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":_vm.onClose}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":"","id":"qr-code","align-center":"","justify-center":""}},[_vm._l((_vm.item.quantity),function(i){return [_c('v-flex',{key:i,staticStyle:{"border":"thin black dashed"},attrs:{"md3":""}},[_c('q-r-code',{staticClass:"ma-4",attrs:{"text":_vm.item.quantity > 1 ? JSON.stringify({id:_vm.item.id, count: i}) : JSON.stringify({id:_vm.item.id}),"size":135}}),_vm._v(" "),_c('div',{staticClass:"primary py-1"},[_c('p',{staticClass:"text-xs-center pt-1"},[_vm._v(_vm._s(_vm.item.courierOption.name+' '+i)+"\n                to "),_c('b',[_vm._v(_vm._s(_vm.item.destinationName))])])])],1),_vm._v(" "),((i%16) === 0)?_c('v-flex',{key:i+_vm.item.quantity,attrs:{"xs12":""}},[_c('div',{staticClass:"html2pdf__page-break"})]):_vm._e()]})],2),_vm._v(" "),_c('v-list',{attrs:{"three-line":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(_vm.item.courierOption.icon)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_c('b',[_vm._v(_vm._s(_vm.item.quantity > 1 ? _vm.item.courierOption.pluralName :
                _vm.item.courierOption.name)+"\n              ")])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption primary--text"},[_c('b',[_vm._v("To: ")]),_vm._v(_vm._s(_vm.item.destinationName)+"\n            ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption accent--text"},[_vm._v("\n              "+_vm._s(_vm.item.destinationFormattedAddress)+"\n            ")])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.connecting || _vm.error)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(_vm.connecting)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e(),_vm._v(" "),(_vm.connecting)?_c('p',{staticClass:"text-xs-center"},[_vm._v("Please wait....")]):_vm._e(),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","icon":"warning","dark":""},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_vm._v("\n            "+_vm._s(_vm.errorText)+"\n        ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.connecting && !_vm.error),expression:"!connecting && !error"}]},[_vm._v("Complete")])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDeliveryDialog_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400567b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDeliveryDialog_vue__ = __webpack_require__(515);
function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-400567b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDeliveryDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_400567b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDeliveryDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"autocomplete",class:_vm.classname,attrs:{"append-icon":_vm.appendIcon,"auto-grow":_vm.autoGrow,"autofocus":_vm.autofocus,"box":_vm.box,"clearable":_vm.clearable,"color":_vm.color,"counter":_vm.counter,"dark":_vm.dark,"disabled":_vm.disabled,"dont-fill-mask-blanks":_vm.dontFillMaskBlanks,"error":_vm.error,"error-messages":_vm.errorMessages,"full-width":_vm.fullWidth,"hide-details":_vm.hideDetails,"hint":_vm.hint,"id":_vm.id,"label":_vm.label,"light":_vm.light,"loading":_vm.loading,"mask":_vm.mask,"multi-line":_vm.multiLine,"name":_vm.id,"persistent-hint":_vm.persistentHint,"placeholder":_vm.placeholder,"prefix":_vm.prefix,"prepend-icon":_vm.prependIcon,"readonly":_vm.readonly,"required":_vm.required,"return-masked-value":_vm.returnMaskedValue,"rows":_vm.rows,"rules":_vm.rules,"single-line":_vm.singleLine,"solo":_vm.solo,"suffix":_vm.suffix,"tabindex":_vm.tabindex,"textarea":_vm.textarea,"toggle-keys":_vm.toggleKeys,"type":"text","validate-on-blur":_vm.validateOnBlur},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress},model:{value:(_vm.autocompleteText),callback:function ($$v) {_vm.autocompleteText=$$v},expression:"autocompleteText"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mt-3 caption",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"lazy":"","persistent":"","max-width":"600px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"mt-1",attrs:{"raised":""}},[_c('v-card-text',{staticClass:"mb-0 pb-0"},[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[(_vm.courierOptions.length)?_c('v-radio-group',{staticClass:"mb-3",attrs:{"row":"","hide-details":""},model:{value:(_vm.courierOption),callback:function ($$v) {_vm.courierOption=$$v},expression:"courierOption"}},_vm._l((_vm.courierOptions),function(courierOption,i){return (courierOption.active)?_c('v-radio',{key:courierOption.id,attrs:{"value":courierOption,"label":courierOption.name}}):_vm._e()})):_vm._e()],1)],1),_vm._v(" "),_c('google-place-input',{ref:"destinationInput",staticClass:"mb-2",attrs:{"id":"destination","country":"KE","clearable":false,"courier":true,"disabled":!_vm.courierOption,"enable-geolocation":true,"label":"Enter a destination location","placeholder":"Destination location","prepend-icon":"edit_location","required":true,"rules":[_vm.rules.required],"load-google-api":false,"google-api-key":_vm.$app.googleMapsKey,"hint":!_vm.placeResultData ? '' : _vm.placeResultData.formatted_address,"persistent-hint":"","types":"establishment","hide-details":false},on:{"placechanged":_vm.onDestinationEntered}}),_vm._v(" "),_vm._l((_vm.otherDestinations),function(destination,index){return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('google-place-input',{staticClass:"mb-2",attrs:{"id":index + '',"country":"KE","clearable":false,"otherDestination":true,"courier":true,"disabled":!_vm.placeResultData,"enable-geolocation":true,"label":"Enter a destination location","placeholder":"Destination location","prepend-icon":"edit_location","required":true,"load-google-api":false,"google-api-key":_vm.$app.googleMapsKey,"hint":!destination ? '' : destination.formatted_address,"persistent-hint":"","types":"establishment","hide-details":false},on:{"placechanged":_vm.onDestinationEntered}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.removeOtherDestination(index)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1)],1)],1)}),_vm._v(" "),_c('v-btn',{attrs:{"block":"","flat":"","color":"primary","disabled":_vm.addDestinationDisabled},nativeOn:{"click":function($event){return _vm.addNewDestination($event)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add\n        ")]),_vm._v("\n        Add a destination\n        "),_c('span',{attrs:{"slot":"loader"},slot:"loader"},[_vm._v("Please wait...")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{attrs:{"disabled":!_vm.placeResultData,"label":"Enter final recipient name","placeholder":"Final recipient name","required":"","rules":[_vm.rules.required],"prepend-icon":"person"},model:{value:(_vm.recipientName),callback:function ($$v) {_vm.recipientName=$$v},expression:"recipientName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"disabled":!_vm.placeResultData,"label":"Enter recipient contact","placeholder":"Recipient contact","required":"","rules":[_vm.rules.required, _vm.rules.recipientContact],"type":"phone","mask":"##########","counter":10,"prepend-icon":"phone"},model:{value:(_vm.recipientContact),callback:function ($$v) {_vm.recipientContact=$$v},expression:"recipientContact"}})],1)],1),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":!_vm.recipientContact,"label":_vm.quantityHint,"placeholder":_vm.quantityHint,"rules":[_vm.rules.required, _vm.rules.quantity],"required":"","mask":"###","prepend-icon":"format_list_numbered"},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}}),_vm._v(" "),_c('v-textarea',{attrs:{"name":"note","rows":"2","prepend-icon":"note","label":"Write a short note","placeholder":"Instructions to the rider"},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"primary","disabled":_vm.invalidForm},nativeOn:{"click":function($event){return _vm.onAddItem($event)}}},[_vm._v("Add item\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","no-title":_vm.noTitle,"disabled":_vm.disabled,"nudge-right":40,"max-width":"290px","min-width":"290px","return-value":_vm.date},on:{"update:returnValue":function($event){_vm.date=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":("Enter " + _vm.placeholder),"placeholder":_vm.placeholder,"prepend-icon":"event","error-messages":_vm.errorMessages,"value":_vm.date,"disabled":_vm.disabled,"readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates.dates},on:{"change":_vm.onChange},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","disabled":_vm.disabled,"nudge-right":40,"max-width":"290px","min-width":"290px","return-value":_vm.time},on:{"update:returnValue":function($event){_vm.time=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":("Enter " + _vm.placeholder),"placeholder":_vm.placeholder,"disabled":_vm.disabled,"value":_vm.time,"error-messages":_vm.errorMessages,"prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"format":"24hr","allowed-hours":_vm.allowedTimes.hours,"allowed-minutes":_vm.allowedTimes.minutes},on:{"change":_vm.onChange},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.step > 1}},[_vm._v("\n        Pick up\n      ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.step > 2}},[_vm._v("\n        Items\n      ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.step > 3}},[_vm._v("\n        Schedule\n      ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4"}},[_vm._v("\n        Confirm Cost\n      ")])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',[_c('v-card-text',[_c('google-place-input',{ref:"originInput",attrs:{"id":"origin","country":"KE","clearable":false,"disabled":_vm.connecting,"enable-geolocation":true,"label":"Enter pickup location","placeholder":"Pickup location","prepend-icon":"edit_location","required":true,"load-google-api":false,"value":_vm.originInput,"types":"establishment","hint":_vm.originFormattedAddress,"persistent-hint":"","hide-details":false},on:{"placechanged":_vm.onOriginEntered}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Enter address details","placeholder":"Address detail E.g. Company Name","required":"","rules":[_vm.rules.required],"prepend-icon":"edit_location"},model:{value:(_vm.addressDetails),callback:function ($$v) {_vm.addressDetails=$$v},expression:"addressDetails"}}),_vm._v(" "),_c('guide',{attrs:{"text":"Please provide location where item or items will be collected"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.connecting && !_vm.courierOptions.length,"disabled":!_vm.originPosition || _vm.connecting || _vm.invalidForm},nativeOn:{"click":function($event){return _vm.goStepTwo($event)}}},[_vm._v("\n              Continue\n            ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card-text',[_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height*0.40)+'px; '),attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,i){return [_c('v-list-tile',{key:i,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(item.courierOption.icon)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_c('b',[_vm._v(_vm._s(item.quantity)+" -\n                      "+_vm._s((item.quantity === 1 ? item.courierOption.name:
                      item.courierOption.pluralName)))]),_vm._v("\n                    - "+_vm._s(item.distance/1000)+"km\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text caption"},[_c('b',[_vm._v(" To: ")]),_vm._v(_vm._s(item.destinationName)+" -\n                    "+_vm._s(item.destinationFormattedAddress)+"\n                  ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","light":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.deleteItem(item)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),(i !== _vm.items.length - 1)?_c('v-divider',{key:i+_vm.items.length,attrs:{"inset":""}}):_vm._e()]})],2),_vm._v(" "),_c('add-delivery-item-dialog',{attrs:{"show":_vm.addingItem,"courierOptions":_vm.courierOptions},on:{"onAddItem":_vm.onAddItem,"onClose":function($event){_vm.addingItem = false}}}),_vm._v(" "),_c('v-btn',{attrs:{"block":"","loading":_vm.calculatingDirections,"flat":"","color":"primary","disabled":_vm.connecting || _vm.calculatingDirections},nativeOn:{"click":function($event){_vm.addingItem = true}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add\n            ")]),_vm._v("\n            Add item\n            "),_c('span',{attrs:{"slot":"loader"},slot:"loader"},[_vm._v("Please wait...")])],1),_vm._v(" "),_c('guide',{attrs:{"text":"One/multiple packages with different/same destination"}})],1),_vm._v(" "),_c('v-card',[_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n              Back\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting,"color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.items.length},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v("\n              Continue\n            ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","offset-xs2":""}},[_c('v-subheader',[_vm._v("Optional scheduling")]),_vm._v(" "),_c('date-input',{attrs:{"disabled":_vm.connecting,"placeholder":"Pick up date","allowedDates":_vm.allowedDates},model:{value:(_vm.scheduleDate),callback:function ($$v) {_vm.scheduleDate=$$v},expression:"scheduleDate"}}),_vm._v(" "),_c('time-input',{attrs:{"disabled":_vm.connecting,"placeholder":"Pick up time","allowedTimes":_vm.allowedTimes},model:{value:(_vm.scheduleTime),callback:function ($$v) {_vm.scheduleTime=$$v},expression:"scheduleTime"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n              Back\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting,"color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 4}}},[_vm._v("\n              Continue\n            ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","offset-xs2":""}},[_c('v-icon',{staticClass:"mb-3",attrs:{"x-large":""}},[_vm._v("\n                  account_balance_wallet\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","color":"primary","outline":"","large":"","flat":""}},[_vm._v("\n                  Total Cost Estimate: "),_c('b',[_vm._v(_vm._s(_vm.$app.formatMoney(_vm.estimatedCost)))])]),_vm._v(" "),_c('v-checkbox',{staticClass:"mt-3",attrs:{"disabled":_vm.connecting,"label":"This is an urgent delivery"},model:{value:(_vm.urgent),callback:function ($$v) {_vm.urgent=$$v},expression:"urgent"}}),_vm._v(" "),(_vm.itemWithLongestDistance)?_c('span',[_vm._v("Estimated Max Distance: "+_vm._s(_vm.itemWithLongestDistance
                                                  .distance)+" meters")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.itemWithLongestDistance)?_c('span',[_vm._v("Estimate Max Time: "+_vm._s(_vm.itemWithLongestDistance.duration)+" seconds")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 3}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n              Back\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting,"color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n              Continue\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-breadcrumbs',[_c('v-breadcrumbs-item',[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("Courier")]),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v(_vm._s(_vm.$app.capitalizeFirstLetter(_vm.$route.params.filter)))])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),_vm._v(" "),_c('v-card',{staticClass:"pt-3"},[_c('v-data-iterator',{attrs:{"content-tag":"v-expansion-panel","content-class":"elevation-0","no-data-text":_vm.loading ? '' : 'No data available',"items":_vm.items,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-expansion-panel-content',{attrs:{"lazy":"","value":_vm.items.length === 1}},[_c('template',{staticStyle:{"min-height":"250px"},slot:"header"},[_c('div',[_c('b',{staticStyle:{"color":"#00bfa5"}},[_vm._v("ID: "+_vm._s(props.item.id))]),_vm._v(" "),_c('b',[_vm._v("From: "+_vm._s(props.item.originName))]),_vm._v("-\n              "),(props.item.createdAt)?_c('timeago',{staticClass:"accent--text",attrs:{"datetime":props.item.createdAt}}):_vm._e(),_vm._v(" "),_c('v-chip',{staticClass:"mb-2",attrs:{"color":"accent","label":"","small":"","text-color":"white"}},[(props.item.status === 'DELIVERED')?_c('b',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.actualDeliveryCost))+" incl. 16% VAT")]):_c('b',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.estimatedCost))+" incl. 16% VAT")])]),_vm._v(" "),_vm._l((props.item.stats),function(stat,i){return _c('v-chip',{key:i,attrs:{"small":"","color":"primary","text-color":"white"}},[_c('v-avatar',{attrs:{"size":24}},[_c('img',{staticStyle:{"max-height":"24px","max-width":"24px"},attrs:{"src":_vm.$app.imageUrl(stat.courierOption.icon),"alt":stat.courierOption.name}})]),_vm._v(" "),_c('b',[_vm._v(_vm._s(stat.count)+" "+_vm._s(stat.count > 1 ? stat.courierOption.pluralName :
                  stat.courierOption.name))])],1)}),_vm._v(" "),(props.item.status === 'REJECTED')?_c('v-chip',{attrs:{"label":"","outline":"","color":"red","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Rejected by "+_vm._s(props.item.rejectedBy.accountType)+" - "+_vm._s(props.item.rejectedBy.name)+"\n              ")],1):_vm._e(),_vm._v(" "),(props.item.status === 'CANCELLED')?_c('v-chip',{attrs:{"label":"","outline":"","color":"red","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Cancelled by "+_vm._s(props.item.cancelledBy.accountType)+" - "+_vm._s(props.item.cancelledBy.name)+"\n              ")],1):_vm._e(),_vm._v(" "),(props.item.status === 'AT_DEPARTMENT_HEAD' && !_vm.isDepartmentHead())?_c('v-chip',{attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Pending Department Head approval\n              ")],1):_vm._e(),_vm._v(" "),(props.item.status === 'AT_PURCHASING_HEAD' && !_vm.isPurchasingHead())?_c('v-chip',{attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Pending Purchasing Head approval\n              ")],1):_vm._e(),_vm._v(" "),(_vm.showApprovalActions(props.item))?_c('v-btn',{attrs:{"flat":"","color":"red","small":"","outline":""},nativeOn:{"click":function($event){_vm.reject(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("close\n                ")]),_vm._v("\n                Reject\n              ")],1):_vm._e(),_vm._v(" "),(_vm.showApprovalActions(props.item))?_c('v-btn',{attrs:{"flat":"","color":"success","small":"","outline":""},nativeOn:{"click":function($event){_vm.confirm(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("check_circle\n                ")]),_vm._v("\n                Approve\n              ")],1):_vm._e(),_vm._v(" "),(_vm.showCancelActions(props.item))?_c('v-btn',{attrs:{"flat":"","color":"red","small":"","outline":""},nativeOn:{"click":function($event){_vm.cancelDelivery(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("close\n                ")]),_vm._v("\n                Cancel\n              ")],1):_vm._e()],2)]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._l((props.item.items),function(item,index){return [_c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"align-self-center":"","xs1":""}},[_c('v-img',{staticClass:"align-self-center",attrs:{"src":_vm.$app.imageUrl(item.courierOption.icon),"height":"40px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('v-list-tile-title',{staticClass:"body-2"},[_c('b',[_vm._v(_vm._s(item.quantity)+" "+_vm._s(item.quantity > 1 ? item.courierOption.pluralName :
                          item.courierOption.name)+"\n                        ")]),_vm._v(" "),(item.status)?_c('span',[_vm._v("- "+_vm._s(item.status))]):_vm._e(),_c('br'),_vm._v(" "),(item.status === 'AT_DESTINATION')?_c('span',[_c('v-chip',{staticClass:"mb-2",attrs:{"color":"accent","label":"","small":"","text-color":"white"}},[_c('b',[_vm._v(_vm._s(_vm.$app.formatMoney(item.deliveryCost))+" incl. 16% VAT")])])],1):_vm._e()]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption"},[_c('b',[_vm._v("To: ")]),_vm._v(_vm._s(item.destinationName)),_c('br')]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption"},[_c('b',[_vm._v("Address: ")]),_vm._v(_vm._s(item.destinationFormattedAddress)),_c('br')]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption"},[_c('b',[_vm._v("Note: ")]),_vm._v(_vm._s(item.note)),_c('br')]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"caption accent--text"},[_vm._v("Stops:")]),_vm._v(" "),_c('v-timeline',{attrs:{"align-top":"","dense":""}},[_vm._l((item.stops),function(stop,index){return [_c('v-timeline-item',{key:index,attrs:{"color":"pink","small":""}},[_c('v-layout',{attrs:{"pt-1":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('strong',[_vm._v(_vm._s(stop.stopName))])])],1)],1)]})],2)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(item.status === 'PENDING_PICKUP')?_c('v-btn',{attrs:{"slot":"activator","flat":"","outline":"","color":"primary"},on:{"click":function($event){_vm.printingItem = item}},slot:"activator"},[_vm._v("\n                      Print QR\n                    ")]):_vm._e(),_vm._v(" "),(item.status ==='EN_ROUTE_TO_DESTINATION')?_c('v-btn',{attrs:{"slot":"activator","flat":"","outline":"","color":"primary"},on:{"click":function($event){_vm.trackingItem = item}},slot:"activator"},[_vm._v("\n                      Track\n                    ")]):_vm._e()],1)],1),_vm._v(" "),(index !== props.item.items.length-1)?_c('v-divider',{key:index + props.item.items.length,staticClass:"mt-2",attrs:{"inset":""}}):_vm._e()]})],2),_vm._v(" "),_c('v-card-text')],1)],2)}}])})],1)],1),_vm._v(" "),_c('add-delivery-dialog',{attrs:{"show":_vm.addingDelivery},on:{"onClose":_vm.onCloseAddingDelivery}}),_vm._v(" "),_c('delivery-item-q-r-dialog',{attrs:{"item":_vm.printingItem},on:{"onClose":function($event){_vm.printingItem = null}}}),_vm._v(" "),(_vm.isDepartmentUser())?_c('v-fab-transition',[_c('v-btn',{staticClass:"ma-5",attrs:{"color":"accent","fab":"","dark":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.addingDelivery = true}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Appointments_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197a0591_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Appointments_vue__ = __webpack_require__(529);
function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-197a0591"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Appointments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197a0591_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Appointments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */,
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAppointmentDialog_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d83189a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAppointmentDialog_vue__ = __webpack_require__(528);
function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d83189a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAppointmentDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d83189a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAppointmentDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseDialog_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f2be2c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseDialog_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.maxWidth,"persistent":"","lazy":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.step > 1}},[_vm._v("Venue")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"scroll-y"},[_c('v-card-text',[_c('div',[_c('v-select',{attrs:{"items":_vm.venueTypes,"disabled":_vm.connecting,"clearable":"","item-text":"text","item-value":"value","label":"Select appointment/meeting venue type venue type","validate-on-blur":"","single-line":""},model:{value:(_vm.venueType),callback:function ($$v) {_vm.venueType=$$v},expression:"venueType"}}),_vm._v(" "),_c('google-place-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.venueType === 2),expression:"venueType === 2"}],ref:"locationInput",attrs:{"disabled":_vm.connecting,"id":"destination","country":"KE","clearable":false,"enable-geolocation":true,"label":"Enter location","placeholder":"Location","prepend-icon":"edit_location","required":true,"rules":[_vm.rules.required],"load-google-api":false,"google-api-key":_vm.$app.googleMapsKey,"hint":!_vm.placeResultData ? '' : _vm.placeResultData.formatted_address,"persistent-hint":"","hide-details":false,"types":"establishment"},on:{"placechanged":_vm.onLocationEntered}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.venueType === 1),expression:"venueType === 1"}],attrs:{"disabled":_vm.connecting,"required":"","label":"Enter appointment/Meeting venue","placeholder":"Appointment/Meeting venue e.g Office, Boardroom or Room 10","prepend-icon":"edit_location"},model:{value:(_vm.venue),callback:function ($$v) {_vm.venue=$$v},expression:"venue"}})],1)]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.venue},nativeOn:{"click":function($event){_vm.step = 2}}},[_vm._v("Continue")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.step > 2}},[_vm._v("Internal Participants")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.filteredUsers,"label":"Select internal participants","disabled":_vm.connecting,"item-text":"name","menu-props":"auto, overflowY","required":"","min-height":"45px","rules":[function () { return _vm.internalParticipants.length > 0 || 'You must choose at least one'; }],"multiple":"","chips":"","search-input":_vm.search,"loading":_vm.loadingUsers},on:{"update:searchInput":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"close":"","selected":data.selected},on:{"input":function($event){data.parent.selectItem(data.item)}}},[_c('v-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(data.item.avatar)}})]),_vm._v("\n                    "+_vm._s(data.item.name)+"\n                  ")],1)]}}]),model:{value:(_vm.internalParticipants),callback:function ($$v) {_vm.internalParticipants=$$v},expression:"internalParticipants"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n            Back\n          ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.internalParticipants.length || _vm.internalParticipants.length <= 0},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v("\n            Continue\n          ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.step > 3}},[_vm._v("External Participants")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{attrs:{"flat":""}},[_vm._l((_vm.externalParticipants),function(participant,index){return [_c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.connecting,"placeholder":"Participant name","label":"Enter participant name","error-messages":participant.errors.name,"prepend-icon":"email"},model:{value:(participant.name),callback:function ($$v) {_vm.$set(participant, "name", $$v)},expression:"participant.name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-5",attrs:{"xs5":""}},[_c('v-text-field',{attrs:{"disabled":_vm.connecting,"placeholder":"Participant email address","label":"Enter participant email address","error-messages":participant.errors.email,"prepend-icon":"email"},model:{value:(participant.email),callback:function ($$v) {_vm.$set(participant, "email", $$v)},expression:"participant.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":_vm.connecting,"placeholder":"Participant phone number","label":"Enter participant phone number","error-messages":participant.errors.phone,"mask":"##########","prepend-icon":"phone"},model:{value:(participant.phone),callback:function ($$v) {_vm.$set(participant, "phone", $$v)},expression:"participant.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.removeExternalParticipant(participant)}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]}),_vm._v(" "),_c('v-btn',{attrs:{"block":"","flat":"","color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.addExternalParticipant($event)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n          Add participant\n        ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n            Back\n          ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.externalParticipantsValidate},nativeOn:{"click":function($event){_vm.step = 4}}},[_vm._v("\n            Continue\n          ")])],1)],2)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4","complete":_vm.step > 4}},[_vm._v("Title/Topic")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-text-field',{attrs:{"label":"Enter meeting title/subject","disabled":_vm.connecting,"placeholder":"Title/Subject e.g Website development progress meeting","required":"","prepend-icon":"title"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 3}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n            Back\n          ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.title || _vm.connecting},nativeOn:{"click":function($event){_vm.step = 5}}},[_vm._v("Continue\n          ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"5"}},[_vm._v("Issues/Items/Agenda")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',{attrs:{"flat":""}},[_vm._l((_vm.itemsToDiscuss),function(itemToDiscuss,index){return [_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-text-field',{attrs:{"disabled":_vm.connecting,"placeholder":"An item to discuss","label":"Enter item to discuss","error-messages":itemToDiscuss.error,"prepend-icon":"note"},model:{value:(itemToDiscuss.text),callback:function ($$v) {_vm.$set(itemToDiscuss, "text", $$v)},expression:"itemToDiscuss.text"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.removeItemToDiscuss(itemToDiscuss)}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]}),_vm._v(" "),_c('v-btn',{attrs:{"block":"","flat":"","color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.addItemToDiscuss($event)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n          Add item to discuss\n        ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 4}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n            Back\n          ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || !_vm.itemsToDiscussValidate},nativeOn:{"click":function($event){_vm.step = 6}}},[_vm._v("Continue\n          ")])],1)],2)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"6"}},[_vm._v("Meeting Time")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"6"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',_vm._b({},'v-flex',( _obj = {}, _obj[("xs" + (_vm.allDay ? 12 : 6))] = true, _obj ),false),[_c('date-input',{attrs:{"disabled":_vm.connecting,"placeholder":"Starting date","error-messages":_vm.startDateErrors,"allowedDates":_vm.allowedStartDates},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.allDay),expression:"!allDay"}],staticClass:"pl-5",attrs:{"xs6":""}},[_c('time-input',{attrs:{"disabled":_vm.connecting,"default-value":_vm.currentTime,"placeholder":"Starting time","allowedTimes":_vm.allowedStartTimes},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1),_vm._v(" "),_c('v-flex',_vm._b({},'v-flex',( _obj$1 = {}, _obj$1[("xs" + (_vm.allDay ? 12 : 6))] = true, _obj$1 ),false),[_c('date-input',{ref:"endDate",attrs:{"disabled":_vm.connecting || !_vm.startDate,"placeholder":"Ending date","allowedDates":_vm.allowedEndDates},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1),_vm._v(" "),(!_vm.allDay)?_c('v-flex',{staticClass:"pl-5",attrs:{"xs6":""}},[_c('time-input',{ref:"endTime",attrs:{"disabled":_vm.connecting,"default-value":_vm.currentTime,"placeholder":"Ending time","allowedTimes":_vm.allowedEndTimes},model:{value:(_vm.endTime),callback:function ($$v) {_vm.endTime=$$v},expression:"endTime"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-checkbox',{attrs:{"label":"All day","hide-details":"","disabled":_vm.connecting},model:{value:(_vm.allDay),callback:function ($$v) {_vm.allDay=$$v},expression:"allDay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}})],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.invalidInternalParticipants.length > 0}},[_c('v-list',_vm._l((_vm.invalidInternalParticipants),function(participant){return _c('v-list-tile',{key:participant.id},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(participant.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("has another appointment/meeting on the selected timing\n                ")])],1)],1)}))],1),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.invalidTime}},[_c('p',[_vm._v("End time can't be lower than the start time")])]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.invalidDate}},[_c('p',[_vm._v("End date can't be lower than the start date")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 4}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n            Back\n          ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){return _vm.onCancel($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.invalidTime || _vm.invalidDate || _vm.invalidSchedule || _vm.invalidInternalParticipants.length > 0},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("Finish\n          ")])],1)],1)],1)],1)],1)
var _obj;
var _obj$1;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('connection-manager',{ref:"connectionManager"}),_vm._v(" "),_c('full-calendar',{attrs:{"events":_vm.appointments,"config":_vm.config},on:{"event-selected":_vm.onEventClicked}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px","persistent":""},model:{value:(_vm.showAppointmentDialog),callback:function ($$v) {_vm.showAppointmentDialog=$$v},expression:"showAppointmentDialog"}},[_c('v-card',[(_vm.selectedAppointment)?_c('v-card-text',{staticClass:"scroll-y pa-3",style:('max-height: '+_vm.cardHeight)},[_c('h2',[_vm._v(_vm._s(_vm.selectedAppointment.title))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.selectedAppointment.venue))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","small":"","color":"accent","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("access_time")]),_vm._v("\n          "+_vm._s(_vm.selectedAppointment.allDay ? 'All day'
          : _vm.selectedAppointment.startingAt+' -'+_vm.selectedAppointment.endingAt)+"\n        ")],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Internal Participants")]),_vm._v(" "),_c('v-list',{attrs:{"avatar":""}},_vm._l((_vm.selectedAppointment.internalParticipants),function(participant){return _c('v-list-tile',{key:participant.id},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(participant.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(participant.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(participant.phone))])],1)],1)})),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("External Participants")]),_vm._v(" "),_c('v-list',{attrs:{"avatar":""}},_vm._l((_vm.selectedAppointment.externalParticipants),function(participant){return _c('v-list-tile',{key:participant.id},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(participant.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(participant.phone))])],1)],1)})),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Issues/Items")]),_vm._v(" "),_vm._l((_vm.selectedAppointment.items),function(issue,index){return [_c('p',{key:issue.id},[_vm._v(_vm._s(issue.details))]),_vm._v(" "),(index !== _vm.selectedAppointment.items.length - 1)?_c('v-divider',{key:'div_'+issue.id,staticClass:"mb-3"}):_vm._e()]})],2):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){_vm.showAppointmentDialog = false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('add-appointment-dialog',{attrs:{"show":_vm.addingAppointment},on:{"onClose":_vm.onCloseDialog}}),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{staticStyle:{"margin-bottom":"100px"},attrs:{"color":"accent","fab":"","dark":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.addingAppointment = true}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscriptions_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1bf561c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscriptions_vue__ = __webpack_require__(534);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1bf561c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscriptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1bf561c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscriptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"650px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.step > 1}},[_vm._v("Option")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.step > 2}},[_vm._v("Renewal")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.step > 3}},[_vm._v("Days")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4"}},[_vm._v("Quantity")])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-select',{staticClass:"mb-1",attrs:{"items":_vm.options,"hide-details":"","item-text":"name","item-value":"id","label":"Select a subscription option","placeholder":"Subscription option"},model:{value:(_vm.optionId),callback:function ($$v) {_vm.optionId=$$v},expression:"optionId"}}),_vm._v(" "),_c('v-slide-y-transition',[(_vm.option)?_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;')},[_vm._l((_vm.option.items),function(optionItem,index){return [_c('v-list-tile',{key:index,on:{"click":function($event){_vm.selectedOptionItem = optionItem}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(optionItem.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$app.formatMoney(optionItem.price))+"\n                    ")])],1)],1),_vm._v(" "),(index < _vm.option.items.length)?_c('v-divider',{key:_vm.option.items.length + index}):_vm._e()]})],2),_vm._v(" "),_c('v-chip',{staticClass:"mt-3",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n              Select "+_vm._s(_vm.option.name)+" to subscribe to from the above list\n            ")],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.selectedOptionItem)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.step = 2}}},[_vm._v("\n              Subscribe for "+_vm._s(_vm.selectedOptionItem.name)+"\n            ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-slide-y-transition',[(_vm.weekdays.length && _vm.step === 2)?_c('v-card',[_c('v-card-text',[_c('div',[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.renewal),callback:function ($$v) {_vm.renewal=$$v},expression:"renewal"}},[_c('v-radio',{attrs:{"label":"Renew every month","color":"orange","disabled":_vm.connecting,"value":"renew_every_month"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"One time","color":"orange","disabled":_vm.connecting,"value":"one_time_subscription"}})],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                Back\n              ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v("\n                Continue\n              ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-slide-y-transition',[_c('v-card',[(_vm.weekdays.length && _vm.step === 3 && _vm.renewal === 'renew_every_month')?_c('v-card-text',[_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.45)+'px;'),attrs:{"dense":""}},_vm._l((_vm.weekdays),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}})],1)],1)})),_vm._v(" "),_c('v-chip',{staticClass:"mt-3 caption",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Select on which days we should deliver your subscription from the above list\n              ")],1)],1):_c('v-card-text',[_c('v-text-field',{attrs:{"required":"","disabled":_vm.connecting,"hide-details":"","label":"Select date for this subscription","placeholder":"Date for this subscription"},on:{"click":function($event){_vm.showSelectTerminationDateDialog = true}},model:{value:(_vm.terminationDate),callback:function ($$v) {_vm.terminationDate=$$v},expression:"terminationDate"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                Back\n              ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedOptionItem)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check_circle")]),_vm._v("\n                "+_vm._s(_vm.selectedOptionItem.name)+" @ "+_vm._s(_vm.$app.formatMoney(_vm.selectedOptionItem.price))+"\n              ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.selectedWeekdays <= 0 && !_vm.terminationDate},nativeOn:{"click":function($event){_vm.step = 4}}},[_vm._v("\n                Continue\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","mask":"###","label":"Enter quantity","disabled":_vm.connecting,"hide-details":_vm.renewEveryMonth,"placeholder":"Quantity to be delivered"},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(!_vm.renewEveryMonth)?_c('v-text-field',{attrs:{"required":!_vm.renewEveryMonth,"disabled":_vm.connecting,"hide-details":"","label":"Select date for this subscription","placeholder":"Date for this subscription"},on:{"click":function($event){_vm.showSelectTerminationDateDialog = true}},model:{value:(_vm.terminationDate),callback:function ($$v) {_vm.terminationDate=$$v},expression:"terminationDate"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290px","lazy":""},model:{value:(_vm.showSelectTerminationDateDialog),callback:function ($$v) {_vm.showSelectTerminationDateDialog=$$v},expression:"showSelectTerminationDateDialog"}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates},model:{value:(_vm.terminationDate),callback:function ($$v) {_vm.terminationDate=$$v},expression:"terminationDate"}})],1)],1),_vm._v(" "),(_vm.renewEveryMonth)?_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"dense":""}},_vm._l((_vm.weekdays),function(item){return (item.selected)?_c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("\n                  "+_vm._s(item.days+' '+item.name+''+((item.days > 1) ? 's' : ''))+"\n                  "),_c('b',[_vm._v("\n                    "+_vm._s(_vm.renewEveryMonth ? ' this month ' : ' between now and '+_vm.terminationDate)+"\n                  ")])])],1)],1):_vm._e()})):_vm._e(),_vm._v(" "),_c('v-slide-y-transition',[(_vm.terminationDate || _vm.renewEveryMonth)?_c('div',[_c('v-btn',{attrs:{"color":"primary","small":"","flat":"","outline":""}},[_vm._v("\n                Total Item Cost : "),_c('b',[_vm._v(" "+_vm._s(_vm.$app.formatMoney(_vm.costs.item)))])]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","small":"","flat":"","outline":""}},[_vm._v("\n                Total Delivery Cost : "),_c('b',[_vm._v(" "+_vm._s(_vm.$app.formatMoney(_vm.costs.delivery)))])]),_vm._v(" "),(_vm.renewEveryMonth)?_c('v-chip',{staticClass:"mt-3 caption",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                "+_vm._s(_vm.costsDescription)+"\n              ")],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 3}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n              Back\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedOptionItem)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check_circle")]),_vm._v("\n              "+_vm._s(_vm.selectedOptionItem.name)+" @ "+_vm._s(_vm.$app.formatMoney(_vm.selectedOptionItem.price))+"\n            ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.quantity || _vm.connecting || (!_vm.terminationDate && !_vm.renewEveryMonth)},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n              Continue\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-breadcrumbs',[_c('v-breadcrumbs-item',[_vm._v("Subscriptions")]),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v(_vm._s(_vm.$app.capitalizeFirstLetter(_vm.$route.params.filter)))])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.optionItem.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.transformWeekdays(props.item.weekdays)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.itemCost)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.deliveryCost)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.$app.formatMoney(props.item.itemCost+props.item.deliveryCost))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.renewEveryMonth)?_c('span',[_vm._v("Renew monthly")]):_c('span',[_vm._v("Up to "+_vm._s(props.item.terminationDate))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.status === 'AT_DEPARTMENT_HEAD' || props.item.status === 'AT_PURCHASING_HEAD')?_c('v-chip',{attrs:{"label":"","outline":"","color":"red","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n              Pending "+_vm._s(props.item.status === 'AT_DEPARTMENT_HEAD' ? ' Department ' :
              ' Purchasing ')+" Head approval\n            ")],1):_vm._e(),_vm._v(" "),(props.item.status === 'REJECTED')?_c('v-alert',{attrs:{"type":"error","value":true,"outline":""}},[_vm._v("\n              Rejected by "+_vm._s(props.item.rejectedBy.role.name)+" "),_c('br'),_vm._v("\n              "+_vm._s(props.item.rejectedBy.name)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.showApprovalActions(props.item))?_c('div',[_c('v-btn',{attrs:{"flat":"","color":"red","small":"","outline":""},nativeOn:{"click":function($event){_vm.reject(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("close")]),_vm._v("\n                Reject\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"success","small":"","outline":""},nativeOn:{"click":function($event){_vm.confirm(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("check_circle")]),_vm._v("\n                Confirm\n              ")],1)],1):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('add-subscription-dialog',{attrs:{"show":_vm.showAddSubscriptionDialog},on:{"onClose":_vm.onCloseAddSubscriptionDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSubscription_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dcb0d8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSubscription_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dcb0d8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dcb0d8c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.step > 1}},[_vm._v("Option")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.step > 2}},[_vm._v("Renewal")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.step > 3}},[_vm._v("Days")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4"}},[_vm._v("Quantity")])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-select',{staticClass:"mb-1",attrs:{"items":_vm.options,"hide-details":"","item-text":"name","item-value":"id","label":"Select a subscription option","placeholder":"Subscription option"},model:{value:(_vm.optionId),callback:function ($$v) {_vm.optionId=$$v},expression:"optionId"}}),_vm._v(" "),_c('v-slide-y-transition',[(_vm.option)?_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;')},[_vm._l((_vm.option.items),function(optionItem,index){return [_c('v-list-tile',{key:index,on:{"click":function($event){_vm.selectedOptionItem = optionItem}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(optionItem.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$app.formatMoney(optionItem.price))+"\n                        ")])],1)],1),_vm._v(" "),(index < _vm.option.items.length)?_c('v-divider',{key:_vm.option.items.length + index}):_vm._e()]})],2),_vm._v(" "),_c('v-chip',{staticClass:"mt-3",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                  Select "+_vm._s(_vm.option.name)+" to subscribe to from the above list\n                ")],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.selectedOptionItem)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.step = 2}}},[_vm._v("\n                  Subscribe for "+_vm._s(_vm.selectedOptionItem.name)+"\n                ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-slide-y-transition',[(_vm.weekdays.length && _vm.step === 2)?_c('v-card',[_c('v-card-text',[_c('div',[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.renewal),callback:function ($$v) {_vm.renewal=$$v},expression:"renewal"}},[_c('v-radio',{attrs:{"label":"Renew every month","color":"orange","disabled":_vm.connecting,"value":"renew_every_month"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"One time","color":"orange","disabled":_vm.connecting,"value":"one_time_subscription"}})],1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                    Back\n                  ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v("\n                    Continue\n                  ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-slide-y-transition',[_c('v-card',[(_vm.weekdays.length && _vm.step === 3 && _vm.renewal === 'renew_every_month')?_c('v-card-text',[_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.45)+'px;'),attrs:{"dense":""}},_vm._l((_vm.weekdays),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}})],1)],1)})),_vm._v(" "),_c('v-chip',{staticClass:"mt-3 caption",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                    Select on which days we should deliver your subscription from the above list\n                  ")],1)],1):_c('v-card-text',[_c('v-text-field',{attrs:{"required":"","disabled":_vm.connecting,"hide-details":"","label":"Select date for this subscription","placeholder":"Date for this subscription"},on:{"click":function($event){_vm.showSelectTerminationDateDialog = true}},model:{value:(_vm.terminationDate),callback:function ($$v) {_vm.terminationDate=$$v},expression:"terminationDate"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                    Back\n                  ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedOptionItem)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check_circle")]),_vm._v("\n                    "+_vm._s(_vm.selectedOptionItem.name)+" @ "+_vm._s(_vm.$app.formatMoney(_vm.selectedOptionItem.price))+"\n                  ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.selectedWeekdays <= 0 && !_vm.terminationDate},nativeOn:{"click":function($event){_vm.step = 4}}},[_vm._v("\n                    Continue\n                  ")])],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","mask":"###","label":"Enter quantity","disabled":_vm.connecting,"hide-details":_vm.renewEveryMonth,"placeholder":"Quantity to be delivered"},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(!_vm.renewEveryMonth)?_c('v-text-field',{attrs:{"required":!_vm.renewEveryMonth,"disabled":_vm.connecting,"hide-details":"","label":"Select date for this subscription","placeholder":"Date for this subscription"},on:{"click":function($event){_vm.showSelectTerminationDateDialog = true}},model:{value:(_vm.terminationDate),callback:function ($$v) {_vm.terminationDate=$$v},expression:"terminationDate"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290px","lazy":""},model:{value:(_vm.showSelectTerminationDateDialog),callback:function ($$v) {_vm.showSelectTerminationDateDialog=$$v},expression:"showSelectTerminationDateDialog"}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates},model:{value:(_vm.terminationDate),callback:function ($$v) {_vm.terminationDate=$$v},expression:"terminationDate"}})],1)],1),_vm._v(" "),_c('v-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.renewEveryMonth),expression:"renewEveryMonth"}],staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"dense":""}},_vm._l((_vm.weekdays),function(item){return (item.selected)?_c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("\n                      "+_vm._s(item.days+' '+item.name+''+((item.days > 1) ? 's' : ''))+"\n                      "),_c('b',[_vm._v("\n                        "+_vm._s(_vm.renewEveryMonth ? ' this month ' : ' between now and ' + _vm.terminationDate)+"\n                      ")])])],1)],1):_vm._e()})),_vm._v(" "),_c('v-slide-y-transition',[(_vm.terminationDate || _vm.renewEveryMonth)?_c('div',[_c('v-btn',{attrs:{"color":"primary","small":"","flat":"","outline":""}},[_vm._v("\n                    Total Item Cost : "),_c('b',[_vm._v(" "+_vm._s(_vm.$app.formatMoney(_vm.costs.item)))])]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","small":"","flat":"","outline":""}},[_vm._v("\n                    Total Delivery Cost : "),_c('b',[_vm._v(" "+_vm._s(_vm.$app.formatMoney(_vm.costs.delivery)))])]),_vm._v(" "),(_vm.renewEveryMonth)?_c('v-chip',{staticClass:"mt-3 caption",attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.renewEveryMonth),expression:"renewEveryMonth"}],attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                    "+_vm._s(_vm.costsDescription)+"\n                  ")],1):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.step = 3}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                  Back\n                ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedOptionItem)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check_circle")]),_vm._v("\n                  "+_vm._s(_vm.selectedOptionItem.name)+" @ "+_vm._s(_vm.$app.formatMoney(_vm.selectedOptionItem.price))+"\n                ")],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.quantity || _vm.connecting || (!_vm.terminationDate && !_vm.renewEveryMonth)},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n                  Continue\n                ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSubscriptions_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8dd322_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSubscriptions_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e8dd322"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSubscriptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8dd322_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSubscriptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */,
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-breadcrumbs',[_c('v-breadcrumbs-item',[_vm._v("Subscriptions")]),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v(_vm._s(_vm.$app.capitalizeFirstLetter(_vm.$route.params.filter)))]),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v(_vm._s(_vm.$app.capitalizeFirstLetter(_vm.dayFilter)))])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"color":"transparent","dense":"","flat":"","card":""}},[(_vm.filter !== 'expired')?_c('v-btn',{staticClass:"mx-4",attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.dayFilter = 'all'}}},[_vm._v("\n          All\n        ")]):_vm._e(),_vm._v(" "),(_vm.filter !== 'expired')?_c('v-btn',{staticClass:"mx-4",attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.dayFilter = 'today'}}},[_vm._v("\n          Today\n        ")]):_vm._e(),_vm._v(" "),(_vm.filter !== 'expired')?_c('v-btn',{staticClass:"mx-4",attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.dayFilter = 'tomorrow'}}},[_vm._v("\n          Tomorrow\n        ")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mx-4",attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.printForSupplier($event)}}},[_vm._v("\n          Print for Supplier\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-4",attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.printForRider($event)}}},[_vm._v("\n          Print for Rider\n        ")])],1),_vm._v(" "),_c('v-data-table',{ref:"subscriptionsTable",attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.optionItem.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.transformWeekdays(props.item.weekdays)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.itemCost)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.deliveryCost)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n            "+_vm._s(_vm.$app.formatMoney(props.item.itemCost+props.item.deliveryCost))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[(props.item.renewEveryMonth)?_c('span',[_vm._v("Renew monthly")]):_c('span',[_vm._v("Up to "+_vm._s(props.item.terminationDate))])]),_vm._v(" "),_c('td',{staticClass:"justify-center layout wrap px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"color":"primary"},on:{"click":function($event){_vm.viewItem(props.item)}}},[_vm._v("\n              Client Details\n            ")])],1)]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px"},model:{value:(_vm.viewItemDialog),callback:function ($$v) {_vm.viewItemDialog=$$v},expression:"viewItemDialog"}},[(_vm.itemToView)?_c('v-card',[_c('v-card-text',[_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewItemHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.itemToView[props.item.value]))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.viewItemDialog = false}}},[_vm._v("Close\n        ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('add-subscription-dialog',{attrs:{"show":_vm.showAddSubscriptionDialog},on:{"onClose":_vm.onCloseAddSubscriptionDialog}}),_vm._v(" "),(_vm.isDepartmentUser())?_c('v-fab-transition',[_c('v-btn',{staticClass:"ma-5",attrs:{"color":"accent","fab":"","dark":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.showAddSubscriptionDialog = true}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108de6ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-108de6ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108de6ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"color":"white","dense":""}},[_c('img',{staticClass:"mr-3",attrs:{"src":__webpack_require__(146),"height":"36px","width":"200px"}}),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("person")]),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Sign In")])],1),_vm._v(" "),_c('v-card-text',[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.connecting),expression:"connecting"}],attrs:{"indeterminate":true}}),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","dismissible":"","icon":"warning","dark":""},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_vm._v("\n          "+_vm._s(_vm.errorText)+"\n        ")]),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"disabled":_vm.connecting,"id":"username","name":"username","rules":_vm.emailRules,"type":"email","label":"Enter your email address","prepend-icon":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.connecting,"name":"password","label":"Enter your password","rules":_vm.passwordRules,"required":"","prepend-icon":"vpn_key","append-icon":_vm.passwordVisibilityOff ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.passwordVisibilityOff = !_vm.passwordVisibilityOff); },"type":_vm.passwordVisibilityOff ? 'password' : 'text'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary","disabled":!_vm.valid || _vm.connecting},on:{"click":_vm.submit}},[_vm._v("\n          Sign In\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b8d4d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74b8d4d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b8d4d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientDashboard_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf8a8568_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientDashboard_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf8a8568"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf8a8568_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsPieChart_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d969ea4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsPieChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsBarChart_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d8c3b90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsBarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2"},[_c('v-toolbar',{attrs:{"color":"primary","dark":"","flat":"","dense":""}},[_c('v-toolbar-side-icon'),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.refreshData(_vm.url)}}},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){}}},[_vm._v("Refresh")])],1)],1)],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager"}),_vm._v(" "),(_vm.chartData)?_c('v-card-text',[(_vm.chartType === 'pie')?_c('stats-pie-chart',{attrs:{"chartData":_vm.chartData}}):_vm._e(),_vm._v(" "),(_vm.chartType === 'bar')?_c('stats-bar-chart',{attrs:{"chartData":_vm.chartData}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('stats-card',{attrs:{"url":"deliveryBills","chart-type":"bar","title":"Courier Spending"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierDashboard_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4664f7be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierDashboard_vue__ = __webpack_require__(609);
function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4664f7be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4664f7be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComingSoon_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016b5dc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingSoon_vue__ = __webpack_require__(608);
function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-016b5dc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComingSoon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_016b5dc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComingSoon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm3":""}},[_c('h1',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.$route.name))]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ma-5",attrs:{"indeterminate":"","size":50,"color":"primary"}}),_vm._v(" "),_c('h4',[_vm._v("Work In Progress...")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('coming-soon')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673296d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-673296d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_673296d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('stats-card',{attrs:{"url":"income","chart-type":"bar","title":"Income Per Month"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-breadcrumbs',[_c('v-breadcrumbs-item',[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("Dashboard")]),_vm._v(" "),(_vm.$auth.user().client)?_c('v-breadcrumbs-item',[_vm._v(_vm._s(_vm.$auth.user().client.name))]):_vm._e()],1),_vm._v(" "),((_vm.isAdmin() || _vm.isOperations()))?_c('admin-dashboard'):(_vm.isSupplier())?_c('supplier-dashboard'):(_vm.isClientAdmin() || _vm.isPurchasingHead() || _vm.isDepartmentHead() || _vm.isDepartmentUser())?_c('client-dashboard'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shopping_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99fd817e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shopping_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99fd817e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shopping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99fd817e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shopping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToCartDialog_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b380cbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToCartDialog_vue__ = __webpack_require__(618);
function injectStyle (ssrContext) {
  __webpack_require__(617)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b380cbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddToCartDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b380cbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddToCartDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px","lazy":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.product)?_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","dense":"","color":"primary"}},[_c('v-icon',[_vm._v("shopping_cart")]),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Add to cart")])],1),_vm._v(" "),_c('v-card-media',{attrs:{"src":_vm.$app.imageUrl(_vm.product.image),"height":"150px"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"subheading white--text"},[_vm._v(_vm._s(_vm.product.name))])])],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":"","lazy":"","max-width":"200px"}},[_c('v-btn',{staticClass:"mt-0 mb-0",attrs:{"slot":"activator","flat":"","block":""},slot:"activator"},[_vm._v("\n        "+_vm._s(_vm.$app.formatMoney(_vm.product.price))+"\n        "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("info\n        ")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.product.description))])],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"required":"","label":"Enter quantity","mask":"##","rules":[_vm.rules.required],"placeholder":"Quantity"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.quantity > 0 ? _vm.onConfirm() : function (){}}},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"flat":""}},[_vm._v(_vm._s(_vm.$app.formatMoney(_vm.quantity *_vm.product.price)))])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onCancel()}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.quantity || _vm.quantity < 1},nativeOn:{"click":function($event){_vm.onConfirm()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check")]),_vm._v("\n        Confirm\n      ")],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDialog_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_786f05ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDialog_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-786f05ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_786f05ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"800px","lazy":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.45)+'px;'),attrs:{"headers":_vm.headers,"items":_vm.cartProducts,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.product.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.product.price))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.$app.formatMoney((props.item.quantity * props.item.product.price)))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"layout row wrap"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.removeProductFromCart(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete\n                        ")])],1)],1)]}}])}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"accent","flat":""},nativeOn:{"click":function($event){_vm.show = false}}},[_vm._v("\n                Close\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":!_vm.cartProducts.length},nativeOn:{"click":function($event){_vm.close()}}},[_vm._v("\n                Clear All\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.cartProducts.length || _vm.connecting},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("Submit\n            ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""}},[_vm._v("\n                Total "+_vm._s(_vm.$app.formatMoney(_vm.cartTotal))+"\n            ")]),_vm._v(" "),_c('v-spacer')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tabs',{attrs:{"fixed-tabs":"","show-arrows":"","lazy":"","grow":""},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('v-tab',{key:category.id,attrs:{"href":("#" + (category.id))}},[_vm._v("\n        "+_vm._s(category.name)+"\n      ")])})],2),_vm._v(" "),_c('v-card',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticStyle:{"margin-left":"20px"},attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-data-iterator',{attrs:{"content-tag":"v-layout","row":"","wrap":"","items":_vm.products,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs3":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":_vm.$app.imageUrl(props.item.image),"height":"150px"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"subheading white--text"},[_vm._v(_vm._s(props.item.name))])])],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":"","lazy":"","max-width":"175px"}},[_c('v-btn',{staticClass:"mt-0 mb-0",attrs:{"slot":"activator","flat":"","block":""},slot:"activator"},[_vm._v("\n                  Ksh. "+_vm._s(props.item.price)+"\n                  "),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("info\n                  ")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.description))])],1),_vm._v(" "),(_vm.isDepartmentUser() || _vm.isDepartmentHead())?_c('v-card-actions',[(props.item.quantityInCart)?_c('v-badge',{attrs:{"small":"","color":"accent","overlap":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(props.item.quantityInCart))]),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("shopping_basket")])],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","small":"","outline":""},nativeOn:{"click":function($event){_vm.selectedProduct = props.item}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("shopping_cart\n                  ")]),_vm._v("\n                  Add to cart\n                ")],1)],1):_vm._e()],1)],1)}}])})],1)],1)],1),_vm._v(" "),_c('add-to-cart-dialog',{attrs:{"product":_vm.selectedProduct},on:{"onCancel":function($event){_vm.selectedProduct = null}}}),_vm._v(" "),_c('cart-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItServices_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e360cbc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItServices_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e360cbc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e360cbc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceRequestDialog_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a042234a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceRequestDialog_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a042234a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceRequestDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a042234a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceRequestDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"lazy":"","persistent":"","min-height":"600px","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dense":"","color":"primary","dark":""}},[_c('v-icon',{staticClass:"mx-3"},[_vm._v(_vm._s(_vm.type === 'it' ? 'computer' : 'build'))]),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$route.name))])],1),_vm._v(" "),_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-select',{staticClass:"mb-3",attrs:{"disabled":_vm.connecting,"label":_vm.detailsLabel,"multiple":"","required":"","rules":[function () { return _vm.select.length > 0 || 'You must choose at least one'; }],"hint":_vm.detailsHint,"persistent-hint":"","chips":"","tags":"","search-input":_vm.search,"loading":_vm.loading,"items":_vm.items},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"note","rows":"2","label":"Write a short note","placeholder":"Short note","disabled":_vm.connecting,"multi-line":""},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}}),_vm._v(" "),_c('v-alert',{attrs:{"type":"info"}},[_vm._v("\n        If you don't schedule, this issue will be attended to immediately\n      ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('date-input',{attrs:{"placeholder":"Schedule date","disabled":_vm.connecting},model:{value:(_vm.scheduleDate),callback:function ($$v) {_vm.scheduleDate=$$v},expression:"scheduleDate"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"xs6":""}},[_c('time-input',{attrs:{"placeholder":"Schedule time","disabled":_vm.connecting},model:{value:(_vm.scheduleTime),callback:function ($$v) {_vm.scheduleTime=$$v},expression:"scheduleTime"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.$emit('onClose')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.formIsValid || _vm.connecting},on:{"click":function($event){$event.stopPropagation();return _vm.submit($event)}}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tabs',{attrs:{"fixed-tabs":"","slider-color":"accent","lazy":"","grow":""},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_c('v-tab',{attrs:{"href":"#pendingApproval"}},[_vm._v("Pending Approval")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#pendingQuotes"}},[_vm._v("Pending/Rejected Quotes")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#pendingAttendance"}},[_vm._v("Pending Attendance")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#attended"}},[_vm._v("Attended")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#rejected"}},[_vm._v("Rejected")])],1),_vm._v(" "),_c('v-card',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.serviceRequests,"loading":_vm.loading,"no-data-text":_vm.loading ? '' : 'No data available',"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('p',{staticClass:"ma-2"},[_vm._v(_vm._s(props.item.details.replace(/#/g , ', ')))]),_vm._v(" "),_c('div',[(props.item.status === 'AT_DEPARTMENT_HEAD' || props.item.status === 'AT_PURCHASING_HEAD')?_c('v-chip',{attrs:{"label":"","outline":"","color":"info","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Pending "+_vm._s(props.item.status === 'AT_DEPARTMENT_HEAD' ? ' Department ' :
                ' Purchasing ')+" Head approval\n              ")],1):_vm._e(),_vm._v(" "),(_vm.currentTab==='pendingQuotes')?_c('v-chip',{attrs:{"label":"","outline":"","color":"red","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                "+_vm._s(props.item.status)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.currentTab==='rejected')?_c('v-chip',{attrs:{"label":"","outline":"","color":"red","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info")]),_vm._v("\n                Rejected by "+_vm._s(props.item.rejectedBy.role.name)+" - "+_vm._s(props.item.rejectedBy.name)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.showApprovalActions(props.item))?_c('v-btn',{attrs:{"flat":"","color":"red","small":"","outline":""},nativeOn:{"click":function($event){_vm.reject(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("close")]),_vm._v("\n                Reject\n              ")],1):_vm._e(),_vm._v(" "),(_vm.showApprovalActions(props.item))?_c('v-btn',{attrs:{"flat":"","color":"success","small":"","outline":""},nativeOn:{"click":function($event){_vm.confirm(props.item)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("check_circle")]),_vm._v("\n                Approve\n              ")],1):_vm._e()],1)]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.scheduleDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.scheduleTime))])]}}])})],1)],1),_vm._v(" "),(_vm.isDepartmentUser())?_c('v-fab-transition',[_c('v-btn',{staticClass:"ma-5",attrs:{"color":"accent","fab":"","dark":"","fixed":"","bottom":"","value":false,"right":""},nativeOn:{"click":function($event){_vm.addingServiceRequest = true}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),_c('service-request-dialog',{attrs:{"show":_vm.addingServiceRequest,"type":_vm.type},on:{"onClose":_vm.onCloseAddingServiceRequest}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('service-requests',{attrs:{"type":"it"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepairServices_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_814beb3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepairServices_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-814beb3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepairServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_814beb3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepairServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('service-requests',{attrs:{"type":"repair"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640a8c67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-640a8c67"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640a8c67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CrudRemoteSelect_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0f6a23_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CrudRemoteSelect_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e0f6a23"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CrudRemoteSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0f6a23_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CrudRemoteSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{key:'#'+_vm.header.id,attrs:{"id":'#'+_vm.header.id,"items":_vm.items,"hint":_vm.editing ? _vm.header.editHint : _vm.header.createHint,"label":_vm.header.text,"required":_vm.required,"rules":_vm.required ? [_vm.rules.required] : [],"disabled":_vm.disabled,"item-text":"name","item-value":"id","single-line":"","autocomplete":"","cache-items":"","persistent-hint":"","search-input":_vm.query,"loading":_vm.searching},on:{"update:searchInput":function($event){_vm.query=$event}},model:{value:(_vm.itemId),callback:function ($$v) {_vm.itemId=$$v},expression:"itemId"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"600px","persistent":""},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("\n          "+_vm._s(_vm.formTitle)+"\n        ")])],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('connection-manager',{ref:"editConnectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.headers),function(header,index){return (_vm.isEditable(header))?_c('v-flex',{key:index,attrs:{"xs12":""}},[(header.type === 'select')?_c('v-select',{attrs:{"items":_vm.toOptions(header.options),"placeholder":_vm.toPlaceholder(header.text),"label":header.text,"hint":_vm.itemToEditIndex > -1 ? header.editHint : header.createHint,"persistent-hint":"","required":_vm.isRequired(header),"rules":_vm.isRequired(header) ? [_vm.rules.required] : [],"disabled":_vm.connecting},model:{value:(_vm.itemToEdit[header.value]),callback:function ($$v) {_vm.$set(_vm.itemToEdit, header.value, $$v)},expression:"itemToEdit[header.value]"}}):(header.type === 'select_remote')?_c('crud-remote-select',{attrs:{"header":header,"editing":_vm.itemToEditIndex > -1,"disabled":_vm.connecting,"required":_vm.isRequired(header)},model:{value:(_vm.itemToEdit[header.value]),callback:function ($$v) {_vm.$set(_vm.itemToEdit, header.value, $$v)},expression:"itemToEdit[header.value]"}}):(header.type === 'location')?_c('google-place-input',{ref:"locationInput",refInFor:true,attrs:{"header":header,"disabled":_vm.connecting,"id":"destination","country":"KE","clearable":false,"enable-geolocation":true,"label":"Enter location","placeholder":"Location","prepend-icon":"edit_location","required":true,"rules":_vm.isRequired(header) ? [_vm.rules.required] : [],"load-google-api":false,"google-api-key":_vm.$app.googleMapsKey,"hint":!_vm.placeResultData ? '' : _vm.placeResultData.formatted_address,"persistent-hint":"","hide-details":false,"types":"establishment"},on:{"placechanged":_vm.onLocationEntered},model:{value:(_vm.itemToEdit[header.value]),callback:function ($$v) {_vm.$set(_vm.itemToEdit, header.value, $$v)},expression:"itemToEdit[header.value]"}}):_c('v-text-field',{attrs:{"placeholder":_vm.toPlaceholder(header.text),"label":header.text,"type":header.type,"mask":header.mask,"required":_vm.isRequired(header),"rules":_vm.isRequired(header) ? [_vm.rules.required] : [],"hint":_vm.itemToEditIndex > -1 ? header.editHint : header.createHint,"persistent-hint":"","disabled":_vm.connecting},model:{value:(_vm.itemToEdit[header.value]),callback:function ($$v) {_vm.$set(_vm.itemToEdit, header.value, $$v)},expression:"itemToEdit[header.value]"}})],1):_vm._e()}))],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary darken-1","flat":"","disabled":_vm.connecting || !_vm.valid},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px"},model:{value:(_vm.viewDialog),callback:function ($$v) {_vm.viewDialog=$$v},expression:"viewDialog"}},[(_vm.itemToView)?_c('v-card',[_c('v-card-text',[_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewableHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manager.toValue(props.item, _vm.itemToView)))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":""},nativeOn:{"click":function($event){_vm.itemToView = null}}},[_vm._v("Close\n        ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[(_vm.itemToDelete)?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"deleteConnectionManager",model:{value:(_vm.deleting),callback:function ($$v) {_vm.deleting=$$v},expression:"deleting"}}),_vm._v(" "),_c('p',[_vm._v("Confirm you want to delete ")]),_c('b',[_vm._v(_vm._s(_vm.manager.nameOnDelete(_vm.itemToDelete)))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.deleting},nativeOn:{"click":function($event){return _vm.doDelete($event)}}},[_vm._v("Delete\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","disabled":_vm.deleting},nativeOn:{"click":function($event){_vm.itemToDelete = null}}},[_vm._v("Cancel\n        ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"color":"transparent","dense":"","flat":"","card":""}},[(_vm.creatable)?_c('v-btn',{staticClass:"mx-5",attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.editDialog = true}}},[_vm._v("\n        Add\n      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.extraTopActions),function(action,index){return (_vm.manager.showTopAction(action, _vm.items, _vm.currentFilter))?_c('v-btn',{key:index,staticClass:"mx-5",attrs:{"color":action.color ? action.color : 'primary'},nativeOn:{"click":function($event){_vm.manager.onTopAction(action, _vm.items, _vm.currentFilter)}}},[_vm._v("\n        "+_vm._s(action.name)+"\n      ")]):_vm._e()}),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-menu',{attrs:{"transition":"slide-y-transition","bottom":"","offset-y":""}},[(_vm.filters && _vm.filters.length)?_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":"","flat":""},slot:"activator"},[_vm._v("\n          "+_vm._s(_vm.currentFilter ? _vm.currentFilter.name : 'Filters')+"\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_down")])],1):_vm._e(),_vm._v(" "),_c('v-list',_vm._l((_vm.filters),function(filter,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.currentFilter = filter}}},[_c('v-list-tile-title',[_vm._v(_vm._s(filter.name))])],1)}))],1)],2),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.browsableHeaders,"items":_vm.items,"item-key":"id","search":_vm.search,"expand":"","no-data-text":_vm.connecting ? '' : 'No data available',"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){_vm.extraInlineActions.length ? props.expanded = !props.expanded : ''}}},[_vm._l((_vm.browsableHeaders),function(header,index){return (header.value !== 'actions' )?_c('td',{key:index,class:['text-xs-' + header.align]},[_vm._v("\n          "+_vm._s(_vm.manager.toValue(header, props.item))+"\n        ")]):_vm._e()}),_vm._v(" "),_c('td',[_c('v-btn-toggle',{attrs:{"light":""}},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.viewItem(props.item)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("visibility")])],1),_vm._v(" "),(_vm.manager.deletable(props.item))?_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),(_vm.manager.editable(props.item))?_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":""}},[(_vm.extraOverflowActions.length)?_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1):_vm._e(),_vm._v(" "),_c('v-list',_vm._l((_vm.extraOverflowActions),function(action,index){return (_vm.manager.showExtraOverflowActions(action, _vm.currentFilter))?_c('v-list-tile',{key:index,on:{"click":function($event){_vm.manager.fireAction(action, props.item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(action.name))])],1):_vm._e()}))],1)],1)],1)],2)]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._l((_vm.extraInlineActions),function(action,index){return (_vm.manager.showInlineAction(action, props.item, _vm.currentFilter))?_c('v-btn',{key:index,staticClass:"ml-0 mr-1",attrs:{"color":action.color,"small":""},nativeOn:{"click":function($event){_vm.manager.onInlineActionClicked(action, props.item, _vm.currentFilter)}}},[_vm._v("\n              "+_vm._s(action.name)+"\n            ")]):_vm._e()})],2)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-breadcrumbs',[_c('v-breadcrumbs-item',[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("Orders")])],1),_vm._v(" "),_c('crud',{ref:"crud",attrs:{"resource":"orders","manager":_vm.manager,"filters":(_vm.isAdmin() || _vm.isOperations()) ? _vm.adminAndOperationsFilters : _vm.clientFilters,"creatable":false,"extra-inline-actions":_vm.extraInlineActions,"extra-top-actions":_vm.extraTopActions,"custom-view-dialog":true}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.viewDialogHere),callback:function ($$v) {_vm.viewDialogHere=$$v},expression:"viewDialogHere"}},[(_vm.item)?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewableHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manager.toValue(props.item, _vm.item)))])]}}])}),_vm._v(" "),_c('v-data-table',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"items":_vm.item.items,"hide-actions":"","item-key":"id","headers":_vm.productHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.priceAtPurchase)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.priceAtPurchase*props.item.quantity)))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Close\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.showRejectButton(_vm.item))?_c('v-btn',{attrs:{"flat":"","color":"red","small":"","outline":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.approveOrReject('reject')}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("close\n          ")]),_vm._v("\n          Reject\n        ")],1):_vm._e(),_vm._v(" "),(_vm.showApproveButton(_vm.item))?_c('v-btn',{attrs:{"flat":"","color":"success","small":"","outline":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.approveOrReject('approve')}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("check_circle\n          ")]),_vm._v("\n          Approve\n        ")],1):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.dispatching),callback:function ($$v) {_vm.dispatching=$$v},expression:"dispatching"}},[(_vm.dispatchingItem)?_c('v-card',[_c('v-card-text',[_c('guide',{attrs:{"text":"The order will be assigned to the available rider!"}}),_vm._v(" "),_c('connection-manager',{ref:"dispatchConnectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewableHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manager.toValue(props.item, _vm.dispatchingItem)))])]}}])}),_vm._v(" "),_c('v-data-table',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"items":_vm.dispatchingItem.items,"hide-actions":"","item-key":"id","headers":_vm.productHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.priceAtPurchase)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.priceAtPurchase*props.item.quantity)))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.dispatching = false}}},[_vm._v("Close\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.dispatch($event)}}},[_vm._v("Dispatch\n        ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.confirmingReceived),callback:function ($$v) {_vm.confirmingReceived=$$v},expression:"confirmingReceived"}},[(_vm.confirmingReceivedItem)?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"confirmingReceivedConnectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('guide',{attrs:{"text":"Confirm the following order was received successfully!"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('v-text-field',{attrs:{"rules":[_vm.rules.required],"counter":4,"label":"Confirmation token","persistent-hint":"","hint":"Enter a 4 digits confirmation code that was sent to the person who placed this order","required":""},model:{value:(_vm.confirmationToken),callback:function ($$v) {_vm.confirmationToken=$$v},expression:"confirmationToken"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm4":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.resendConfirmationCode($event)}}},[_vm._v("Resend confirmation\n              token\n            ")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewableHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manager.toValue(props.item, _vm.confirmingReceivedItem)))])]}}])}),_vm._v(" "),_c('v-data-table',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"items":_vm.confirmingReceivedItem.items,"hide-actions":"","item-key":"id","headers":_vm.productHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.priceAtPurchase)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.priceAtPurchase*props.item.quantity)))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.confirmingReceived = false}}},[_vm._v("Close\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || !_vm.confirmationToken},nativeOn:{"click":function($event){return _vm.confirmReceived($event)}}},[_vm._v("Confirm\n        ")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c1c3836_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c1c3836"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c1c3836_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUsers_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e80f6c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUsers_vue__ = __webpack_require__(647);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e80f6c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e80f6c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"users","manager":_vm.manager}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientUsers_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3f0c6aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientUsers_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(649)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3f0c6aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3f0c6aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUserDialog_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d117666_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUserDialog_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d117666"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUserDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d117666_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUserDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{attrs:{"color":"primary","extended":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":""}},[_c('v-card',{staticStyle:{"margin-top":"-64px"}},[_c('v-toolbar',{attrs:{"color":"white"}},[_c('v-icon',[_vm._v("group")]),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Users")])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager"}),_vm._v(" "),_c('v-list',{attrs:{"three-line":""}},[_vm._l((_vm.users),function(user,index){return [_c('v-list-tile',{key:user.id},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(user.avatar)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(user.role.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(user.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(user.email)}})],1),_vm._v(" "),_c('v-list-tile-action',[(user.id !== _vm.$auth.user().id)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editItem(user)}}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(user.id !== _vm.$auth.user().id)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteItem(user)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1):_vm._e()],1)],1),_vm._v(" "),(index !== (_vm.users.length - 1))?_c('v-divider',{key:user.email+'_'+user.phone,attrs:{"inset":""}}):_vm._e()]})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{staticClass:"ma-5",attrs:{"color":"accent","fab":"","dark":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.editDialog = true}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lazy":"","max-width":"600px","persistent":""},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","card":"","color":"primary"}},[_c('v-icon',[_vm._v("person")]),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Add User")])],1),_vm._v(" "),_c('connection-manager',{ref:"editConnectionManager",model:{value:(_vm.editingUser),callback:function ($$v) {_vm.editingUser=$$v},expression:"editingUser"}}),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-text-field',{attrs:{"placeholder":"Full name","label":"Enter full name","required":"","type":"text","rules":[_vm.rules.required],"disabled":_vm.editingUser},model:{value:(_vm.userToEdit['name']),callback:function ($$v) {_vm.$set(_vm.userToEdit, 'name', $$v)},expression:"userToEdit['name']"}}),_vm._v(" "),_c('v-text-field',{staticClass:"mb-2",attrs:{"label":"Enter phone number","placeholder":"Phone number","required":"","rules":[_vm.rules.required, _vm.rules.phone],"type":"phone","disabled":_vm.editingUser,"mask":"##########","counter":10,"hint":"A password will be sent to this phone number","persistent-hint":""},model:{value:(_vm.userToEdit['phone']),callback:function ($$v) {_vm.$set(_vm.userToEdit, 'phone', $$v)},expression:"userToEdit['phone']"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":"Password","label":"Enter a password","required":"","type":"password","rules":_vm.userToEditIndex > -1 ? [] : [_vm.rules.required],"hint":_vm.userToEditIndex > -1 ? 'Leave empty to keep the same password' :
            'Password will be sent to the user phone number',"disabled":_vm.editingUser,"persistent-hint":""},model:{value:(_vm.userToEdit['password']),callback:function ($$v) {_vm.$set(_vm.userToEdit, 'password', $$v)},expression:"userToEdit['password']"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":"Email address","label":"Enter email address","required":"","type":"email","rules":[_vm.rules.required, _vm.rules.email],"disabled":_vm.editingUser},model:{value:(_vm.userToEdit['email']),callback:function ($$v) {_vm.$set(_vm.userToEdit, 'email', $$v)},expression:"userToEdit['email']"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.roles,"required":"","label":"Select user role","disabled":_vm.editingUser,"clearable":""},model:{value:(_vm.roleName),callback:function ($$v) {_vm.roleName=$$v},expression:"roleName"}}),_vm._v(" "),(_vm.roleName !== 'ADMIN' && _vm.roleName !==   'PURCHASING_HEAD')?_c('v-select',{attrs:{"items":_vm.$auth.user().client.departments,"item-text":"name","item-value":"id","required":"","label":"Select department","disabled":_vm.editingUser,"clearable":""},model:{value:(_vm.userToEdit['departmentId']),callback:function ($$v) {_vm.$set(_vm.userToEdit, 'departmentId', $$v)},expression:"userToEdit['departmentId']"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.editingUser},on:{"click":_vm.close}},[_vm._v("Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.editingUser || !_vm.formValid || !_vm.roleName},on:{"click":_vm.save}},[_vm._v("Add User\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[(_vm.userToDelete)?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"deleteConnectionManager",model:{value:(_vm.deletingUser),callback:function ($$v) {_vm.deletingUser=$$v},expression:"deletingUser"}}),_vm._v(" "),_c('p',[_vm._v("Confirm you want to delete ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.userToDelete.name))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.deletingUser},nativeOn:{"click":function($event){return _vm.doDelete($event)}}},[_vm._v("Delete\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","disabled":_vm.deletingUser},nativeOn:{"click":function($event){_vm.userToDelete = null}}},[_vm._v("Cancel\n        ")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.isAdmin() || _vm.isOperations())?_c('admin-users'):_c('client-users')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c51ec320_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(660);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c51ec320"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c51ec320_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePasswordDialog_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d07f6f98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePasswordDialog_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d07f6f98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePasswordDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d07f6f98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePasswordDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"lazy":"","max-width":"600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","card":"","color":"primary"}},[_c('v-icon',[_vm._v("vpn_key")]),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Change your password")])],1),_vm._v(" "),_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":"Current Password","label":"Enter your current password","required":"","type":"password","rules":[_vm.rules.required],"disabled":_vm.connecting},model:{value:(_vm.currentPassword),callback:function ($$v) {_vm.currentPassword=$$v},expression:"currentPassword"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":"New Password","label":"Enter your new password","required":"","type":"password","rules":[_vm.rules.required],"disabled":_vm.connecting},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}}),_vm._v(" "),_c('v-text-field',{attrs:{"placeholder":"Confirm Password","label":"Confirm your new password","required":"","type":"password","rules":[_vm.rules.required],"disabled":_vm.connecting},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}}),_vm._v(" "),_c('guide',{attrs:{"text":"You will be signed out so as to Sign In with the new password"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.$emit('onClose')}}},[_vm._v("Cancel\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || !_vm.validates},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("Submit\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-media',{attrs:{"src":_vm.$app.imageUrl(_vm.$auth.user().client.logo),"height":"250px"}}),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","offset-xs2":""}},[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Name and email")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(_vm.$auth.user().avatar)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$auth.user().name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$auth.user().email))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.changingPassword = true}}},[_vm._v("Change Password\n                  ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Department and role")]),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("group_work")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$auth.user().department ? _vm.$auth.user().department.name : 'N/A')+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$auth.user().role.name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Upcoming Appointments")]),_vm._v(" "),_c('connection-manager',{ref:"connectionManager"}),_vm._v(" "),_vm._l((_vm.appointments),function(appointment,index){return [_c('v-list-tile',{key:appointment.id},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(appointment.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('v-chip',{attrs:{"label":"","small":"","color":"accent","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("access_time")]),_vm._v("\n                        "+_vm._s(appointment.allDay ? 'All day'
                        : appointment.startingAt+' -'+appointment.endingAt)+"\n                      ")],1)],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(appointment.venue))])],1)],1),_vm._v(" "),((index+1) < _vm.appointments.length)?_c('v-divider',{key:appointment.id+index+1}):_vm._e()]})],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('change-password-dialog',{attrs:{"show":_vm.changingPassword},on:{"onClose":function($event){_vm.changingPassword=false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Departments_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f49e3c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Departments_vue__ = __webpack_require__(663);
function injectStyle (ssrContext) {
  __webpack_require__(662)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f49e3c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Departments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f49e3c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Departments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"departments","manager":_vm.manager}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26057c9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__(666);
function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26057c9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26057c9c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"clients","manager":_vm.manager},on:{"client-created":_vm.clientCreated}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f88cbe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f88cbe6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f88cbe6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"roles","manager":_vm.manager}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopUps_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba05fa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopUps_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ba05fa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopUps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba05fa4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopUps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"topUps","manager":_vm.manager}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85cea6a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85cea6a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85cea6a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"categories","manager":_vm.manager}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52604c26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52604c26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52604c26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"products","manager":_vm.manager}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deliveries_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3f0dc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deliveries_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed3f0dc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deliveries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3f0dc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deliveries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{ref:"crud",attrs:{"resource":"deliveries","manager":_vm.manager,"custom-view-dialog":true,"filters":_vm.filters,"creatable":false,"extra-overflow-actions":_vm.extraOverflowActions}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.viewDialogHere),callback:function ($$v) {_vm.viewDialogHere=$$v},expression:"viewDialogHere"}},[(_vm.item)?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewableHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manager.toValue(props.item, _vm.item)))])]}}])}),_vm._v(" "),_c('v-data-table',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"items":_vm.item.items,"hide-actions":"","item-key":"id","headers":_vm.itemHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.courierOption.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.destinationName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.recipientName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.recipientContact))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.receivedTime ? props.item.receivedTime : _vm.defaultValue))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n          Close\n        ")]),_vm._v(" "),_c('v-spacer')],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.proceedWithCancel),callback:function ($$v) {_vm.proceedWithCancel=$$v},expression:"proceedWithCancel"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Do you want to cancel this delivery?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        The action can't be reversed and the client will be charged\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"solo":"","name":"input-7-4","label":"Reason"},model:{value:(_vm.cancellationReason),callback:function ($$v) {_vm.cancellationReason=$$v},expression:"cancellationReason"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.proceedWithCancel = false}}},[_vm._v("\n          Go Back\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.cancelDelivery()}}},[_vm._v("\n          Proceed\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.changeUrgency),callback:function ($$v) {_vm.changeUrgency=$$v},expression:"changeUrgency"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Do you want to change the urgency?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Changing the urgency will affect the cost of the delivery\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.changeUrgency = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.changeDeliveryUrgency()}}},[_vm._v("\n          Continue\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderedItems_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6632dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderedItems_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a6632dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderedItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6632dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderedItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{ref:"crud",attrs:{"resource":_vm.isSupplier() ? 'orderItems' : _vm.isAdmin() ? 'orderItems' : 'rawOrderItems',"manager":_vm.manager,"extra-top-actions":_vm.extraTopActions,"creatable":false,"filters":_vm.isSupplier() ? _vm.supplierFilters : _vm.isDepartmentUser() ? _vm.clientFilters : _vm.isDepartmentHead() ? _vm.clientFilters :_vm.isPurchasingHead() ? _vm.clientFilters: _vm.adminAndOperationsFilters,"hiddenHeaders":_vm.isSupplier() ? _vm.supplierHiddenHeaders : []}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.selectingItems),callback:function ($$v) {_vm.selectingItems=$$v},expression:"selectingItems"}},[(_vm.isSupplier())?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"select-all":"","item-key":"id","hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected},on:{"click":function($event){props.selected = !props.selected}}},[_c('td',[_c('v-checkbox',{attrs:{"input-value":props.selected,"primary":"","hide-details":""}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.priceAtPurchase))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney((props.item.quantity * props.item.priceAtPurchase))))])])]}}]),model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}}),_vm._v(" "),_c('guide',{attrs:{"text":"It will be considered that you cannot deliver the items that are not selected"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.selectingItems = false}}},[_vm._v("Close\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || !_vm.selectedItems.length},nativeOn:{"click":function($event){return _vm.generateLPO($event)}}},[_vm._v("Submit\n          ")])],1)],1):_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.departmentHeadHeaders,"items":_vm.items,"select-all":"","item-key":"id","hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected}},[_c('td',[_c('v-checkbox',{attrs:{"input-value":props.selected,"primary":"","disabled":!props.item.quantity || props.item.quantity <= 0,"hide-details":""},on:{"click":function($event){props.selected = !props.selected}}})],1),_vm._v(" "),(props.item.product)?_c('td',[_vm._v(_vm._s(props.item.product.name))]):_vm._e(),_vm._v(" "),(!props.item.product)?_c('td',[_vm._v("----")]):_vm._e(),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!props.item.edit),expression:"!props.item.edit"}]},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(props.item.edit),expression:"props.item.edit"}]},[_c('v-text-field',{attrs:{"label":"New Quantity","mask":"##","rules":[_vm.rules.required, _vm.rules.quantity],"maxLength":"10px"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }props.item.quantity > 0 ? props.item.edit = !props.item.edit : function (){}}},model:{value:(props.item.quantity),callback:function ($$v) {_vm.$set(props.item, "quantity", $$v)},expression:"props.item.quantity"}})],1)]),_vm._v(" "),_c('td',{staticClass:"justify-center layout wrap px-0"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!props.item.edit),expression:"!props.item.edit"}]},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){props.item.edit = !props.item.edit}}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(props.item.edit),expression:"props.item.edit"}]},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":!props.item.quantity || props.item.quantity <= 0},on:{"click":function($event){props.item.edit = !props.item.edit}}},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.priceAtPurchase))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney((props.item.quantity * props.item.priceAtPurchase)))+"\n                ")])])]}}]),model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}},[_c('template',{slot:"footer"},[_c('tr',{staticClass:"grey lighten-2"},[_c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Total tem cost")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(this.$app.formatMoney(_vm.totalCost)))])])]),_vm._v(" "),(_vm.isPurchasingHead())?_c('tr',{staticClass:"grey lighten-2"},[_c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Delivery cost")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(this.$app.formatMoney(_vm.deliveryCost)))])])]):_vm._e(),_vm._v(" "),(_vm.isPurchasingHead())?_c('tr',{staticClass:"grey lighten-2"},[_c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Total amount payable")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(this.$app.formatMoney(_vm.amountPayable)))])])]):_vm._e()])],2),_vm._v(" "),_c('guide',{attrs:{"text":"It will be considered that you reject the items that are not selected"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.selectingItems = false}}},[_vm._v("Close\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || !_vm.selectedItems.length || !_vm.selectedItemsValid()},nativeOn:{"click":function($event){return _vm.approveItems($event)}}},[_vm._v("Approve\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LPOs_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dba5634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LPOs_vue__ = __webpack_require__(811);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dba5634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LPOs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dba5634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LPOs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadButton_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_877c3af2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadButton_vue__ = __webpack_require__(689);
function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-877c3af2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_877c3af2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-primary jbtn-file"},[_vm._v(" "+_vm._s(_vm.title)),_c('input',{attrs:{"type":"file"},on:{"change":_vm.fileSelected}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePicker_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138600e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilePicker_vue__ = __webpack_require__(691);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138600e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{ref:"fileTextField",attrs:{"prepend-icon":"attach_file","single-line":"","label":_vm.label,"accept":_vm.accept,"disabled":_vm.$upload.meta(_vm.name).status === 'sending' || _vm.disabled},on:{"click":function($event){_vm.$upload.select(_vm.name)}},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}}),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.$upload.meta(_vm.name).percentComplete === 100),expression:"$upload.meta(name).percentComplete === 100"}],attrs:{"indeterminate":true}}),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.$upload.meta(_vm.name).status === 'sending' && _vm.$upload.meta(_vm.name).percentComplete < 100),expression:"$upload.meta(name).status === 'sending' && $upload.meta(name).percentComplete < 100"}],attrs:{"color":"teal"},model:{value:(_vm.$upload.meta(_vm.name).percentComplete),callback:function ($$v) {_vm.$set(_vm.$upload.meta(_vm.name), "percentComplete", $$v)},expression:"$upload.meta(name).percentComplete"}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._l((_vm.$upload.errors(_vm.name)),function(error){return _c('div',[_vm._v("\n          "+_vm._s(error.rule)+": "+_vm._s(error.message)+"\n        ")])}),_vm._v(" "),_c('div',[_c('pre',[_vm._v("                      "),_c('code',[_vm._v(_vm._s(_vm.message))]),_vm._v("\n                  ")])])],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.reset()}}},[_vm._v("Okay")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vuePdfNoSss_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vuePdfNoSss_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */,
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_sensor_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_resize_sensor_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 775 */,
/* 776 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 795 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 796 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./78-EUC-H.bcmap": [
		872,
		168
	],
	"./78-EUC-V.bcmap": [
		873,
		167
	],
	"./78-H.bcmap": [
		874,
		166
	],
	"./78-RKSJ-H.bcmap": [
		875,
		165
	],
	"./78-RKSJ-V.bcmap": [
		876,
		164
	],
	"./78-V.bcmap": [
		877,
		163
	],
	"./78ms-RKSJ-H.bcmap": [
		878,
		162
	],
	"./78ms-RKSJ-V.bcmap": [
		879,
		161
	],
	"./83pv-RKSJ-H.bcmap": [
		880,
		160
	],
	"./90ms-RKSJ-H.bcmap": [
		881,
		159
	],
	"./90ms-RKSJ-V.bcmap": [
		882,
		158
	],
	"./90msp-RKSJ-H.bcmap": [
		883,
		157
	],
	"./90msp-RKSJ-V.bcmap": [
		884,
		156
	],
	"./90pv-RKSJ-H.bcmap": [
		885,
		155
	],
	"./90pv-RKSJ-V.bcmap": [
		886,
		154
	],
	"./Add-H.bcmap": [
		887,
		153
	],
	"./Add-RKSJ-H.bcmap": [
		888,
		152
	],
	"./Add-RKSJ-V.bcmap": [
		889,
		151
	],
	"./Add-V.bcmap": [
		890,
		150
	],
	"./Adobe-CNS1-0.bcmap": [
		891,
		149
	],
	"./Adobe-CNS1-1.bcmap": [
		892,
		148
	],
	"./Adobe-CNS1-2.bcmap": [
		893,
		147
	],
	"./Adobe-CNS1-3.bcmap": [
		894,
		146
	],
	"./Adobe-CNS1-4.bcmap": [
		895,
		145
	],
	"./Adobe-CNS1-5.bcmap": [
		896,
		144
	],
	"./Adobe-CNS1-6.bcmap": [
		897,
		143
	],
	"./Adobe-CNS1-UCS2.bcmap": [
		898,
		142
	],
	"./Adobe-GB1-0.bcmap": [
		899,
		141
	],
	"./Adobe-GB1-1.bcmap": [
		900,
		140
	],
	"./Adobe-GB1-2.bcmap": [
		901,
		139
	],
	"./Adobe-GB1-3.bcmap": [
		902,
		138
	],
	"./Adobe-GB1-4.bcmap": [
		903,
		137
	],
	"./Adobe-GB1-5.bcmap": [
		904,
		136
	],
	"./Adobe-GB1-UCS2.bcmap": [
		905,
		135
	],
	"./Adobe-Japan1-0.bcmap": [
		906,
		134
	],
	"./Adobe-Japan1-1.bcmap": [
		907,
		133
	],
	"./Adobe-Japan1-2.bcmap": [
		908,
		132
	],
	"./Adobe-Japan1-3.bcmap": [
		909,
		131
	],
	"./Adobe-Japan1-4.bcmap": [
		910,
		130
	],
	"./Adobe-Japan1-5.bcmap": [
		911,
		129
	],
	"./Adobe-Japan1-6.bcmap": [
		912,
		128
	],
	"./Adobe-Japan1-UCS2.bcmap": [
		913,
		127
	],
	"./Adobe-Korea1-0.bcmap": [
		914,
		126
	],
	"./Adobe-Korea1-1.bcmap": [
		915,
		125
	],
	"./Adobe-Korea1-2.bcmap": [
		916,
		124
	],
	"./Adobe-Korea1-UCS2.bcmap": [
		917,
		123
	],
	"./B5-H.bcmap": [
		918,
		122
	],
	"./B5-V.bcmap": [
		919,
		121
	],
	"./B5pc-H.bcmap": [
		920,
		120
	],
	"./B5pc-V.bcmap": [
		921,
		119
	],
	"./CNS-EUC-H.bcmap": [
		922,
		118
	],
	"./CNS-EUC-V.bcmap": [
		923,
		117
	],
	"./CNS1-H.bcmap": [
		924,
		116
	],
	"./CNS1-V.bcmap": [
		925,
		115
	],
	"./CNS2-H.bcmap": [
		926,
		114
	],
	"./CNS2-V.bcmap": [
		927,
		113
	],
	"./ETHK-B5-H.bcmap": [
		928,
		112
	],
	"./ETHK-B5-V.bcmap": [
		929,
		111
	],
	"./ETen-B5-H.bcmap": [
		930,
		110
	],
	"./ETen-B5-V.bcmap": [
		931,
		109
	],
	"./ETenms-B5-H.bcmap": [
		932,
		108
	],
	"./ETenms-B5-V.bcmap": [
		933,
		107
	],
	"./EUC-H.bcmap": [
		934,
		106
	],
	"./EUC-V.bcmap": [
		935,
		105
	],
	"./Ext-H.bcmap": [
		936,
		104
	],
	"./Ext-RKSJ-H.bcmap": [
		937,
		103
	],
	"./Ext-RKSJ-V.bcmap": [
		938,
		102
	],
	"./Ext-V.bcmap": [
		939,
		101
	],
	"./GB-EUC-H.bcmap": [
		940,
		100
	],
	"./GB-EUC-V.bcmap": [
		941,
		99
	],
	"./GB-H.bcmap": [
		942,
		98
	],
	"./GB-V.bcmap": [
		943,
		97
	],
	"./GBK-EUC-H.bcmap": [
		944,
		96
	],
	"./GBK-EUC-V.bcmap": [
		945,
		95
	],
	"./GBK2K-H.bcmap": [
		946,
		94
	],
	"./GBK2K-V.bcmap": [
		947,
		93
	],
	"./GBKp-EUC-H.bcmap": [
		948,
		92
	],
	"./GBKp-EUC-V.bcmap": [
		949,
		91
	],
	"./GBT-EUC-H.bcmap": [
		950,
		90
	],
	"./GBT-EUC-V.bcmap": [
		951,
		89
	],
	"./GBT-H.bcmap": [
		952,
		88
	],
	"./GBT-V.bcmap": [
		953,
		87
	],
	"./GBTpc-EUC-H.bcmap": [
		954,
		86
	],
	"./GBTpc-EUC-V.bcmap": [
		955,
		85
	],
	"./GBpc-EUC-H.bcmap": [
		956,
		84
	],
	"./GBpc-EUC-V.bcmap": [
		957,
		83
	],
	"./H.bcmap": [
		958,
		82
	],
	"./HKdla-B5-H.bcmap": [
		959,
		81
	],
	"./HKdla-B5-V.bcmap": [
		960,
		80
	],
	"./HKdlb-B5-H.bcmap": [
		961,
		79
	],
	"./HKdlb-B5-V.bcmap": [
		962,
		78
	],
	"./HKgccs-B5-H.bcmap": [
		963,
		77
	],
	"./HKgccs-B5-V.bcmap": [
		964,
		76
	],
	"./HKm314-B5-H.bcmap": [
		965,
		75
	],
	"./HKm314-B5-V.bcmap": [
		966,
		74
	],
	"./HKm471-B5-H.bcmap": [
		967,
		73
	],
	"./HKm471-B5-V.bcmap": [
		968,
		72
	],
	"./HKscs-B5-H.bcmap": [
		969,
		71
	],
	"./HKscs-B5-V.bcmap": [
		970,
		70
	],
	"./Hankaku.bcmap": [
		971,
		69
	],
	"./Hiragana.bcmap": [
		972,
		68
	],
	"./KSC-EUC-H.bcmap": [
		973,
		67
	],
	"./KSC-EUC-V.bcmap": [
		974,
		66
	],
	"./KSC-H.bcmap": [
		975,
		65
	],
	"./KSC-Johab-H.bcmap": [
		976,
		64
	],
	"./KSC-Johab-V.bcmap": [
		977,
		63
	],
	"./KSC-V.bcmap": [
		978,
		62
	],
	"./KSCms-UHC-H.bcmap": [
		979,
		61
	],
	"./KSCms-UHC-HW-H.bcmap": [
		980,
		60
	],
	"./KSCms-UHC-HW-V.bcmap": [
		981,
		59
	],
	"./KSCms-UHC-V.bcmap": [
		982,
		58
	],
	"./KSCpc-EUC-H.bcmap": [
		983,
		57
	],
	"./KSCpc-EUC-V.bcmap": [
		984,
		56
	],
	"./Katakana.bcmap": [
		985,
		55
	],
	"./NWP-H.bcmap": [
		986,
		54
	],
	"./NWP-V.bcmap": [
		987,
		53
	],
	"./RKSJ-H.bcmap": [
		988,
		52
	],
	"./RKSJ-V.bcmap": [
		989,
		51
	],
	"./Roman.bcmap": [
		990,
		50
	],
	"./UniCNS-UCS2-H.bcmap": [
		991,
		49
	],
	"./UniCNS-UCS2-V.bcmap": [
		992,
		48
	],
	"./UniCNS-UTF16-H.bcmap": [
		993,
		47
	],
	"./UniCNS-UTF16-V.bcmap": [
		994,
		46
	],
	"./UniCNS-UTF32-H.bcmap": [
		995,
		45
	],
	"./UniCNS-UTF32-V.bcmap": [
		996,
		44
	],
	"./UniCNS-UTF8-H.bcmap": [
		997,
		43
	],
	"./UniCNS-UTF8-V.bcmap": [
		998,
		42
	],
	"./UniGB-UCS2-H.bcmap": [
		999,
		41
	],
	"./UniGB-UCS2-V.bcmap": [
		1000,
		40
	],
	"./UniGB-UTF16-H.bcmap": [
		1001,
		39
	],
	"./UniGB-UTF16-V.bcmap": [
		1002,
		38
	],
	"./UniGB-UTF32-H.bcmap": [
		1003,
		37
	],
	"./UniGB-UTF32-V.bcmap": [
		1004,
		36
	],
	"./UniGB-UTF8-H.bcmap": [
		1005,
		35
	],
	"./UniGB-UTF8-V.bcmap": [
		1006,
		34
	],
	"./UniJIS-UCS2-H.bcmap": [
		1007,
		33
	],
	"./UniJIS-UCS2-HW-H.bcmap": [
		1008,
		32
	],
	"./UniJIS-UCS2-HW-V.bcmap": [
		1009,
		31
	],
	"./UniJIS-UCS2-V.bcmap": [
		1010,
		30
	],
	"./UniJIS-UTF16-H.bcmap": [
		1011,
		29
	],
	"./UniJIS-UTF16-V.bcmap": [
		1012,
		28
	],
	"./UniJIS-UTF32-H.bcmap": [
		1013,
		27
	],
	"./UniJIS-UTF32-V.bcmap": [
		1014,
		26
	],
	"./UniJIS-UTF8-H.bcmap": [
		1015,
		25
	],
	"./UniJIS-UTF8-V.bcmap": [
		1016,
		24
	],
	"./UniJIS2004-UTF16-H.bcmap": [
		1017,
		23
	],
	"./UniJIS2004-UTF16-V.bcmap": [
		1018,
		22
	],
	"./UniJIS2004-UTF32-H.bcmap": [
		1019,
		21
	],
	"./UniJIS2004-UTF32-V.bcmap": [
		1020,
		20
	],
	"./UniJIS2004-UTF8-H.bcmap": [
		1021,
		19
	],
	"./UniJIS2004-UTF8-V.bcmap": [
		1022,
		18
	],
	"./UniJISPro-UCS2-HW-V.bcmap": [
		1023,
		17
	],
	"./UniJISPro-UCS2-V.bcmap": [
		1024,
		16
	],
	"./UniJISPro-UTF8-V.bcmap": [
		1025,
		15
	],
	"./UniJISX0213-UTF32-H.bcmap": [
		1026,
		14
	],
	"./UniJISX0213-UTF32-V.bcmap": [
		1027,
		13
	],
	"./UniJISX02132004-UTF32-H.bcmap": [
		1028,
		12
	],
	"./UniJISX02132004-UTF32-V.bcmap": [
		1029,
		11
	],
	"./UniKS-UCS2-H.bcmap": [
		1030,
		10
	],
	"./UniKS-UCS2-V.bcmap": [
		1031,
		9
	],
	"./UniKS-UTF16-H.bcmap": [
		1032,
		8
	],
	"./UniKS-UTF16-V.bcmap": [
		1033,
		7
	],
	"./UniKS-UTF32-H.bcmap": [
		1034,
		6
	],
	"./UniKS-UTF32-V.bcmap": [
		1035,
		5
	],
	"./UniKS-UTF8-H.bcmap": [
		1036,
		4
	],
	"./UniKS-UTF8-V.bcmap": [
		1037,
		3
	],
	"./V.bcmap": [
		1038,
		2
	],
	"./WP-Symbol.bcmap": [
		1039,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 804;
module.exports = webpackAsyncContext;

/***/ }),
/* 805 */,
/* 806 */,
/* 807 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 808 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 809 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 810 */,
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{ref:"crud",attrs:{"resource":"lpos","creatable":false,"manager":_vm.manager,"filters":_vm.isSupplier() ? _vm.supplierFilters : _vm.adminAndOperationsFilters,"hiddenHeaders":_vm.isSupplier() ? _vm.supplierHiddenHeaders : [],"extraInlineActions":_vm.isAdmin() || _vm.isOperations() ? _vm.extraInlineActions : []}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px","persistent":""},model:{value:(_vm.uploadingDeliveryNote),callback:function ($$v) {_vm.uploadingDeliveryNote=$$v},expression:"uploadingDeliveryNote"}},[_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('guide',{attrs:{"text":"Select all the items that you have confirmed have been delivered"}}),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"select-all":"","item-key":"id","hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected},on:{"click":function($event){props.selected = !props.selected}}},[_c('td',[_c('v-checkbox',{attrs:{"input-value":props.selected,"primary":"","hide-details":""}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.orderItem.product.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.orderItem.priceAtPurchase))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.orderItem.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney((props.item.orderItem.quantity *
                props.item.orderItem.priceAtPurchase)))+"\n              ")])])]}}]),model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}}),_vm._v(" "),_c('file-picker',{attrs:{"name":"deliveryNote","disabled":_vm.connecting || !_vm.selectedItems.length,"label":"Select Delivery Note File..."},on:{"onFilePicked":_vm.onDeliveryNotePicked}}),_vm._v(" "),_c('file-picker',{attrs:{"name":"invoice","disabled":_vm.connecting || !_vm.selectedItems.length,"label":"Select Invoice File..."},on:{"onFilePicked":_vm.onInvoicePicked}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.uploadingDeliveryNote = false}}},[_vm._v("Close\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || !_vm.selectedItems.length || !_vm.deliveryNoteFile || !_vm.invoiceFile},nativeOn:{"click":function($event){return _vm.uploadDeliveryNote($event)}}},[_vm._v("\n          Submit\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px","persistent":""},model:{value:(_vm.viewDocument),callback:function ($$v) {_vm.viewDocument=$$v},expression:"viewDocument"}},[(_vm.viewDocumentItem)?_c('v-card',[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.pageCount)+"\n\n        "),(_vm.documentLoadedProgress < 1 && !_vm.viewDocumentError)?_c('v-progress-linear',{attrs:{"width":3,"color":"green","indeterminate":""}}):_vm._e(),_vm._v(" "),(!_vm.viewDocumentError)?_c('pdf',{attrs:{"src":_vm.viewDocumentSrc},on:{"num-pages":function($event){_vm.pageCount = $event},"progress":function($event){_vm.documentLoadedProgress = $event},"error":function($event){_vm.viewDocumentError = $event},"page-loaded":function($event){_vm.currentPage = $event}}}):_vm._e(),_vm._v(" "),(_vm.viewDocumentError)?_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v("\n          Unable to load the document\n        ")]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},nativeOn:{"click":function($event){_vm.onCloseViewDocument()}}},[_vm._v("Close\n        ")]),_vm._v(" "),_c('v-spacer')],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Billing_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0534b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Billing_vue__ = __webpack_require__(814);
function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c0534b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0534b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-breadcrumbs',[_c('v-breadcrumbs-item',[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v("Billing")]),_vm._v(" "),_c('v-breadcrumbs-item',[_vm._v(_vm._s(_vm.$app.capitalizeFirstLetter(_vm.$route.params.filter)))])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),(_vm.filter)?_c('v-card',{staticClass:"pt-3"},[_c('v-toolbar',{attrs:{"color":"transparent","dense":"","flat":"","card":""}},[_c('v-text-field',{staticClass:"ml-5",attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","flat":"","outline":"","color":"primary"},slot:"activator"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("date_range")]),_vm._v("\n            "+_vm._s(_vm.month)+"\n          ")],1),_vm._v(" "),_c('v-date-picker',{attrs:{"type":"month","landscape":"","min":_vm.minMonth,"max":_vm.maxMonth},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","outline":"","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("file_download")]),_vm._v("\n          Download\n        ")],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","outline":"","color":"primary"},on:{"click":_vm.refresh}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("refresh")]),_vm._v("\n          Refresh\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{ref:"dataTable",attrs:{"headers":(_vm.isAdmin() || _vm.isOperations()) ? _vm.adminHeaders : _vm.clientHeaders,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),((_vm.isAdmin() || _vm.isOperations()))?_c('td',[_vm._v(_vm._s(props.item.client.name))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$app.formatMoney(props.item.amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.createdAt))])]}}])})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDelivery_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d2b950_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDelivery_vue__ = __webpack_require__(817);
function injectStyle (ssrContext) {
  __webpack_require__(816)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37d2b950"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDelivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d2b950_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDelivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-stepper',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.step > 1}},[_vm._v("\n            Pick up\n          ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.step > 2}},[_vm._v("\n            Items\n          ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.step > 3}},[_vm._v("\n            Schedule\n          ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4"}},[_vm._v("\n            Confirm Cost\n          ")])],1),_vm._v(" "),_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',[_c('v-card-text',[_c('google-place-input',{ref:"originInput",attrs:{"id":"origin","country":"KE","clearable":false,"courier":true,"disabled":_vm.connecting,"enable-geolocation":true,"label":"Enter pickup location","placeholder":"Pickup location","prepend-icon":"edit_location","required":true,"load-google-api":false,"value":_vm.originInput,"hint":_vm.originFormattedAddress,"persistent-hint":"","hide-details":false,"types":"[\"geocode\",]"},on:{"placechanged":_vm.onOriginEntered}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Enter address details","placeholder":"Address details E.g. Company Name, Floor name, Contact name, Contact phone","required":"","rules":[_vm.rules.required],"prepend-icon":"edit_location"},model:{value:(_vm.addressDetails),callback:function ($$v) {_vm.addressDetails=$$v},expression:"addressDetails"}}),_vm._v(" "),_c('guide',{attrs:{"text":"Please provide location where item or items will be collected"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.connecting && !_vm.courierOptions.length,"disabled":!_vm.originPosition || _vm.connecting || _vm.invalidForm},nativeOn:{"click":function($event){return _vm.goStepTwo($event)}}},[_vm._v("\n                  Continue\n                ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card-text',[_c('v-list',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height*0.40)+'px; '),attrs:{"two-line":""}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:index,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":_vm.$app.imageUrl(item.courierOption.icon)}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"body-2"},[_c('b',[_vm._v(_vm._s(item.quantity)+" -\n                          "+_vm._s((item.quantity === 1 ? item.courierOption.name:
                          item.courierOption.pluralName)))])]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text caption"},[_c('b',[_vm._v(" To: ")]),_vm._v(_vm._s(item.destinationName)+" -\n                        "+_vm._s(item.destinationFormattedAddress)+"\n                      ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","light":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.deleteItem(item, index)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),(index !== _vm.items.length - 1)?_c('v-divider',{key:index+_vm.items.length,attrs:{"inset":""}}):_vm._e()]})],2),_vm._v(" "),_c('add-delivery-item-dialog',{attrs:{"show":_vm.addingItem,"courierOptions":_vm.courierOptions},on:{"onAddItem":_vm.onAddItem,"onClose":function($event){_vm.addingItem = false}}}),_vm._v(" "),_c('v-btn',{attrs:{"block":"","loading":_vm.calculatingDirections,"flat":"","color":"primary","disabled":_vm.connecting || _vm.calculatingDirections},nativeOn:{"click":function($event){_vm.addingItem = true, _vm.isAnEdit = false}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add\n                ")]),_vm._v("\n                Add item\n                "),_c('span',{attrs:{"slot":"loader"},slot:"loader"},[_vm._v("Please wait...")])],1),_vm._v(" "),_c('guide',{attrs:{"text":"One/multiple packages with different/same destination"}})],1),_vm._v(" "),_c('v-card',[_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                  Back\n                ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting,"color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.items.length},nativeOn:{"click":function($event){_vm.step = 3}}},[_vm._v("\n                  Continue\n                ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('guide',{attrs:{"text":"We deliver from Monday to Friday between 8 a.m and 4 p.m. And on Saturdays between 8 a.m and 1 p.m"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","offset-xs2":""}},[_c('v-subheader',[_vm._v("Optional scheduling")]),_vm._v(" "),_c('date-input',{attrs:{"disabled":_vm.connecting,"default-value":_vm.currentDate,"placeholder":"Pick up date","allowedDates":_vm.allowedDates},model:{value:(_vm.scheduleDate),callback:function ($$v) {_vm.scheduleDate=$$v},expression:"scheduleDate"}}),_vm._v(" "),_c('time-input',{attrs:{"disabled":_vm.connecting,"default-value":_vm.currentTime,"placeholder":"pick up time","allowedTimes":_vm.allowedTimes},model:{value:(_vm.scheduleTime),callback:function ($$v) {_vm.scheduleTime=$$v},expression:"scheduleTime"}}),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.invalidTime}},[_c('p',[_vm._v(_vm._s(_vm.invalidTimeErrorMessage))])]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.invalidDate}},[_c('p',[_vm._v("Sorry we don't do deliveries of Sundays")])]),_vm._v(" "),_c('guide',{attrs:{"text":"Our rider will pickup your delivery at the earliest time possible"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 2}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                  Back\n                ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting,"color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting || _vm.invalidTime || _vm.invalidDate},nativeOn:{"click":function($event){_vm.step = 4}}},[_vm._v("\n                  Continue\n                ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":"","offset-xs2":""}},[_c('v-icon',{staticClass:"mb-3",attrs:{"x-large":""}},[_vm._v("\n                      account_balance_wallet\n                    ")]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","color":"primary","outline":"","large":"","flat":""}},[_vm._v("\n                      Total Cost Estimate: "),_c('b',[_vm._v(_vm._s(_vm.$app.formatMoney(_vm.estimatedCost)))])]),_vm._v(" "),_c('v-checkbox',{staticClass:"mt-3",attrs:{"disabled":_vm.connecting,"label":"This is an urgent delivery"},model:{value:(_vm.urgent),callback:function ($$v) {_vm.urgent=$$v},expression:"urgent"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){_vm.step = 3}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n                  Back\n                ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","disabled":_vm.connecting,"color":"red"},nativeOn:{"click":function($event){_vm.onClose(false)}}},[_vm._v("Cancel\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n                  Continue\n                ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryItems_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c89db62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryItems_vue__ = __webpack_require__(820);
function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c89db62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c89db62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('crud',{attrs:{"resource":"deliveryItems","manager":_vm.manager,"filters":_vm.filters,"custom-view-dialog":true,"creatable":false}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.viewDialogHere),callback:function ($$v) {_vm.viewDialogHere=$$v},expression:"viewDialogHere"}},[(_vm.item)?_c('v-card',[_c('v-card-text',[_c('connection-manager',{ref:"connectionManager",model:{value:(_vm.connecting),callback:function ($$v) {_vm.connecting=$$v},expression:"connecting"}}),_vm._v(" "),_c('v-data-table',{attrs:{"hide-headers":"","hide-actions":"","headers":_vm.viewItemHeaders,"items":_vm.viewableHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.text))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manager.toValue(props.item, _vm.item)))])]}}])}),_vm._v(" "),_c('v-data-table',{staticClass:"scroll-y",style:('max-height: '+(_vm.$vuetify.breakpoint.height * 0.30)+'px;'),attrs:{"items":_vm.item.stops,"hide-actions":"","item-key":"id","headers":_vm.itemHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.stopName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.stopVicinity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.stopFormattedAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.stopLatitude))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.stopLongitude))])]}}])})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"","disabled":_vm.connecting},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n          Close\n        ")]),_vm._v(" "),_c('v-spacer')],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 821 */,
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_cart__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_categories__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_charts__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_general__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger__);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: true,
  plugins: __WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */].isDebug ? [__WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default()()] : [],
  modules: {
    cart: __WEBPACK_IMPORTED_MODULE_3__modules_cart__["a" /* default */],
    categories: __WEBPACK_IMPORTED_MODULE_4__modules_categories__["a" /* default */],
    charts: __WEBPACK_IMPORTED_MODULE_5__modules_charts__["a" /* default */],
    general: __WEBPACK_IMPORTED_MODULE_6__modules_general__["a" /* default */]
  }
}));

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  added: [],
  checkoutStatus: null
};

var getters = {
  checkoutStatus: function checkoutStatus(state) {
    return state.checkoutStatus;
  },
  cartProducts: function cartProducts(state) {
    return state.added;
  },
  cartProductsTotal: function cartProductsTotal(state, getters) {
    return state.added.length;
  },
  cartTotal: function cartTotal(state, getters) {
    return getters.cartProducts.reduce(function (total, cartProduct) {
      return total + cartProduct.product.price * cartProduct.quantity;
    }, 0);
  }

  // actions
};var actions = {
  checkout: function checkout(_ref, products) {
    var commit = _ref.commit,
        state = _ref.state;

    // const savedCartItems = [...state.added]
    commit('setCheckoutStatus', null);
    // empty cart
    commit('setCartItems', { items: [] });
    /* shop.buyProducts(
      products,
      () => commit('setCheckoutStatus', 'successful'),
      () => {
        commit('setCheckoutStatus', 'failed')
        // rollback to the cart saved before sending the request
        commit('setCartItems', {items: savedCartItems})
      }
    ) */
  },
  addProductToCart: function addProductToCart(_ref2, payLoad) {
    var state = _ref2.state,
        commit = _ref2.commit;

    // console.info('addProductToCart')
    // console.info(payLoad.product)
    // console.info(payLoad.quantity)
    commit('setCheckoutStatus', null);
    var cartItem = state.added.find(function (item) {
      return item.product.id === payLoad.product.id;
    });
    if (!cartItem) {
      commit('pushProductToCart', payLoad);
    } else {
      commit('incrementItemQuantity', payLoad);
    }
    console.info('incrementProductQuantityInCart');
    // Increment the number of items in cart for the product
    commit('incrementProductQuantityInCart', payLoad);
    // remove 1 item from stock
    // commit('decrementProductInventory', {id: product.id})
  },
  removeProductFromCart: function removeProductFromCart(_ref3, payLoad) {
    var state = _ref3.state,
        commit = _ref3.commit;

    commit('removeProduct', payLoad);
    // We remove the product quantity in cart when it is removed
    commit('clearProductQuantityInCart', payLoad);
  },
  removeAllProductsFromCart: function removeAllProductsFromCart(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit;

    commit('clearCart');
    commit('clearAllProductsQuantityInCart');
  }
};

// mutations
var mutations = {
  clearCart: function clearCart(state) {
    state.added = [];
  },
  removeProduct: function removeProduct(state, payLoad) {
    // console.info('removeProductFromCart')
    var cartItem = state.added.find(function (item) {
      return item.product.id === payLoad.product.id;
    });
    // const index = state.added.indexOf(cartItem);
    if (cartItem) {
      state.added.splice(cartItem, 1);
    }
  },
  pushProductToCart: function pushProductToCart(state, payLoad) {
    state.added.push({
      product: payLoad.product,
      quantity: payLoad.quantity
    });
  },
  incrementItemQuantity: function incrementItemQuantity(state, payLoad) {
    var cartItem = state.added.find(function (item) {
      return item.product.id === payLoad.product.id;
    });
    cartItem.quantity += payLoad.quantity;
  },
  setCartItems: function setCartItems(state, _ref5) {
    var items = _ref5.items;

    state.added = items;
  },
  setCheckoutStatus: function setCheckoutStatus(state, status) {
    state.checkoutStatus = status;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(127);


// initial state
var state = {
  all: []

  // getters
};var getters = {
  allCategories: function allCategories(state) {
    return state.all;
  },
  getProductCategory: function getProductCategory(state) {
    return function (id) {
      return state.all.find(function (item) {
        return item.id === id;
      });
    };
  }

  // actions
};var actions = {
  getAllCategories: function getAllCategories(_ref) {
    var commit = _ref.commit;

    console.info('getAllCategories');
    if (!state.all.length) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('categories', function (categories) {
        console.info('Got all categories');
        console.info(categories);
        commit('setCategories', categories);
      });
    }
  }
};

// mutations
var mutations = {
  setCategories: function setCategories(state, categories) {
    state.all = categories;
  },
  incrementProductQuantityInCart: function incrementProductQuantityInCart(state, payLoad) {
    // for some reasons payLoad.product.categoryId is a string hence parseInt
    var category = state.all.find(function (item) {
      return item.id === parseInt(payLoad.product.categoryId);
    });
    if (category) {
      var product = category.products.find(function (product) {
        return product.id === payLoad.product.id;
      });
      if (!product.quantityInCart) {
        product.quantityInCart = payLoad.quantity;
      } else {
        product.quantityInCart += payLoad.quantity;
      }
    }
  },
  clearProductQuantityInCart: function clearProductQuantityInCart(state, payLoad) {
    // console.info('clearProductQuantityInCart')
    var categoriesCopy = state.all;
    var category = categoriesCopy.find(function (category) {
      return category.id === payLoad.product.categoryId;
    });
    var product = category.products.find(function (product) {
      return product.id === payLoad.product.id;
    });
    product.quantityInCart = 0;
    state.all = [];
    state.all = state.all.concat(categoriesCopy);
  },
  clearAllProductsQuantityInCart: function clearAllProductsQuantityInCart(state) {
    var categoriesCopy = state.all;
    categoriesCopy.forEach(function (category) {
      category.products.forEach(function (product) {
        product.quantityInCart = 0;
      });
    });
    state.all = [];
    state.all = state.all.concat(categoriesCopy);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(127);


// initial state
var state = {
  data: null,
  allBills: null,
  serviceBills: null,
  shoppingBills: null,
  deliveryBills: null,
  subscriptionBills: null

  // getters
};var getters = {
  getDataByFilter: function getDataByFilter(state) {
    return function (filter) {
      switch (filter) {
        case 'allBills':
          return state.allBills;
        case 'serviceBills':
          return state.serviceBills;
        case 'shoppingBills':
          return state.shoppingBills;
        case 'deliveryBills':
          return state.deliveryBills;
        case 'subscriptionBills':
          return state.subscriptionBills;
        default:
          return state.data;
      }
    };
  }

  // actions
};var actions = {
  loadData: function loadData(_ref, filter) {
    var state = _ref.state,
        dispatch = _ref.dispatch,
        getters = _ref.getters;

    var data = getters['getDataByFilter'](filter);
    if (!data) {
      dispatch('refreshData', filter);
    }
  },
  refreshData: function refreshData(_ref2, filter) {
    var state = _ref2.state,
        commit = _ref2.commit,
        rootState = _ref2.rootState;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('charts/' + filter, function (data) {
      console.log(data);
      commit('setData', { data: data, filter: filter });
    });
  }
};

// mutations
var mutations = {
  setData: function setData(state, payload) {
    switch (payload.filter) {
      case 'allBills':
        state.allBills = payload.data;
        break;
      case 'serviceBills':
        state.serviceBills = payload.data;
        break;
      case 'shoppingBills':
        state.shoppingBills = payload.data;
        break;
      case 'deliveryBills':
        state.deliveryBills = payload.data;
        break;
      case 'subscriptionBills':
        state.subscriptionBills = payload.data;
        break;
      default:
        state.data = payload.data;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(127);


// initial state
var state = {
  selectedItem: {}

  // getters
};var getters = {
  getSelectedItem: function getSelectedItem(state) {
    return state.selectedItem;
  }

  // actions
};var actions = {
  getAllOrders: function getAllOrders(_ref) {
    var commit = _ref.commit;

    if (!state.all.length) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('orders', function (orders) {
        commit('setOrders', orders);
      });
    }
  }
};

// mutations
var mutations = {
  setSelectedItem: function setSelectedItem(state, payLoad) {
    state.selectedItem = payLoad;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff08b0c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__(862);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff08b0c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 860 */,
/* 861 */,
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[394]);


// WEBPACK FOOTER //
// static/js/app.5ab13907244fea69bfb9.js